!(function webpackUniversalModuleDefinition(e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define([], t)
    : 'object' == typeof exports
    ? (exports.bulmaCalendar = t())
    : (e.bulmaCalendar = t())
})('undefined' != typeof self ? self : this, function () {
  return (function (n) {
    var o = {}
    function __webpack_require__(e) {
      if (o[e]) return o[e].exports
      var t = (o[e] = { i: e, l: !1, exports: {} })
      return (
        n[e].call(t.exports, t, t.exports, __webpack_require__),
        (t.l = !0),
        t.exports
      )
    }
    return (
      (__webpack_require__.m = n),
      (__webpack_require__.c = o),
      (__webpack_require__.d = function (e, t, n) {
        __webpack_require__.o(e, t) ||
          Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: n,
          })
      }),
      (__webpack_require__.n = function (e) {
        var t =
          e && e.__esModule
            ? function getDefault() {
                return e.default
              }
            : function getModuleExports() {
                return e
              }
        return __webpack_require__.d(t, 'a', t), t
      }),
      (__webpack_require__.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
      }),
      (__webpack_require__.p = ''),
      __webpack_require__((__webpack_require__.s = 232))
    )
  })([
    function (e, t, n) {
      var d = n(120),
        l = 36e5,
        f = 6e4,
        h = /[T ]/,
        m = /:/,
        p = /^(\d{2})$/,
        v = [/^([+-]\d{2})$/, /^([+-]\d{3})$/, /^([+-]\d{4})$/],
        g = /^(\d{4})/,
        b = [/^([+-]\d{4})/, /^([+-]\d{5})/, /^([+-]\d{6})/],
        _ = /^-(\d{2})$/,
        M = /^-?(\d{3})$/,
        k = /^-?(\d{2})-?(\d{2})$/,
        y = /^-?W(\d{2})$/,
        x = /^-?W(\d{2})-?(\d{1})$/,
        D = /^(\d{2}([.,]\d*)?)$/,
        w = /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        j = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        T = /([Z+-].*)$/,
        S = /^(Z)$/,
        P = /^([+-])(\d{2})$/,
        H = /^([+-])(\d{2}):?(\d{2})$/
      function dayOfISOYear(e, t, n) {
        ;(t = t || 0), (n = n || 0)
        var o = new Date(0)
        o.setUTCFullYear(e, 0, 4)
        var i = 7 * t + n + 1 - (o.getUTCDay() || 7)
        return o.setUTCDate(o.getUTCDate() + i), o
      }
      e.exports = function parse(e, t) {
        if (d(e)) return new Date(e.getTime())
        if ('string' != typeof e) return new Date(e)
        var n = (t || {}).additionalDigits
        n = null == n ? 2 : Number(n)
        var o = (function splitDateString(e) {
            var t,
              n = {},
              o = e.split(h)
            if (
              (t = m.test(o[0])
                ? ((n.date = null), o[0])
                : ((n.date = o[0]), o[1]))
            ) {
              var i = T.exec(t)
              i
                ? ((n.time = t.replace(i[1], '')), (n.timezone = i[1]))
                : (n.time = t)
            }
            return n
          })(e),
          i = (function parseYear(e, t) {
            var n,
              o = v[t],
              i = b[t]
            if ((n = g.exec(e) || i.exec(e))) {
              var r = n[1]
              return {
                year: parseInt(r, 10),
                restDateString: e.slice(r.length),
              }
            }
            if ((n = p.exec(e) || o.exec(e))) {
              var a = n[1]
              return {
                year: 100 * parseInt(a, 10),
                restDateString: e.slice(a.length),
              }
            }
            return { year: null }
          })(o.date, n),
          r = i.year,
          a = (function parseDate(e, t) {
            if (null === t) return null
            var n, o, i, r
            if (0 === e.length) return (o = new Date(0)).setUTCFullYear(t), o
            if ((n = _.exec(e)))
              return (
                (o = new Date(0)),
                (i = parseInt(n[1], 10) - 1),
                o.setUTCFullYear(t, i),
                o
              )
            if ((n = M.exec(e))) {
              o = new Date(0)
              var a = parseInt(n[1], 10)
              return o.setUTCFullYear(t, 0, a), o
            }
            if ((n = k.exec(e))) {
              ;(o = new Date(0)), (i = parseInt(n[1], 10) - 1)
              var s = parseInt(n[2], 10)
              return o.setUTCFullYear(t, i, s), o
            }
            if ((n = y.exec(e)))
              return (r = parseInt(n[1], 10) - 1), dayOfISOYear(t, r)
            if ((n = x.exec(e))) {
              r = parseInt(n[1], 10) - 1
              var u = parseInt(n[2], 10) - 1
              return dayOfISOYear(t, r, u)
            }
            return null
          })(i.restDateString, r)
        if (a) {
          var s,
            u = a.getTime(),
            c = 0
          return (
            o.time &&
              (c = (function parseTime(e) {
                var t, n, o
                if ((t = D.exec(e)))
                  return ((n = parseFloat(t[1].replace(',', '.'))) % 24) * l
                if ((t = w.exec(e)))
                  return (
                    (n = parseInt(t[1], 10)),
                    (o = parseFloat(t[2].replace(',', '.'))),
                    (n % 24) * l + o * f
                  )
                if ((t = j.exec(e))) {
                  ;(n = parseInt(t[1], 10)), (o = parseInt(t[2], 10))
                  var i = parseFloat(t[3].replace(',', '.'))
                  return (n % 24) * l + o * f + 1e3 * i
                }
                return null
              })(o.time)),
            (s = o.timezone
              ? (function parseTimezone(e) {
                  var t, n
                  return (t = S.exec(e))
                    ? 0
                    : (t = P.exec(e))
                    ? ((n = 60 * parseInt(t[2], 10)), '+' === t[1] ? -n : n)
                    : (t = H.exec(e))
                    ? ((n = 60 * parseInt(t[2], 10) + parseInt(t[3], 10)),
                      '+' === t[1] ? -n : n)
                    : 0
                })(o.timezone)
              : ((s = new Date(u + c).getTimezoneOffset()),
                new Date(u + c + s * f).getTimezoneOffset())),
            new Date(u + c + s * f)
          )
        }
        return new Date(e)
      }
    },
    function (e, n, o) {
      var i
      !(function (t) {
        'use strict'
        var b = {},
          _ = 'en',
          M = {
            en: {
              MMMM: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
              ],
              MMM: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
              ],
              dddd: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
              ],
              ddd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              dd: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
              A: ['a.m.', 'p.m.'],
              formatter: {
                YYYY: function (e) {
                  return ('000' + e.getFullYear()).slice(-4)
                },
                YY: function (e) {
                  return ('0' + e.getFullYear()).slice(-2)
                },
                Y: function (e) {
                  return '' + e.getFullYear()
                },
                MMMM: function (e) {
                  return this.MMMM[e.getMonth()]
                },
                MMM: function (e) {
                  return this.MMM[e.getMonth()]
                },
                MM: function (e) {
                  return ('0' + (e.getMonth() + 1)).slice(-2)
                },
                M: function (e) {
                  return '' + (e.getMonth() + 1)
                },
                DD: function (e) {
                  return ('0' + e.getDate()).slice(-2)
                },
                D: function (e) {
                  return '' + e.getDate()
                },
                HH: function (e) {
                  return ('0' + e.getHours()).slice(-2)
                },
                H: function (e) {
                  return '' + e.getHours()
                },
                A: function (e) {
                  return this.A[(11 < e.getHours()) | 0]
                },
                hh: function (e) {
                  return ('0' + (e.getHours() % 12 || 12)).slice(-2)
                },
                h: function (e) {
                  return '' + (e.getHours() % 12 || 12)
                },
                mm: function (e) {
                  return ('0' + e.getMinutes()).slice(-2)
                },
                m: function (e) {
                  return '' + e.getMinutes()
                },
                ss: function (e) {
                  return ('0' + e.getSeconds()).slice(-2)
                },
                s: function (e) {
                  return '' + e.getSeconds()
                },
                SSS: function (e) {
                  return ('00' + e.getMilliseconds()).slice(-3)
                },
                SS: function (e) {
                  return ('0' + ((e.getMilliseconds() / 10) | 0)).slice(-2)
                },
                S: function (e) {
                  return '' + ((e.getMilliseconds() / 100) | 0)
                },
                dddd: function (e) {
                  return this.dddd[e.getDay()]
                },
                ddd: function (e) {
                  return this.ddd[e.getDay()]
                },
                dd: function (e) {
                  return this.dd[e.getDay()]
                },
                Z: function (e) {
                  var t = e.utc ? 0 : e.getTimezoneOffset() / 0.6
                  return (
                    (0 < t ? '-' : '+') +
                    ('000' + Math.abs(t - (t % 100) * 0.4)).slice(-4)
                  )
                },
                post: function (e) {
                  return e
                },
              },
              parser: {
                find: function (e, t) {
                  for (var n, o = -1, i = 0, r = 0, a = e.length; r < a; r++)
                    (n = e[r]),
                      !t.indexOf(n) && n.length > i && ((o = r), (i = n.length))
                  return { index: o, length: i }
                },
                MMMM: function (e) {
                  return this.parser.find(this.MMMM, e)
                },
                MMM: function (e) {
                  return this.parser.find(this.MMM, e)
                },
                A: function (e) {
                  return this.parser.find(this.A, e)
                },
                h: function (e, t) {
                  return (12 === e ? 0 : e) + 12 * t
                },
                pre: function (e) {
                  return e
                },
              },
            },
          }
        ;(b.format = function (e, n, t) {
          var o = b.addMinutes(e, t ? e.getTimezoneOffset() : 0),
            i = M[_],
            r = i.formatter
          return (
            (o.utc = t),
            n.replace(
              /(\[[^\[\]]*]|\[.*\][^\[]*\]|YYYY|YY|MMM?M?|DD|HH|hh|mm|ss|SSS?|ddd?d?|.)/g,
              function (e) {
                var t = r[e]
                return t ? r.post(t.call(i, o, n)) : e.replace(/\[(.*)]/, '$1')
              },
            )
          )
        }),
          (b.parse = function (e, t, n) {
            for (
              var o,
                i,
                r,
                a,
                s,
                u,
                c,
                d,
                l = M[_],
                f = l.parser.pre(e),
                h = 0,
                m =
                  /(MMMM?|A)|(YYYY)|(SSS)|(MM|DD|HH|hh|mm|ss)|(YY|M|D|H|h|m|s|SS)|(S)|(.)/g,
                p = {
                  2: /^\d{1,4}/,
                  3: /^\d{1,3}/,
                  4: /^\d\d/,
                  5: /^\d\d?/,
                  6: /^\d/,
                },
                v = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
                g = { Y: 1970, M: 1, D: 1, H: 0, m: 0, s: 0, S: 0 };
              (o = m.exec(t));

            ) {
              for (i = 0, a = 1, r = ''; !r; ) r = o[++i]
              if (((s = r.charAt(0)), (u = f.slice(h)), i < 2))
                (c = l.parser[r].call(l, u, t)),
                  (g[s] = c.index),
                  'M' === s && g[s]++,
                  (a = c.length)
              else if (i < 7)
                (c = (u.match(p[i]) || [''])[0]),
                  (g[s] =
                    0 | ('S' === s ? (c + '000').slice(0, -r.length) : c)),
                  (a = c.length)
              else if (' ' !== s && s !== u[0]) return NaN
              if (!a) return NaN
              h += a
            }
            return h === f.length && c
              ? ((g.Y += g.Y < 70 ? 2e3 : g.Y < 100 ? 1900 : 0),
                (g.H = g.H || l.parser.h(g.h || 0, g.A || 0)),
                (d = new Date(g.Y, g.M - 1, g.D, g.H, g.m, g.s, g.S)),
                (v[1] += 0 | b.isLeapYear(d)),
                g.M < 1 ||
                12 < g.M ||
                g.D < 1 ||
                g.D > v[g.M - 1] ||
                23 < g.H ||
                59 < g.m ||
                59 < g.s
                  ? NaN
                  : n
                  ? b.addMinutes(d, -d.getTimezoneOffset())
                  : d)
              : NaN
          }),
          (b.isValid = function (e, t) {
            return !!b.parse(e, t)
          }),
          (b.addYears = function (e, t) {
            return b.addMonths(e, 12 * t)
          }),
          (b.addMonths = function (e, t) {
            var n = new Date(e.getTime())
            return n.setMonth(n.getMonth() + t), n
          }),
          (b.addDays = function (e, t) {
            var n = new Date(e.getTime())
            return n.setDate(n.getDate() + t), n
          }),
          (b.addHours = function (e, t) {
            return b.addMilliseconds(e, 36e5 * t)
          }),
          (b.addMinutes = function (e, t) {
            return b.addMilliseconds(e, 6e4 * t)
          }),
          (b.addSeconds = function (e, t) {
            return b.addMilliseconds(e, 1e3 * t)
          }),
          (b.addMilliseconds = function (e, t) {
            return new Date(e.getTime() + t)
          }),
          (b.subtract = function (e, t) {
            var n = e.getTime() - t.getTime()
            return {
              toMilliseconds: function () {
                return n
              },
              toSeconds: function () {
                return (n / 1e3) | 0
              },
              toMinutes: function () {
                return (n / 6e4) | 0
              },
              toHours: function () {
                return (n / 36e5) | 0
              },
              toDays: function () {
                return (n / 864e5) | 0
              },
            }
          }),
          (b.isLeapYear = function (e) {
            var t = e.getFullYear()
            return !((t % 4 || !(t % 100)) && t % 400)
          }),
          (b.isSameDay = function (e, t) {
            return b.format(e, 'YYYYMMDD') === b.format(t, 'YYYYMMDD')
          }),
          (b.locale = function (e) {
            return e && (!M[e] && t && o(331)('./' + e), (_ = e)), _
          }),
          (b.getLocales = function (e) {
            return M[e || _]
          }),
          (b.setLocales = function (e, t) {
            var n = function (e, t) {
                var n,
                  o,
                  i = function () {}
                for (o in ((i.prototype = t), (n = new i()), e))
                  e.hasOwnProperty(o) && (n[o] = e[o])
                return n
              },
              o = M[e] || M.en,
              i = n(t, o)
            t.formatter && (i.formatter = n(t.formatter, o.formatter)),
              t.parser && (i.parser = n(t.parser, o.parser)),
              (M[e] = i)
          }),
          'object' == typeof e && 'object' == typeof e.exports
            ? (e.exports = b)
            : void 0 ===
                (i = function () {
                  return b
                }.apply(n, [])) || (e.exports = i)
      })(this)
    },
    function (e, t) {
      var i = [
        'M',
        'MM',
        'Q',
        'D',
        'DD',
        'DDD',
        'DDDD',
        'd',
        'E',
        'W',
        'WW',
        'YY',
        'YYYY',
        'GG',
        'GGGG',
        'H',
        'HH',
        'h',
        'hh',
        'm',
        'mm',
        's',
        'ss',
        'S',
        'SS',
        'SSS',
        'Z',
        'ZZ',
        'X',
        'x',
      ]
      e.exports = function buildFormattingTokensRegExp(e) {
        var t = []
        for (var n in e) e.hasOwnProperty(n) && t.push(n)
        var o = i.concat(t).sort().reverse()
        return new RegExp('(\\[[^\\[]*\\])|(\\\\)?(' + o.join('|') + '|.)', 'g')
      }
    },
    function (e, t, n) {
      var s = n(0),
        u = n(4)
      e.exports = function getISOYear(e) {
        var t = s(e),
          n = t.getFullYear(),
          o = new Date(0)
        o.setFullYear(n + 1, 0, 4), o.setHours(0, 0, 0, 0)
        var i = u(o),
          r = new Date(0)
        r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0)
        var a = u(r)
        return t.getTime() >= i.getTime()
          ? n + 1
          : t.getTime() >= a.getTime()
          ? n
          : n - 1
      }
    },
    function (e, t, n) {
      var o = n(80)
      e.exports = function startOfISOWeek(e) {
        return o(e, { weekStartsOn: 1 })
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function startOfDay(e) {
        var t = o(e)
        return t.setHours(0, 0, 0, 0), t
      }
    },
    function (e, t, n) {
      var o = n(12),
        i = n(13)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      e.exports = {
        addDays: n(8),
        addHours: n(130),
        addISOYears: n(131),
        addMilliseconds: n(9),
        addMinutes: n(133),
        addMonths: n(82),
        addQuarters: n(134),
        addSeconds: n(135),
        addWeeks: n(122),
        addYears: n(136),
        areRangesOverlapping: n(233),
        closestIndexTo: n(234),
        closestTo: n(235),
        compareAsc: n(11),
        compareDesc: n(123),
        differenceInCalendarDays: n(81),
        differenceInCalendarISOWeeks: n(236),
        differenceInCalendarISOYears: n(137),
        differenceInCalendarMonths: n(138),
        differenceInCalendarQuarters: n(237),
        differenceInCalendarWeeks: n(238),
        differenceInCalendarYears: n(140),
        differenceInDays: n(141),
        differenceInHours: n(239),
        differenceInISOYears: n(240),
        differenceInMilliseconds: n(83),
        differenceInMinutes: n(241),
        differenceInMonths: n(124),
        differenceInQuarters: n(242),
        differenceInSeconds: n(125),
        differenceInWeeks: n(243),
        differenceInYears: n(244),
        distanceInWords: n(143),
        distanceInWordsStrict: n(245),
        distanceInWordsToNow: n(246),
        eachDay: n(247),
        endOfDay: n(126),
        endOfHour: n(248),
        endOfISOWeek: n(249),
        endOfISOYear: n(250),
        endOfMinute: n(251),
        endOfMonth: n(145),
        endOfQuarter: n(252),
        endOfSecond: n(253),
        endOfToday: n(254),
        endOfTomorrow: n(255),
        endOfWeek: n(144),
        endOfYear: n(256),
        endOfYesterday: n(257),
        format: n(258),
        getDate: n(259),
        getDay: n(260),
        getDayOfYear: n(146),
        getDaysInMonth: n(121),
        getDaysInYear: n(261),
        getHours: n(262),
        getISODay: n(150),
        getISOWeek: n(127),
        getISOWeeksInYear: n(263),
        getISOYear: n(3),
        getMilliseconds: n(264),
        getMinutes: n(265),
        getMonth: n(266),
        getOverlappingDaysInRanges: n(267),
        getQuarter: n(139),
        getSeconds: n(268),
        getTime: n(269),
        getYear: n(270),
        isAfter: n(271),
        isBefore: n(272),
        isDate: n(120),
        isEqual: n(273),
        isFirstDayOfMonth: n(274),
        isFriday: n(275),
        isFuture: n(276),
        isLastDayOfMonth: n(277),
        isLeapYear: n(149),
        isMonday: n(278),
        isPast: n(279),
        isSameDay: n(280),
        isSameHour: n(151),
        isSameISOWeek: n(153),
        isSameISOYear: n(154),
        isSameMinute: n(155),
        isSameMonth: n(157),
        isSameQuarter: n(158),
        isSameSecond: n(160),
        isSameWeek: n(128),
        isSameYear: n(162),
        isSaturday: n(281),
        isSunday: n(282),
        isThisHour: n(283),
        isThisISOWeek: n(284),
        isThisISOYear: n(285),
        isThisMinute: n(286),
        isThisMonth: n(287),
        isThisQuarter: n(288),
        isThisSecond: n(289),
        isThisWeek: n(290),
        isThisYear: n(291),
        isThursday: n(292),
        isToday: n(293),
        isTomorrow: n(294),
        isTuesday: n(295),
        isValid: n(148),
        isWednesday: n(296),
        isWeekend: n(297),
        isWithinRange: n(298),
        isYesterday: n(299),
        lastDayOfISOWeek: n(300),
        lastDayOfISOYear: n(301),
        lastDayOfMonth: n(302),
        lastDayOfQuarter: n(303),
        lastDayOfWeek: n(163),
        lastDayOfYear: n(304),
        max: n(305),
        min: n(306),
        parse: n(0),
        setDate: n(307),
        setDay: n(308),
        setDayOfYear: n(309),
        setHours: n(310),
        setISODay: n(311),
        setISOWeek: n(312),
        setISOYear: n(132),
        setMilliseconds: n(313),
        setMinutes: n(314),
        setMonth: n(164),
        setQuarter: n(315),
        setSeconds: n(316),
        setYear: n(317),
        startOfDay: n(5),
        startOfHour: n(152),
        startOfISOWeek: n(4),
        startOfISOYear: n(10),
        startOfMinute: n(156),
        startOfMonth: n(318),
        startOfQuarter: n(159),
        startOfSecond: n(161),
        startOfToday: n(319),
        startOfTomorrow: n(320),
        startOfWeek: n(80),
        startOfYear: n(147),
        startOfYesterday: n(321),
        subDays: n(322),
        subHours: n(323),
        subISOYears: n(142),
        subMilliseconds: n(324),
        subMinutes: n(325),
        subMonths: n(326),
        subQuarters: n(327),
        subSeconds: n(328),
        subWeeks: n(329),
        subYears: n(330),
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function addDays(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setDate(n.getDate() + o), n
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function addMilliseconds(e, t) {
        var n = i(e).getTime(),
          o = Number(t)
        return new Date(n + o)
      }
    },
    function (e, t, n) {
      var o = n(3),
        i = n(4)
      e.exports = function startOfISOYear(e) {
        var t = o(e),
          n = new Date(0)
        return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), i(n)
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function compareAsc(e, t) {
        var n = i(e).getTime(),
          o = i(t).getTime()
        return n < o ? -1 : o < n ? 1 : 0
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds',
          },
          xSeconds: { one: '1 second', other: '{{count}} seconds' },
          halfAMinute: 'half a minute',
          lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes',
          },
          xMinutes: { one: '1 minute', other: '{{count}} minutes' },
          aboutXHours: { one: 'about 1 hour', other: 'about {{count}} hours' },
          xHours: { one: '1 hour', other: '{{count}} hours' },
          xDays: { one: '1 day', other: '{{count}} days' },
          aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months',
          },
          xMonths: { one: '1 month', other: '{{count}} months' },
          aboutXYears: { one: 'about 1 year', other: 'about {{count}} years' },
          xYears: { one: '1 year', other: '{{count}} years' },
          overXYears: { one: 'over 1 year', other: 'over {{count}} years' },
          almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'in ' + o : o + ' ago') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec',
          ],
          n = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
          o = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          i = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          r = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                var t = e % 100
                if (20 < t || t < 10)
                  switch (t % 10) {
                    case 1:
                      return e + 'st'
                    case 2:
                      return e + 'nd'
                    case 3:
                      return e + 'rd'
                  }
                return e + 'th'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'أقل من ثانية واحدة',
            other: 'أقل من {{count}} ثواني',
          },
          xSeconds: { one: 'ثانية واحدة', other: '{{count}} ثواني' },
          halfAMinute: 'نصف دقيقة',
          lessThanXMinutes: {
            one: 'أقل من دقيقة',
            other: 'أقل من {{count}} دقيقة',
          },
          xMinutes: { one: 'دقيقة واحدة', other: '{{count}} دقائق' },
          aboutXHours: {
            one: 'ساعة واحدة تقريباً',
            other: '{{count}} ساعات تقريباً',
          },
          xHours: { one: 'ساعة واحدة', other: '{{count}} ساعات' },
          xDays: { one: 'يوم واحد', other: '{{count}} أيام' },
          aboutXMonths: {
            one: 'شهر واحد تقريباً',
            other: '{{count}} أشهر تقريباً',
          },
          xMonths: { one: 'شهر واحد', other: '{{count}} أشهر' },
          aboutXYears: {
            one: 'عام واحد تقريباً',
            other: '{{count}} أعوام تقريباً',
          },
          xYears: { one: 'عام واحد', other: '{{count}} أعوام' },
          overXYears: { one: 'أكثر من عام', other: 'أكثر من {{count}} أعوام' },
          almostXYears: {
            one: 'عام واحد تقريباً',
            other: '{{count}} أعوام تقريباً',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'في خلال ' + o : 'منذ ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ],
          n = [
            'كانون الثاني يناير',
            'شباط فبراير',
            'آذار مارس',
            'نيسان أبريل',
            'أيار مايو',
            'حزيران يونيو',
            'تموز يوليو',
            'آب أغسطس',
            'أيلول سبتمبر',
            'تشرين الأول أكتوبر',
            'تشرين الثاني نوفمبر',
            'كانون الأول ديسمبر',
          ],
          o = ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
          i = ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
          r = [
            'الأحد',
            'الإثنين',
            'الثلاثاء',
            'الأربعاء',
            'الخميس',
            'الجمعة',
            'السبت',
          ],
          a = ['صباح', 'مساء'],
          s = ['ص', 'م'],
          u = ['صباحاً', 'مساءاً'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return String(e)
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'по-малко от секунда',
            other: 'по-малко от {{count}} секунди',
          },
          xSeconds: { one: '1 секунда', other: '{{count}} секунди' },
          halfAMinute: 'половин минута',
          lessThanXMinutes: {
            one: 'по-малко от минута',
            other: 'по-малко от {{count}} минути',
          },
          xMinutes: { one: '1 минута', other: '{{count}} минути' },
          aboutXHours: { one: 'около час', other: 'около {{count}} часа' },
          xHours: { one: '1 час', other: '{{count}} часа' },
          xDays: { one: '1 ден', other: '{{count}} дни' },
          aboutXMonths: { one: 'около месец', other: 'около {{count}} месеца' },
          xMonths: { one: '1 месец', other: '{{count}} месеца' },
          aboutXYears: { one: 'около година', other: 'около {{count}} години' },
          xYears: { one: '1 година', other: '{{count}} години' },
          overXYears: { one: 'над година', other: 'над {{count}} години' },
          almostXYears: {
            one: 'почти година',
            other: 'почти {{count}} години',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'след ' + o : 'преди ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var u = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'яну',
            'фев',
            'мар',
            'апр',
            'май',
            'юни',
            'юли',
            'авг',
            'сеп',
            'окт',
            'ное',
            'дек',
          ],
          n = [
            'януари',
            'февруари',
            'март',
            'април',
            'май',
            'юни',
            'юли',
            'август',
            'септември',
            'октомври',
            'ноември',
            'декември',
          ],
          o = ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
          i = ['нед', 'пон', 'вто', 'сря', 'чет', 'пет', 'съб'],
          r = [
            'неделя',
            'понеделник',
            'вторник',
            'сряда',
            'четвъртък',
            'петък',
            'събота',
          ],
          a = ['сутринта', 'на обяд', 'следобед', 'вечерта'],
          e = function (e) {
            var t = e.getHours()
            return 4 <= t && t < 12
              ? a[0]
              : 12 <= t && t < 14
              ? a[1]
              : 14 <= t && t < 17
              ? a[2]
              : a[3]
          },
          s = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: e,
            a: e,
            aa: e,
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            s[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                var t = e % 100
                if (20 < t || t < 10)
                  switch (t % 10) {
                    case 1:
                      return e + '-ви'
                    case 2:
                      return e + '-ри'
                  }
                return e + '-и'
              })(t[n](e))
            }
          }),
          { formatters: s, formattingTokensRegExp: u(s) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: "menys d'un segon",
            other: 'menys de {{count}} segons',
          },
          xSeconds: { one: '1 segon', other: '{{count}} segons' },
          halfAMinute: 'mig minut',
          lessThanXMinutes: {
            one: "menys d'un minut",
            other: 'menys de {{count}} minuts',
          },
          xMinutes: { one: '1 minut', other: '{{count}} minuts' },
          aboutXHours: {
            one: 'aproximadament una hora',
            other: 'aproximadament {{count}} hores',
          },
          xHours: { one: '1 hora', other: '{{count}} hores' },
          xDays: { one: '1 dia', other: '{{count}} dies' },
          aboutXMonths: {
            one: 'aproximadament un mes',
            other: 'aproximadament {{count}} mesos',
          },
          xMonths: { one: '1 mes', other: '{{count}} mesos' },
          aboutXYears: {
            one: 'aproximadament un any',
            other: 'aproximadament {{count}} anys',
          },
          xYears: { one: '1 any', other: '{{count}} anys' },
          overXYears: { one: "més d'un any", other: 'més de {{count}} anys' },
          almostXYears: {
            one: 'gairebé un any',
            other: 'gairebé {{count}} anys',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'en ' + o : 'fa ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'gen',
            'feb',
            'mar',
            'abr',
            'mai',
            'jun',
            'jul',
            'ago',
            'set',
            'oct',
            'nov',
            'des',
          ],
          n = [
            'gener',
            'febrer',
            'març',
            'abril',
            'maig',
            'juny',
            'juliol',
            'agost',
            'setembre',
            'octobre',
            'novembre',
            'desembre',
          ],
          o = ['dg', 'dl', 'dt', 'dc', 'dj', 'dv', 'ds'],
          i = ['dge', 'dls', 'dts', 'dcs', 'djs', 'dvs', 'dss'],
          r = [
            'diumenge',
            'dilluns',
            'dimarts',
            'dimecres',
            'dijous',
            'divendres',
            'dissabte',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                switch (e) {
                  case 1:
                    return '1r'
                  case 2:
                    return '2n'
                  case 3:
                    return '3r'
                  case 4:
                    return '4t'
                  default:
                    return e + 'è'
                }
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      function declension(e, t, n) {
        var o = (function declensionGroup(e, t) {
          return 1 === t ? e.one : 2 <= t && t <= 4 ? e.twoFour : e.other
        })(e, t)
        return (o[n] || o).replace('{{count}}', t)
      }
      function prefixPreposition(e) {
        var t = ''
        return (
          'almost' === e && (t = 'skoro'),
          'about' === e && (t = 'přibližně'),
          0 < t.length ? t + ' ' : ''
        )
      }
      function suffixPreposition(e) {
        var t = ''
        return (
          'lessThan' === e && (t = 'méně než'),
          'over' === e && (t = 'více než'),
          0 < t.length ? t + ' ' : ''
        )
      }
      e.exports = function buildDistanceInWordsLocale() {
        var a = {
          xSeconds: {
            one: { regular: 'vteřina', past: 'vteřinou', future: 'vteřinu' },
            twoFour: {
              regular: '{{count}} vteřiny',
              past: '{{count}} vteřinami',
              future: '{{count}} vteřiny',
            },
            other: {
              regular: '{{count}} vteřin',
              past: '{{count}} vteřinami',
              future: '{{count}} vteřin',
            },
          },
          halfAMinute: {
            other: {
              regular: 'půl minuty',
              past: 'půl minutou',
              future: 'půl minuty',
            },
          },
          xMinutes: {
            one: { regular: 'minuta', past: 'minutou', future: 'minutu' },
            twoFour: {
              regular: '{{count}} minuty',
              past: '{{count}} minutami',
              future: '{{count}} minuty',
            },
            other: {
              regular: '{{count}} minut',
              past: '{{count}} minutami',
              future: '{{count}} minut',
            },
          },
          xHours: {
            one: { regular: 'hodina', past: 'hodinou', future: 'hodinu' },
            twoFour: {
              regular: '{{count}} hodiny',
              past: '{{count}} hodinami',
              future: '{{count}} hodiny',
            },
            other: {
              regular: '{{count}} hodin',
              past: '{{count}} hodinami',
              future: '{{count}} hodin',
            },
          },
          xDays: {
            one: { regular: 'den', past: 'dnem', future: 'den' },
            twoFour: {
              regular: '{{count}} dni',
              past: '{{count}} dny',
              future: '{{count}} dni',
            },
            other: {
              regular: '{{count}} dní',
              past: '{{count}} dny',
              future: '{{count}} dní',
            },
          },
          xMonths: {
            one: { regular: 'měsíc', past: 'měsícem', future: 'měsíc' },
            twoFour: {
              regular: '{{count}} měsíce',
              past: '{{count}} měsíci',
              future: '{{count}} měsíce',
            },
            other: {
              regular: '{{count}} měsíců',
              past: '{{count}} měsíci',
              future: '{{count}} měsíců',
            },
          },
          xYears: {
            one: { regular: 'rok', past: 'rokem', future: 'rok' },
            twoFour: {
              regular: '{{count}} roky',
              past: '{{count}} roky',
              future: '{{count}} roky',
            },
            other: {
              regular: '{{count}} roků',
              past: '{{count}} roky',
              future: '{{count}} roků',
            },
          },
        }
        return {
          localize: function localize(e, t, n) {
            n = n || {}
            var o =
                (function extractPreposition(t) {
                  return ['lessThan', 'about', 'over', 'almost'].filter(
                    function (e) {
                      return !!t.match(new RegExp('^' + e))
                    },
                  )[0]
                })(e) || '',
              i = (function lowercaseFirstLetter(e) {
                return e.charAt(0).toLowerCase() + e.slice(1)
              })(e.substring(o.length)),
              r = a[i]
            return n.addSuffix
              ? 0 < n.comparison
                ? prefixPreposition(o) +
                  'za ' +
                  suffixPreposition(o) +
                  declension(r, t, 'future')
                : prefixPreposition(o) +
                  'před ' +
                  suffixPreposition(o) +
                  declension(r, t, 'past')
              : prefixPreposition(o) +
                  suffixPreposition(o) +
                  declension(r, t, 'regular')
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'led',
            'úno',
            'bře',
            'dub',
            'kvě',
            'čvn',
            'čvc',
            'srp',
            'zář',
            'říj',
            'lis',
            'pro',
          ],
          n = [
            'leden',
            'únor',
            'březen',
            'duben',
            'květen',
            'červen',
            'červenec',
            'srpen',
            'září',
            'říjen',
            'listopad',
            'prosinec',
          ],
          o = ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
          i = ['ned', 'pon', 'úte', 'stř', 'čtv', 'pát', 'sob'],
          r = [
            'neděle',
            'pondělí',
            'úterý',
            'středa',
            'čtvrtek',
            'pátek',
            'sobota',
          ],
          a = ['DOP.', 'ODP.'],
          s = ['dop.', 'odp.'],
          u = ['dopoledne', 'odpoledne'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '.'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'mindre end et sekund',
            other: 'mindre end {{count}} sekunder',
          },
          xSeconds: { one: '1 sekund', other: '{{count}} sekunder' },
          halfAMinute: 'et halvt minut',
          lessThanXMinutes: {
            one: 'mindre end et minut',
            other: 'mindre end {{count}} minutter',
          },
          xMinutes: { one: '1 minut', other: '{{count}} minutter' },
          aboutXHours: { one: 'cirka 1 time', other: 'cirka {{count}} timer' },
          xHours: { one: '1 time', other: '{{count}} timer' },
          xDays: { one: '1 dag', other: '{{count}} dage' },
          aboutXMonths: {
            one: 'cirka 1 måned',
            other: 'cirka {{count}} måneder',
          },
          xMonths: { one: '1 måned', other: '{{count}} måneder' },
          aboutXYears: { one: 'cirka 1 år', other: 'cirka {{count}} år' },
          xYears: { one: '1 år', other: '{{count}} år' },
          overXYears: { one: 'over 1 år', other: 'over {{count}} år' },
          almostXYears: { one: 'næsten 1 år', other: 'næsten {{count}} år' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'om ' + o : o + ' siden') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'aug',
            'sep',
            'okt',
            'nov',
            'dec',
          ],
          n = [
            'januar',
            'februar',
            'marts',
            'april',
            'maj',
            'juni',
            'juli',
            'august',
            'september',
            'oktober',
            'november',
            'december',
          ],
          o = ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
          i = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
          r = [
            'søndag',
            'mandag',
            'tirsdag',
            'onsdag',
            'torsdag',
            'fredag',
            'lørdag',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '.'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var r = {
          lessThanXSeconds: {
            standalone: {
              one: 'weniger als eine Sekunde',
              other: 'weniger als {{count}} Sekunden',
            },
            withPreposition: {
              one: 'weniger als einer Sekunde',
              other: 'weniger als {{count}} Sekunden',
            },
          },
          xSeconds: {
            standalone: { one: 'eine Sekunde', other: '{{count}} Sekunden' },
            withPreposition: {
              one: 'einer Sekunde',
              other: '{{count}} Sekunden',
            },
          },
          halfAMinute: {
            standalone: 'eine halbe Minute',
            withPreposition: 'einer halben Minute',
          },
          lessThanXMinutes: {
            standalone: {
              one: 'weniger als eine Minute',
              other: 'weniger als {{count}} Minuten',
            },
            withPreposition: {
              one: 'weniger als einer Minute',
              other: 'weniger als {{count}} Minuten',
            },
          },
          xMinutes: {
            standalone: { one: 'eine Minute', other: '{{count}} Minuten' },
            withPreposition: {
              one: 'einer Minute',
              other: '{{count}} Minuten',
            },
          },
          aboutXHours: {
            standalone: {
              one: 'etwa eine Stunde',
              other: 'etwa {{count}} Stunden',
            },
            withPreposition: {
              one: 'etwa einer Stunde',
              other: 'etwa {{count}} Stunden',
            },
          },
          xHours: {
            standalone: { one: 'eine Stunde', other: '{{count}} Stunden' },
            withPreposition: {
              one: 'einer Stunde',
              other: '{{count}} Stunden',
            },
          },
          xDays: {
            standalone: { one: 'ein Tag', other: '{{count}} Tage' },
            withPreposition: { one: 'einem Tag', other: '{{count}} Tagen' },
          },
          aboutXMonths: {
            standalone: {
              one: 'etwa ein Monat',
              other: 'etwa {{count}} Monate',
            },
            withPreposition: {
              one: 'etwa einem Monat',
              other: 'etwa {{count}} Monaten',
            },
          },
          xMonths: {
            standalone: { one: 'ein Monat', other: '{{count}} Monate' },
            withPreposition: { one: 'einem Monat', other: '{{count}} Monaten' },
          },
          aboutXYears: {
            standalone: { one: 'etwa ein Jahr', other: 'etwa {{count}} Jahre' },
            withPreposition: {
              one: 'etwa einem Jahr',
              other: 'etwa {{count}} Jahren',
            },
          },
          xYears: {
            standalone: { one: 'ein Jahr', other: '{{count}} Jahre' },
            withPreposition: { one: 'einem Jahr', other: '{{count}} Jahren' },
          },
          overXYears: {
            standalone: {
              one: 'mehr als ein Jahr',
              other: 'mehr als {{count}} Jahre',
            },
            withPreposition: {
              one: 'mehr als einem Jahr',
              other: 'mehr als {{count}} Jahren',
            },
          },
          almostXYears: {
            standalone: { one: 'fast ein Jahr', other: 'fast {{count}} Jahre' },
            withPreposition: {
              one: 'fast einem Jahr',
              other: 'fast {{count}} Jahren',
            },
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o,
              i = (n = n || {}).addSuffix
                ? r[e].withPreposition
                : r[e].standalone
            return (
              (o =
                'string' == typeof i
                  ? i
                  : 1 === t
                  ? i.one
                  : i.other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'in ' + o : 'vor ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'Jan',
            'Feb',
            'Mär',
            'Apr',
            'Mai',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dez',
          ],
          n = [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
          ],
          o = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          i = ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'],
          r = [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '.'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'λιγότερο από ένα δευτερόλεπτο',
            other: 'λιγότερο από {{count}} δευτερόλεπτα',
          },
          xSeconds: { one: '1 δευτερόλεπτο', other: '{{count}} δευτερόλεπτα' },
          halfAMinute: 'μισό λεπτό',
          lessThanXMinutes: {
            one: 'λιγότερο από ένα λεπτό',
            other: 'λιγότερο από {{count}} λεπτά',
          },
          xMinutes: { one: '1 λεπτό', other: '{{count}} λεπτά' },
          aboutXHours: {
            one: 'περίπου 1 ώρα',
            other: 'περίπου {{count}} ώρες',
          },
          xHours: { one: '1 ώρα', other: '{{count}} ώρες' },
          xDays: { one: '1 ημέρα', other: '{{count}} ημέρες' },
          aboutXMonths: {
            one: 'περίπου 1 μήνας',
            other: 'περίπου {{count}} μήνες',
          },
          xMonths: { one: '1 μήνας', other: '{{count}} μήνες' },
          aboutXYears: {
            one: 'περίπου 1 χρόνο',
            other: 'περίπου {{count}} χρόνια',
          },
          xYears: { one: '1 χρόνο', other: '{{count}} χρόνια' },
          overXYears: {
            one: 'πάνω από 1 χρόνο',
            other: 'πάνω από {{count}} χρόνια',
          },
          almostXYears: {
            one: 'περίπου 1 χρόνο',
            other: 'περίπου {{count}} χρόνια',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'σε ' + o : o + ' πρίν') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var f = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'Ιαν',
            'Φεβ',
            'Μαρ',
            'Απρ',
            'Μαϊ',
            'Ιουν',
            'Ιουλ',
            'Αυγ',
            'Σεπ',
            'Οκτ',
            'Νοε',
            'Δεκ',
          ],
          n = [
            'Ιανουάριος',
            'Φεβρουάριος',
            'Μάρτιος',
            'Απρίλιος',
            'Μάιος',
            'Ιούνιος',
            'Ιούλιος',
            'Αύγουστος',
            'Σεπτέμβριος',
            'Οκτώβριος',
            'Νοέμβριος',
            'Δεκέμβριος',
          ],
          o = [
            'Ιανουαρίου',
            'Φεβρουαρίου',
            'Μαρτίου',
            'Απριλίου',
            'Μαΐου',
            'Ιουνίου',
            'Ιουλίου',
            'Αυγούστου',
            'Σεπτεμβρίου',
            'Οκτωβρίου',
            'Νοεμβρίου',
            'Δεκεμβρίου',
          ],
          i = ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πέ', 'Πα', 'Σά'],
          r = ['Κυρ', 'Δευ', 'Τρί', 'Τετ', 'Πέμ', 'Παρ', 'Σάβ'],
          a = [
            'Κυριακή',
            'Δευτέρα',
            'Τρίτη',
            'Τετάρτη',
            'Πέμπτη',
            'Παρασκευή',
            'Σάββατο',
          ],
          s = ['ΠΜ', 'ΜΜ'],
          u = ['πμ', 'μμ'],
          c = ['π.μ.', 'μ.μ.'],
          d = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return i[e.getDay()]
            },
            ddd: function (e) {
              return r[e.getDay()]
            },
            dddd: function (e) {
              return a[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? c[1] : c[0]
            },
          },
          l = { M: 'ος', D: 'η', DDD: 'η', d: 'η', Q: 'ο', W: 'η' }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            d[n + 'o'] = function (e, t) {
              return t[n](e) + l[n]
            }
          }),
          ['D', 'Do', 'DD'].forEach(function (n) {
            d[n + ' MMMM'] = function (e, t) {
              return (d[n] || t[n])(e, t) + ' ' + o[e.getMonth()]
            }
          }),
          { formatters: d, formattingTokensRegExp: f(d) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'malpli ol sekundo',
            other: 'malpli ol {{count}} sekundoj',
          },
          xSeconds: { one: '1 sekundo', other: '{{count}} sekundoj' },
          halfAMinute: 'duonminuto',
          lessThanXMinutes: {
            one: 'malpli ol minuto',
            other: 'malpli ol {{count}} minutoj',
          },
          xMinutes: { one: '1 minuto', other: '{{count}} minutoj' },
          aboutXHours: {
            one: 'proksimume 1 horo',
            other: 'proksimume {{count}} horoj',
          },
          xHours: { one: '1 horo', other: '{{count}} horoj' },
          xDays: { one: '1 tago', other: '{{count}} tagoj' },
          aboutXMonths: {
            one: 'proksimume 1 monato',
            other: 'proksimume {{count}} monatoj',
          },
          xMonths: { one: '1 monato', other: '{{count}} monatoj' },
          aboutXYears: {
            one: 'proksimume 1 jaro',
            other: 'proksimume {{count}} jaroj',
          },
          xYears: { one: '1 jaro', other: '{{count}} jaroj' },
          overXYears: { one: 'pli ol 1 jaro', other: 'pli ol {{count}} jaroj' },
          almostXYears: {
            one: 'preskaŭ 1 jaro',
            other: 'preskaŭ {{count}} jaroj',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'post ' + o : 'antaŭ ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'aŭg',
            'sep',
            'okt',
            'nov',
            'dec',
          ],
          n = [
            'januaro',
            'februaro',
            'marto',
            'aprilo',
            'majo',
            'junio',
            'julio',
            'aŭgusto',
            'septembro',
            'oktobro',
            'novembro',
            'decembro',
          ],
          o = ['di', 'lu', 'ma', 'me', 'ĵa', 've', 'sa'],
          i = ['dim', 'lun', 'mar', 'mer', 'ĵaŭ', 'ven', 'sab'],
          r = [
            'dimanĉo',
            'lundo',
            'mardo',
            'merkredo',
            'ĵaŭdo',
            'vendredo',
            'sabato',
          ],
          a = ['A.T.M.', 'P.T.M.'],
          s = ['a.t.m.', 'p.t.m.'],
          u = ['antaŭtagmeze', 'posttagmeze'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return t[n](e) + '-a'
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'menos de un segundo',
            other: 'menos de {{count}} segundos',
          },
          xSeconds: { one: '1 segundo', other: '{{count}} segundos' },
          halfAMinute: 'medio minuto',
          lessThanXMinutes: {
            one: 'menos de un minuto',
            other: 'menos de {{count}} minutos',
          },
          xMinutes: { one: '1 minuto', other: '{{count}} minutos' },
          aboutXHours: {
            one: 'alrededor de 1 hora',
            other: 'alrededor de {{count}} horas',
          },
          xHours: { one: '1 hora', other: '{{count}} horas' },
          xDays: { one: '1 día', other: '{{count}} días' },
          aboutXMonths: {
            one: 'alrededor de 1 mes',
            other: 'alrededor de {{count}} meses',
          },
          xMonths: { one: '1 mes', other: '{{count}} meses' },
          aboutXYears: {
            one: 'alrededor de 1 año',
            other: 'alrededor de {{count}} años',
          },
          xYears: { one: '1 año', other: '{{count}} años' },
          overXYears: { one: 'más de 1 año', other: 'más de {{count}} años' },
          almostXYears: { one: 'casi 1 año', other: 'casi {{count}} años' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'en ' + o : 'hace ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'ene',
            'feb',
            'mar',
            'abr',
            'may',
            'jun',
            'jul',
            'ago',
            'sep',
            'oct',
            'nov',
            'dic',
          ],
          n = [
            'enero',
            'febrero',
            'marzo',
            'abril',
            'mayo',
            'junio',
            'julio',
            'agosto',
            'septiembre',
            'octubre',
            'noviembre',
            'diciembre',
          ],
          o = ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sa'],
          i = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
          r = [
            'domingo',
            'lunes',
            'martes',
            'miércoles',
            'jueves',
            'viernes',
            'sábado',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + 'º'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        function futureSeconds(e) {
          return e.replace(/sekuntia?/, 'sekunnin')
        }
        function futureMinutes(e) {
          return e.replace(/minuuttia?/, 'minuutin')
        }
        function futureHours(e) {
          return e.replace(/tuntia?/, 'tunnin')
        }
        function futureMonths(e) {
          return e.replace(/(kuukausi|kuukautta)/, 'kuukauden')
        }
        function futureYears(e) {
          return e.replace(/(vuosi|vuotta)/, 'vuoden')
        }
        var r = {
          lessThanXSeconds: {
            one: 'alle sekunti',
            other: 'alle {{count}} sekuntia',
            futureTense: futureSeconds,
          },
          xSeconds: {
            one: 'sekunti',
            other: '{{count}} sekuntia',
            futureTense: futureSeconds,
          },
          halfAMinute: {
            one: 'puoli minuuttia',
            other: 'puoli minuuttia',
            futureTense: function (e) {
              return 'puolen minuutin'
            },
          },
          lessThanXMinutes: {
            one: 'alle minuutti',
            other: 'alle {{count}} minuuttia',
            futureTense: futureMinutes,
          },
          xMinutes: {
            one: 'minuutti',
            other: '{{count}} minuuttia',
            futureTense: futureMinutes,
          },
          aboutXHours: {
            one: 'noin tunti',
            other: 'noin {{count}} tuntia',
            futureTense: futureHours,
          },
          xHours: {
            one: 'tunti',
            other: '{{count}} tuntia',
            futureTense: futureHours,
          },
          xDays: {
            one: 'päivä',
            other: '{{count}} päivää',
            futureTense: function futureDays(e) {
              return e.replace(/päivää?/, 'päivän')
            },
          },
          aboutXMonths: {
            one: 'noin kuukausi',
            other: 'noin {{count}} kuukautta',
            futureTense: futureMonths,
          },
          xMonths: {
            one: 'kuukausi',
            other: '{{count}} kuukautta',
            futureTense: futureMonths,
          },
          aboutXYears: {
            one: 'noin vuosi',
            other: 'noin {{count}} vuotta',
            futureTense: futureYears,
          },
          xYears: {
            one: 'vuosi',
            other: '{{count}} vuotta',
            futureTense: futureYears,
          },
          overXYears: {
            one: 'yli vuosi',
            other: 'yli {{count}} vuotta',
            futureTense: futureYears,
          },
          almostXYears: {
            one: 'lähes vuosi',
            other: 'lähes {{count}} vuotta',
            futureTense: futureYears,
          },
        }
        return {
          localize: function localize(e, t, n) {
            n = n || {}
            var o = r[e],
              i = 1 === t ? o.one : o.other.replace('{{count}}', t)
            return n.addSuffix
              ? 0 < n.comparison
                ? o.futureTense(i) + ' kuluttua'
                : i + ' sitten'
              : i
          },
        }
      }
    },
    function (e, t, n) {
      var r = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'tammi',
            'helmi',
            'maalis',
            'huhti',
            'touko',
            'kesä',
            'heinä',
            'elo',
            'syys',
            'loka',
            'marras',
            'joulu',
          ],
          n = [
            'tammikuu',
            'helmikuu',
            'maaliskuu',
            'huhtikuu',
            'toukokuu',
            'kesäkuu',
            'heinäkuu',
            'elokuu',
            'syyskuu',
            'lokakuu',
            'marraskuu',
            'joulukuu',
          ],
          o = ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
          i = [
            'sunnuntai',
            'maanantai',
            'tiistai',
            'keskiviikko',
            'torstai',
            'perjantai',
            'lauantai',
          ]
        function meridiem(e) {
          return e.getHours() < 12 ? 'AP' : 'IP'
        }
        var e = {
          MMM: function (e) {
            return t[e.getMonth()]
          },
          MMMM: function (e) {
            return n[e.getMonth()]
          },
          dd: function (e) {
            return o[e.getDay()]
          },
          ddd: function (e) {
            return o[e.getDay()]
          },
          dddd: function (e) {
            return i[e.getDay()]
          },
          A: meridiem,
          a: meridiem,
          aa: meridiem,
        }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return t[n](e).toString() + '.'
            }
          }),
          { formatters: e, formattingTokensRegExp: r(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'mas maliit sa isang segundo',
            other: 'mas maliit sa {{count}} segundo',
          },
          xSeconds: { one: '1 segundo', other: '{{count}} segundo' },
          halfAMinute: 'kalahating minuto',
          lessThanXMinutes: {
            one: 'mas maliit sa isang minuto',
            other: 'mas maliit sa {{count}} minuto',
          },
          xMinutes: { one: '1 minuto', other: '{{count}} minuto' },
          aboutXHours: { one: 'mga 1 oras', other: 'mga {{count}} oras' },
          xHours: { one: '1 oras', other: '{{count}} oras' },
          xDays: { one: '1 araw', other: '{{count}} araw' },
          aboutXMonths: { one: 'mga 1 buwan', other: 'mga {{count}} buwan' },
          xMonths: { one: '1 buwan', other: '{{count}} buwan' },
          aboutXYears: { one: 'mga 1 taon', other: 'mga {{count}} taon' },
          xYears: { one: '1 taon', other: '{{count}} taon' },
          overXYears: {
            one: 'higit sa 1 taon',
            other: 'higit sa {{count}} taon',
          },
          almostXYears: { one: 'halos 1 taon', other: 'halos {{count}} taon' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix
                ? 0 < n.comparison
                  ? 'sa loob ng ' + o
                  : o + ' ang nakalipas'
                : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'Ene',
            'Peb',
            'Mar',
            'Abr',
            'May',
            'Hun',
            'Hul',
            'Ago',
            'Set',
            'Okt',
            'Nob',
            'Dis',
          ],
          n = [
            'Enero',
            'Pebrero',
            'Marso',
            'Abril',
            'Mayo',
            'Hunyo',
            'Hulyo',
            'Agosto',
            'Setyembre',
            'Oktubre',
            'Nobyembre',
            'Disyembre',
          ],
          o = ['Li', 'Lu', 'Ma', 'Mi', 'Hu', 'Bi', 'Sa'],
          i = ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
          r = [
            'Linggo',
            'Lunes',
            'Martes',
            'Miyerkules',
            'Huwebes',
            'Biyernes',
            'Sabado',
          ],
          a = ['NU', 'NT', 'NH', 'NG'],
          s = ['nu', 'nt', 'nh', 'ng'],
          u = ['ng umaga', 'ng tanghali', 'ng hapon', 'ng gabi'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 12 < e.getHours()
                ? e.getHours() % 12 < 6
                  ? a[2]
                  : a[3]
                : e.getHours() < 12
                ? a[0]
                : a[1]
            },
            a: function (e) {
              return 12 < e.getHours()
                ? e.getHours() % 12 < 6
                  ? s[2]
                  : s[3]
                : e.getHours() < 12
                ? s[0]
                : s[1]
            },
            aa: function (e) {
              return 12 < e.getHours()
                ? e.getHours() % 12 < 6
                  ? u[2]
                  : u[3]
                : e.getHours() < 12
                ? u[0]
                : u[1]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return 'ika-' + e
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'moins d’une seconde',
            other: 'moins de {{count}} secondes',
          },
          xSeconds: { one: '1 seconde', other: '{{count}} secondes' },
          halfAMinute: '30 secondes',
          lessThanXMinutes: {
            one: 'moins d’une minute',
            other: 'moins de {{count}} minutes',
          },
          xMinutes: { one: '1 minute', other: '{{count}} minutes' },
          aboutXHours: {
            one: 'environ 1 heure',
            other: 'environ {{count}} heures',
          },
          xHours: { one: '1 heure', other: '{{count}} heures' },
          xDays: { one: '1 jour', other: '{{count}} jours' },
          aboutXMonths: {
            one: 'environ 1 mois',
            other: 'environ {{count}} mois',
          },
          xMonths: { one: '1 mois', other: '{{count}} mois' },
          aboutXYears: { one: 'environ 1 an', other: 'environ {{count}} ans' },
          xYears: { one: '1 an', other: '{{count}} ans' },
          overXYears: { one: 'plus d’un an', other: 'plus de {{count}} ans' },
          almostXYears: { one: 'presqu’un an', other: 'presque {{count}} ans' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'dans ' + o : 'il y a ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var d = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'janv.',
            'févr.',
            'mars',
            'avr.',
            'mai',
            'juin',
            'juill.',
            'août',
            'sept.',
            'oct.',
            'nov.',
            'déc.',
          ],
          n = [
            'janvier',
            'février',
            'mars',
            'avril',
            'mai',
            'juin',
            'juillet',
            'août',
            'septembre',
            'octobre',
            'novembre',
            'décembre',
          ],
          o = ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
          i = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
          r = [
            'dimanche',
            'lundi',
            'mardi',
            'mercredi',
            'jeudi',
            'vendredi',
            'samedi',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['du matin', 'de l’après-midi', 'du soir'],
          c = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              var t = e.getHours()
              return t <= 12 ? u[0] : t <= 16 ? u[1] : u[2]
            },
            Wo: function (e, t) {
              return (function feminineOrdinal(e) {
                return 1 !== e ? e + 'e' : '1re'
              })(t.W(e))
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q'].forEach(function (n) {
            c[n + 'o'] = function (e, t) {
              return (function masculineOrdinal(e) {
                return 1 !== e ? e + 'e' : '1er'
              })(t[n](e))
            }
          }),
          ['MMM', 'MMMM'].forEach(function (o) {
            c['Do ' + o] = function (e, t) {
              var n = 1 === e.getDate() ? 'Do' : 'D'
              return (c[n] || t[n])(e, t) + ' ' + c[o](e)
            }
          }),
          { formatters: c, formattingTokensRegExp: d(c) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: {
              standalone: 'manje od 1 sekunde',
              withPrepositionAgo: 'manje od 1 sekunde',
              withPrepositionIn: 'manje od 1 sekundu',
            },
            dual: 'manje od {{count}} sekunde',
            other: 'manje od {{count}} sekundi',
          },
          xSeconds: {
            one: {
              standalone: '1 sekunda',
              withPrepositionAgo: '1 sekunde',
              withPrepositionIn: '1 sekundu',
            },
            dual: '{{count}} sekunde',
            other: '{{count}} sekundi',
          },
          halfAMinute: 'pola minute',
          lessThanXMinutes: {
            one: {
              standalone: 'manje od 1 minute',
              withPrepositionAgo: 'manje od 1 minute',
              withPrepositionIn: 'manje od 1 minutu',
            },
            dual: 'manje od {{count}} minute',
            other: 'manje od {{count}} minuta',
          },
          xMinutes: {
            one: {
              standalone: '1 minuta',
              withPrepositionAgo: '1 minute',
              withPrepositionIn: '1 minutu',
            },
            dual: '{{count}} minute',
            other: '{{count}} minuta',
          },
          aboutXHours: {
            one: {
              standalone: 'oko 1 sat',
              withPrepositionAgo: 'oko 1 sat',
              withPrepositionIn: 'oko 1 sat',
            },
            dual: 'oko {{count}} sata',
            other: 'oko {{count}} sati',
          },
          xHours: {
            one: {
              standalone: '1 sat',
              withPrepositionAgo: '1 sat',
              withPrepositionIn: '1 sat',
            },
            dual: '{{count}} sata',
            other: '{{count}} sati',
          },
          xDays: {
            one: {
              standalone: '1 dan',
              withPrepositionAgo: '1 dan',
              withPrepositionIn: '1 dan',
            },
            dual: '{{count}} dana',
            other: '{{count}} dana',
          },
          aboutXMonths: {
            one: {
              standalone: 'oko 1 mjesec',
              withPrepositionAgo: 'oko 1 mjesec',
              withPrepositionIn: 'oko 1 mjesec',
            },
            dual: 'oko {{count}} mjeseca',
            other: 'oko {{count}} mjeseci',
          },
          xMonths: {
            one: {
              standalone: '1 mjesec',
              withPrepositionAgo: '1 mjesec',
              withPrepositionIn: '1 mjesec',
            },
            dual: '{{count}} mjeseca',
            other: '{{count}} mjeseci',
          },
          aboutXYears: {
            one: {
              standalone: 'oko 1 godinu',
              withPrepositionAgo: 'oko 1 godinu',
              withPrepositionIn: 'oko 1 godinu',
            },
            dual: 'oko {{count}} godine',
            other: 'oko {{count}} godina',
          },
          xYears: {
            one: {
              standalone: '1 godina',
              withPrepositionAgo: '1 godine',
              withPrepositionIn: '1 godinu',
            },
            dual: '{{count}} godine',
            other: '{{count}} godina',
          },
          overXYears: {
            one: {
              standalone: 'preko 1 godinu',
              withPrepositionAgo: 'preko 1 godinu',
              withPrepositionIn: 'preko 1 godinu',
            },
            dual: 'preko {{count}} godine',
            other: 'preko {{count}} godina',
          },
          almostXYears: {
            one: {
              standalone: 'gotovo 1 godinu',
              withPrepositionAgo: 'gotovo 1 godinu',
              withPrepositionIn: 'gotovo 1 godinu',
            },
            dual: 'gotovo {{count}} godine',
            other: 'gotovo {{count}} godina',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? n.addSuffix
                    ? 0 < n.comparison
                      ? i[e].one.withPrepositionIn
                      : i[e].one.withPrepositionAgo
                    : i[e].one.standalone
                  : 1 < t % 10 && t % 10 < 5 && '1' !== String(t).substr(-2, 1)
                  ? i[e].dual.replace('{{count}}', t)
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'za ' + o : 'prije ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var l = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'sij',
            'velj',
            'ožu',
            'tra',
            'svi',
            'lip',
            'srp',
            'kol',
            'ruj',
            'lis',
            'stu',
            'pro',
          ],
          n = [
            'siječanj',
            'veljača',
            'ožujak',
            'travanj',
            'svibanj',
            'lipanj',
            'srpanj',
            'kolovoz',
            'rujan',
            'listopad',
            'studeni',
            'prosinac',
          ],
          o = [
            'siječnja',
            'veljače',
            'ožujka',
            'travnja',
            'svibnja',
            'lipnja',
            'srpnja',
            'kolovoza',
            'rujna',
            'listopada',
            'studenog',
            'prosinca',
          ],
          i = ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
          r = ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
          a = [
            'nedjelja',
            'ponedjeljak',
            'utorak',
            'srijeda',
            'četvrtak',
            'petak',
            'subota',
          ],
          s = ['ujutro', 'popodne'],
          u = ['ujutro', 'popodne'],
          c = ['ujutro', 'popodne'],
          d = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return i[e.getDay()]
            },
            ddd: function (e) {
              return r[e.getDay()]
            },
            dddd: function (e) {
              return a[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? c[1] : c[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            d[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '.'
              })(t[n](e))
            }
          }),
          ['D', 'Do', 'DD'].forEach(function (n) {
            d[n + ' MMM'] = function (e, t) {
              return (d[n] || t[n])(e, t) + ' ' + o[e.getMonth()]
            }
          }),
          { formatters: d, formattingTokensRegExp: l(d) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'kevesebb, mint egy másodperce',
            other: 'kevesebb, mint {{count}} másodperce',
          },
          xSeconds: { one: '1 másodperce', other: '{{count}} másodperce' },
          halfAMinute: 'fél perce',
          lessThanXMinutes: {
            one: 'kevesebb, mint egy perce',
            other: 'kevesebb, mint {{count}} perce',
          },
          xMinutes: { one: '1 perce', other: '{{count}} perce' },
          aboutXHours: { one: 'közel 1 órája', other: 'közel {{count}} órája' },
          xHours: { one: '1 órája', other: '{{count}} órája' },
          xDays: { one: '1 napja', other: '{{count}} napja' },
          aboutXMonths: {
            one: 'közel 1 hónapja',
            other: 'közel {{count}} hónapja',
          },
          xMonths: { one: '1 hónapja', other: '{{count}} hónapja' },
          aboutXYears: { one: 'közel 1 éve', other: 'közel {{count}} éve' },
          xYears: { one: '1 éve', other: '{{count}} éve' },
          overXYears: {
            one: 'több, mint 1 éve',
            other: 'több, mint {{count}} éve',
          },
          almostXYears: {
            one: 'majdnem 1 éve',
            other: 'majdnem {{count}} éve',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? '' + o : o + '') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'Jan',
            'Feb',
            'Már',
            'Ápr',
            'Máj',
            'Jún',
            'Júl',
            'Aug',
            'Sze',
            'Okt',
            'Nov',
            'Dec',
          ],
          n = [
            'Január',
            'Február',
            'Március',
            'Április',
            'Május',
            'Június',
            'Július',
            'Augusztus',
            'Szeptember',
            'Október',
            'November',
            'December',
          ],
          o = ['Va', 'Hé', 'Ke', 'Sze', 'Cs', 'Pé', 'Szo'],
          i = ['Vas', 'Hét', 'Ked', 'Sze', 'Csü', 'Pén', 'Szo'],
          r = [
            'Vasárnap',
            'Hétfő',
            'Kedd',
            'Szerda',
            'Csütörtök',
            'Péntek',
            'Szombat',
          ],
          a = ['DE', 'DU'],
          s = ['de', 'du'],
          u = ['délelőtt', 'délután'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                var t = e % 100
                if (20 < t || t < 10)
                  switch (t % 10) {
                    case 1:
                      return e + 'st'
                    case 2:
                      return e + 'nd'
                    case 3:
                      return e + 'rd'
                  }
                return e + 'th'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'kurang dari 1 detik',
            other: 'kurang dari {{count}} detik',
          },
          xSeconds: { one: '1 detik', other: '{{count}} detik' },
          halfAMinute: 'setengah menit',
          lessThanXMinutes: {
            one: 'kurang dari 1 menit',
            other: 'kurang dari {{count}} menit',
          },
          xMinutes: { one: '1 menit', other: '{{count}} menit' },
          aboutXHours: { one: 'sekitar 1 jam', other: 'sekitar {{count}} jam' },
          xHours: { one: '1 jam', other: '{{count}} jam' },
          xDays: { one: '1 hari', other: '{{count}} hari' },
          aboutXMonths: {
            one: 'sekitar 1 bulan',
            other: 'sekitar {{count}} bulan',
          },
          xMonths: { one: '1 bulan', other: '{{count}} bulan' },
          aboutXYears: {
            one: 'sekitar 1 tahun',
            other: 'sekitar {{count}} tahun',
          },
          xYears: { one: '1 tahun', other: '{{count}} tahun' },
          overXYears: {
            one: 'lebih dari 1 tahun',
            other: 'lebih dari {{count}} tahun',
          },
          almostXYears: {
            one: 'hampir 1 tahun',
            other: 'hampir {{count}} tahun',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix
                ? 0 < n.comparison
                  ? 'dalam waktu ' + o
                  : o + ' yang lalu'
                : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'Mei',
            'Jun',
            'Jul',
            'Agu',
            'Sep',
            'Okt',
            'Nov',
            'Des',
          ],
          n = [
            'Januari',
            'Februari',
            'Maret',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Agustus',
            'September',
            'Oktober',
            'November',
            'Desember',
          ],
          o = ['Mi', 'Sn', 'Sl', 'Ra', 'Ka', 'Ju', 'Sa'],
          i = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
          r = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                switch (e) {
                  case 1:
                    return 'pertama'
                  case 2:
                    return 'kedua'
                  case 3:
                    return 'ketiga'
                  default:
                    return 'ke-' + e
                }
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'minna en 1 sekúnda',
            other: 'minna en {{count}} sekúndur',
          },
          xSeconds: { one: '1 sekúnda', other: '{{count}} sekúndur' },
          halfAMinute: 'hálf mínúta',
          lessThanXMinutes: {
            one: 'minna en 1 mínúta',
            other: 'minna en {{count}} mínútur',
          },
          xMinutes: { one: '1 mínúta', other: '{{count}} mínútur' },
          aboutXHours: {
            one: 'u.þ.b. 1 klukkustund',
            other: 'u.þ.b. {{count}} klukkustundir',
          },
          xHours: { one: '1 klukkustund', other: '{{count}} klukkustundir' },
          xDays: { one: '1 dagur', other: '{{count}} dagar' },
          aboutXMonths: {
            one: 'u.þ.b. 1 mánuður',
            other: 'u.þ.b. {{count}} mánuðir',
          },
          xMonths: { one: '1 mánuður', other: '{{count}} mánuðir' },
          aboutXYears: { one: 'u.þ.b. 1 ár', other: 'u.þ.b. {{count}} ár' },
          xYears: { one: '1 ár', other: '{{count}} ár' },
          overXYears: { one: 'meira en 1 ár', other: 'meira en {{count}} ár' },
          almostXYears: { one: 'næstum 1 ár', other: 'næstum {{count}} ár' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'í ' + o : o + ' síðan') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'feb',
            'mar',
            'apr',
            'maí',
            'jún',
            'júl',
            'ágú',
            'sep',
            'okt',
            'nóv',
            'des',
          ],
          n = [
            'janúar',
            'febrúar',
            'mars',
            'apríl',
            'maí',
            'júní',
            'júlí',
            'ágúst',
            'september',
            'október',
            'nóvember',
            'desember',
          ],
          o = ['su', 'má', 'þr', 'mi', 'fi', 'fö', 'la'],
          i = ['sun', 'mán', 'þri', 'mið', 'fim', 'fös', 'lau'],
          r = [
            'sunnudaginn',
            'mánudaginn',
            'þriðjudaginn',
            'miðvikudaginn',
            'fimmtudaginn',
            'föstudaginn',
            'laugardaginn',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return '' + e
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'meno di un secondo',
            other: 'meno di {{count}} secondi',
          },
          xSeconds: { one: 'un secondo', other: '{{count}} secondi' },
          halfAMinute: 'alcuni secondi',
          lessThanXMinutes: {
            one: 'meno di un minuto',
            other: 'meno di {{count}} minuti',
          },
          xMinutes: { one: 'un minuto', other: '{{count}} minuti' },
          aboutXHours: { one: "circa un'ora", other: 'circa {{count}} ore' },
          xHours: { one: "un'ora", other: '{{count}} ore' },
          xDays: { one: 'un giorno', other: '{{count}} giorni' },
          aboutXMonths: { one: 'circa un mese', other: 'circa {{count}} mesi' },
          xMonths: { one: 'un mese', other: '{{count}} mesi' },
          aboutXYears: { one: 'circa un anno', other: 'circa {{count}} anni' },
          xYears: { one: 'un anno', other: '{{count}} anni' },
          overXYears: { one: 'più di un anno', other: 'più di {{count}} anni' },
          almostXYears: { one: 'quasi un anno', other: 'quasi {{count}} anni' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'tra ' + o : o + ' fa') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'gen',
            'feb',
            'mar',
            'apr',
            'mag',
            'giu',
            'lug',
            'ago',
            'set',
            'ott',
            'nov',
            'dic',
          ],
          n = [
            'gennaio',
            'febbraio',
            'marzo',
            'aprile',
            'maggio',
            'giugno',
            'luglio',
            'agosto',
            'settembre',
            'ottobre',
            'novembre',
            'dicembre',
          ],
          o = ['do', 'lu', 'ma', 'me', 'gi', 've', 'sa'],
          i = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
          r = [
            'domenica',
            'lunedì',
            'martedì',
            'mercoledì',
            'giovedì',
            'venerdì',
            'sabato',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + 'º'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: { one: '1秒以下', other: '{{count}}秒以下' },
          xSeconds: { one: '1秒', other: '{{count}}秒' },
          halfAMinute: '30秒ぐらい',
          lessThanXMinutes: { one: '1分以下', other: '{{count}}分以下' },
          xMinutes: { one: '1分', other: '{{count}}分' },
          aboutXHours: { one: '1時間ぐらい', other: '{{count}}時間ぐらい' },
          xHours: { one: '1時間', other: '{{count}}時間' },
          xDays: { one: '1日', other: '{{count}}日' },
          aboutXMonths: { one: '1ヶ月ぐらい', other: '{{count}}ヶ月ぐらい' },
          xMonths: { one: '1ヶ月', other: '{{count}}ヶ月' },
          aboutXYears: { one: '1年ぐらい', other: '{{count}}年ぐらい' },
          xYears: { one: '1年', other: '{{count}}年' },
          overXYears: { one: '1年以上', other: '{{count}}年以上' },
          almostXYears: { one: '1年以下', other: '{{count}}年以下' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? o + '後' : o + '前') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月',
          ],
          n = [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
          ],
          o = ['日', '月', '火', '水', '木', '金', '土'],
          i = ['日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'],
          r = [
            '日曜日',
            '月曜日',
            '火曜日',
            '水曜日',
            '木曜日',
            '金曜日',
            '土曜日',
          ],
          a = ['午前', '午後'],
          s = ['午前', '午後'],
          u = ['午前', '午後'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '日'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: { one: '1초 미만', other: '{{count}}초 미만' },
          xSeconds: { one: '1초', other: '{{count}}초' },
          halfAMinute: '30초',
          lessThanXMinutes: { one: '1분 미만', other: '{{count}}분 미만' },
          xMinutes: { one: '1분', other: '{{count}}분' },
          aboutXHours: { one: '약 1시간', other: '약 {{count}}시간' },
          xHours: { one: '1시간', other: '{{count}}시간' },
          xDays: { one: '1일', other: '{{count}}일' },
          aboutXMonths: { one: '약 1개월', other: '약 {{count}}개월' },
          xMonths: { one: '1개월', other: '{{count}}개월' },
          aboutXYears: { one: '약 1년', other: '약 {{count}}년' },
          xYears: { one: '1년', other: '{{count}}년' },
          overXYears: { one: '1년 이상', other: '{{count}}년 이상' },
          almostXYears: { one: '거의 1년', other: '거의 {{count}}년' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? o + ' 후' : o + ' 전') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월',
          ],
          n = [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월',
          ],
          o = ['일', '월', '화', '수', '목', '금', '토'],
          i = ['일', '월', '화', '수', '목', '금', '토'],
          r = [
            '일요일',
            '월요일',
            '화요일',
            '수요일',
            '목요일',
            '금요일',
            '토요일',
          ],
          a = ['오전', '오후'],
          s = ['오전', '오후'],
          u = ['오전', '오후'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '일'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'помалку од секунда',
            other: 'помалку од {{count}} секунди',
          },
          xSeconds: { one: '1 секунда', other: '{{count}} секунди' },
          halfAMinute: 'половина минута',
          lessThanXMinutes: {
            one: 'помалку од минута',
            other: 'помалку од {{count}} минути',
          },
          xMinutes: { one: '1 минута', other: '{{count}} минути' },
          aboutXHours: { one: 'околу 1 час', other: 'околу {{count}} часа' },
          xHours: { one: '1 час', other: '{{count}} часа' },
          xDays: { one: '1 ден', other: '{{count}} дена' },
          aboutXMonths: {
            one: 'околу 1 месец',
            other: 'околу {{count}} месеци',
          },
          xMonths: { one: '1 месец', other: '{{count}} месеци' },
          aboutXYears: {
            one: 'околу 1 година',
            other: 'околу {{count}} години',
          },
          xYears: { one: '1 година', other: '{{count}} години' },
          overXYears: {
            one: 'повеќе од 1 година',
            other: 'повеќе од {{count}} години',
          },
          almostXYears: {
            one: 'безмалку 1 година',
            other: 'безмалку {{count}} години',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'за ' + o : 'пред ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var s = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'јан',
            'фев',
            'мар',
            'апр',
            'мај',
            'јун',
            'јул',
            'авг',
            'сеп',
            'окт',
            'ное',
            'дек',
          ],
          n = [
            'јануари',
            'февруари',
            'март',
            'април',
            'мај',
            'јуни',
            'јули',
            'август',
            'септември',
            'октомври',
            'ноември',
            'декември',
          ],
          o = ['не', 'по', 'вт', 'ср', 'че', 'пе', 'са'],
          i = ['нед', 'пон', 'вто', 'сре', 'чет', 'пет', 'саб'],
          r = [
            'недела',
            'понеделник',
            'вторник',
            'среда',
            'четврток',
            'петок',
            'сабота',
          ],
          a = ['претпладне', 'попладне'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                var t = e % 100
                if (20 < t || t < 10)
                  switch (t % 10) {
                    case 1:
                      return e + '-ви'
                    case 2:
                      return e + '-ри'
                    case 7:
                    case 8:
                      return e + '-ми'
                  }
                return e + '-ти'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: s(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'mindre enn ett sekund',
            other: 'mindre enn {{count}} sekunder',
          },
          xSeconds: { one: 'ett sekund', other: '{{count}} sekunder' },
          halfAMinute: 'et halvt minutt',
          lessThanXMinutes: {
            one: 'mindre enn ett minutt',
            other: 'mindre enn {{count}} minutter',
          },
          xMinutes: { one: 'ett minutt', other: '{{count}} minutter' },
          aboutXHours: { one: 'rundt en time', other: 'rundt {{count}} timer' },
          xHours: { one: 'en time', other: '{{count}} timer' },
          xDays: { one: 'en dag', other: '{{count}} dager' },
          aboutXMonths: {
            one: 'rundt en måned',
            other: 'rundt {{count}} måneder',
          },
          xMonths: { one: 'en måned', other: '{{count}} måneder' },
          aboutXYears: { one: 'rundt ett år', other: 'rundt {{count}} år' },
          xYears: { one: 'ett år', other: '{{count}} år' },
          overXYears: { one: 'over ett år', other: 'over {{count}} år' },
          almostXYears: { one: 'nesten ett år', other: 'nesten {{count}} år' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'om ' + o : o + ' siden') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan.',
            'feb.',
            'mars',
            'april',
            'mai',
            'juni',
            'juli',
            'aug.',
            'sep.',
            'okt.',
            'nov.',
            'des.',
          ],
          n = [
            'januar',
            'februar',
            'mars',
            'april',
            'mai',
            'juni',
            'juli',
            'august',
            'september',
            'oktober',
            'november',
            'desember',
          ],
          o = ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
          i = ['sø.', 'ma.', 'ti.', 'on.', 'to.', 'fr.', 'lø.'],
          r = [
            'søndag',
            'mandag',
            'tirsdag',
            'onsdag',
            'torsdag',
            'fredag',
            'lørdag',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '.'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'minder dan een seconde',
            other: 'minder dan {{count}} seconden',
          },
          xSeconds: { one: '1 seconde', other: '{{count}} seconden' },
          halfAMinute: 'een halve minuut',
          lessThanXMinutes: {
            one: 'minder dan een minuut',
            other: 'minder dan {{count}} minuten',
          },
          xMinutes: { one: 'een minuut', other: '{{count}} minuten' },
          aboutXHours: {
            one: 'ongeveer 1 uur',
            other: 'ongeveer {{count}} uur',
          },
          xHours: { one: '1 uur', other: '{{count}} uur' },
          xDays: { one: '1 dag', other: '{{count}} dagen' },
          aboutXMonths: {
            one: 'ongeveer 1 maand',
            other: 'ongeveer {{count}} maanden',
          },
          xMonths: { one: '1 maand', other: '{{count}} maanden' },
          aboutXYears: {
            one: 'ongeveer 1 jaar',
            other: 'ongeveer {{count}} jaar',
          },
          xYears: { one: '1 jaar', other: '{{count}} jaar' },
          overXYears: {
            one: 'meer dan 1 jaar',
            other: 'meer dan {{count}} jaar',
          },
          almostXYears: { one: 'bijna 1 jaar', other: 'bijna {{count}} jaar' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix
                ? 0 < n.comparison
                  ? 'over ' + o
                  : o + ' geleden'
                : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'feb',
            'mar',
            'apr',
            'mei',
            'jun',
            'jul',
            'aug',
            'sep',
            'okt',
            'nov',
            'dec',
          ],
          n = [
            'januari',
            'februari',
            'maart',
            'april',
            'mei',
            'juni',
            'juli',
            'augustus',
            'september',
            'oktober',
            'november',
            'december',
          ],
          o = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
          i = ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
          r = [
            'zondag',
            'maandag',
            'dinsdag',
            'woensdag',
            'donderdag',
            'vrijdag',
            'zaterdag',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + 'e'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      function declension(e, t, n) {
        n = n || 'regular'
        var o = (function declensionGroup(e, t) {
          if (1 === t) return e.one
          var n = t % 100
          if (n <= 20 && 10 < n) return e.other
          var o = n % 10
          return 2 <= o && o <= 4 ? e.twoFour : e.other
        })(e, t)
        return (o[n] || o).replace('{{count}}', t)
      }
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: {
              regular: 'mniej niż sekunda',
              past: 'mniej niż sekundę',
              future: 'mniej niż sekundę',
            },
            twoFour: 'mniej niż {{count}} sekundy',
            other: 'mniej niż {{count}} sekund',
          },
          xSeconds: {
            one: { regular: 'sekunda', past: 'sekundę', future: 'sekundę' },
            twoFour: '{{count}} sekundy',
            other: '{{count}} sekund',
          },
          halfAMinute: {
            one: 'pół minuty',
            twoFour: 'pół minuty',
            other: 'pół minuty',
          },
          lessThanXMinutes: {
            one: {
              regular: 'mniej niż minuta',
              past: 'mniej niż minutę',
              future: 'mniej niż minutę',
            },
            twoFour: 'mniej niż {{count}} minuty',
            other: 'mniej niż {{count}} minut',
          },
          xMinutes: {
            one: { regular: 'minuta', past: 'minutę', future: 'minutę' },
            twoFour: '{{count}} minuty',
            other: '{{count}} minut',
          },
          aboutXHours: {
            one: {
              regular: 'około godzina',
              past: 'około godziny',
              future: 'około godzinę',
            },
            twoFour: 'około {{count}} godziny',
            other: 'około {{count}} godzin',
          },
          xHours: {
            one: { regular: 'godzina', past: 'godzinę', future: 'godzinę' },
            twoFour: '{{count}} godziny',
            other: '{{count}} godzin',
          },
          xDays: {
            one: { regular: 'dzień', past: 'dzień', future: '1 dzień' },
            twoFour: '{{count}} dni',
            other: '{{count}} dni',
          },
          aboutXMonths: {
            one: 'około miesiąc',
            twoFour: 'około {{count}} miesiące',
            other: 'około {{count}} miesięcy',
          },
          xMonths: {
            one: 'miesiąc',
            twoFour: '{{count}} miesiące',
            other: '{{count}} miesięcy',
          },
          aboutXYears: {
            one: 'około rok',
            twoFour: 'około {{count}} lata',
            other: 'około {{count}} lat',
          },
          xYears: {
            one: 'rok',
            twoFour: '{{count}} lata',
            other: '{{count}} lat',
          },
          overXYears: {
            one: 'ponad rok',
            twoFour: 'ponad {{count}} lata',
            other: 'ponad {{count}} lat',
          },
          almostXYears: {
            one: 'prawie rok',
            twoFour: 'prawie {{count}} lata',
            other: 'prawie {{count}} lat',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o = i[e]
            return (n = n || {}).addSuffix
              ? 0 < n.comparison
                ? 'za ' + declension(o, t, 'future')
                : declension(o, t, 'past') + ' temu'
              : declension(o, t)
          },
        }
      }
    },
    function (e, t, n) {
      var s = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'sty',
            'lut',
            'mar',
            'kwi',
            'maj',
            'cze',
            'lip',
            'sie',
            'wrz',
            'paź',
            'lis',
            'gru',
          ],
          n = [
            'styczeń',
            'luty',
            'marzec',
            'kwiecień',
            'maj',
            'czerwiec',
            'lipiec',
            'sierpień',
            'wrzesień',
            'październik',
            'listopad',
            'grudzień',
          ],
          o = ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'sb'],
          i = ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'piąt.', 'sob.'],
          r = [
            'niedziela',
            'poniedziałek',
            'wtorek',
            'środa',
            'czwartek',
            'piątek',
            'sobota',
          ],
          a = ['w nocy', 'rano', 'po południu', 'wieczorem'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              var t = e.getHours()
              return 17 <= t ? a[3] : 12 <= t ? a[2] : 4 <= t ? a[1] : a[0]
            },
          }
        return (
          (e.a = e.A),
          (e.aa = e.A),
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return t[n](e).toString()
            }
          }),
          { formatters: e, formattingTokensRegExp: s(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'menos de um segundo',
            other: 'menos de {{count}} segundos',
          },
          xSeconds: { one: '1 segundo', other: '{{count}} segundos' },
          halfAMinute: 'meio minuto',
          lessThanXMinutes: {
            one: 'menos de um minuto',
            other: 'menos de {{count}} minutos',
          },
          xMinutes: { one: '1 minuto', other: '{{count}} minutos' },
          aboutXHours: {
            one: 'aproximadamente 1 hora',
            other: 'aproximadamente {{count}} horas',
          },
          xHours: { one: '1 hora', other: '{{count}} horas' },
          xDays: { one: '1 dia', other: '{{count}} dias' },
          aboutXMonths: {
            one: 'aproximadamente 1 mês',
            other: 'aproximadamente {{count}} meses',
          },
          xMonths: { one: '1 mês', other: '{{count}} meses' },
          aboutXYears: {
            one: 'aproximadamente 1 ano',
            other: 'aproximadamente {{count}} anos',
          },
          xYears: { one: '1 ano', other: '{{count}} anos' },
          overXYears: { one: 'mais de 1 ano', other: 'mais de {{count}} anos' },
          almostXYears: { one: 'quase 1 ano', other: 'quase {{count}} anos' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'daqui a ' + o : 'há ' + o) : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'fev',
            'mar',
            'abr',
            'mai',
            'jun',
            'jul',
            'ago',
            'set',
            'out',
            'nov',
            'dez',
          ],
          n = [
            'janeiro',
            'fevereiro',
            'março',
            'abril',
            'maio',
            'junho',
            'julho',
            'agosto',
            'setembro',
            'outubro',
            'novembro',
            'dezembro',
          ],
          o = ['do', 'se', 'te', 'qa', 'qi', 'se', 'sa'],
          i = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
          r = [
            'domingo',
            'segunda-feira',
            'terça-feira',
            'quarta-feira',
            'quinta-feira',
            'sexta-feira',
            'sábado',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + 'º'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'mai puțin de o secundă',
            other: 'mai puțin de {{count}} secunde',
          },
          xSeconds: { one: '1 secundă', other: '{{count}} secunde' },
          halfAMinute: 'jumătate de minut',
          lessThanXMinutes: {
            one: 'mai puțin de un minut',
            other: 'mai puțin de {{count}} minute',
          },
          xMinutes: { one: '1 minut', other: '{{count}} minute' },
          aboutXHours: { one: 'circa 1 oră', other: 'circa {{count}} ore' },
          xHours: { one: '1 oră', other: '{{count}} ore' },
          xDays: { one: '1 zi', other: '{{count}} zile' },
          aboutXMonths: { one: 'circa 1 lună', other: 'circa {{count}} luni' },
          xMonths: { one: '1 lună', other: '{{count}} luni' },
          aboutXYears: { one: 'circa 1 an', other: 'circa {{count}} ani' },
          xYears: { one: '1 an', other: '{{count}} ani' },
          overXYears: { one: 'peste 1 an', other: 'peste {{count}} ani' },
          almostXYears: { one: 'aproape 1 an', other: 'aproape {{count}} ani' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? 'în ' + o : o + ' în urmă') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'ian',
            'feb',
            'mar',
            'apr',
            'mai',
            'iun',
            'iul',
            'aug',
            'sep',
            'oct',
            'noi',
            'dec',
          ],
          n = [
            'ianuarie',
            'februarie',
            'martie',
            'aprilie',
            'mai',
            'iunie',
            'iulie',
            'august',
            'septembrie',
            'octombrie',
            'noiembrie',
            'decembrie',
          ],
          o = ['du', 'lu', 'ma', 'mi', 'jo', 'vi', 'sâ'],
          i = ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'],
          r = [
            'duminică',
            'luni',
            'marți',
            'miercuri',
            'joi',
            'vineri',
            'sâmbăta',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e.toString()
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      function declension(e, t) {
        if (void 0 !== e.one && 1 === t) return e.one
        var n = t % 10,
          o = t % 100
        return 1 === n && 11 !== o
          ? e.singularNominative.replace('{{count}}', t)
          : 2 <= n && n <= 4 && (o < 10 || 20 < o)
          ? e.singularGenitive.replace('{{count}}', t)
          : e.pluralGenitive.replace('{{count}}', t)
      }
      function buildLocalizeTokenFn(n) {
        return function (e, t) {
          return t.addSuffix
            ? 0 < t.comparison
              ? n.future
                ? declension(n.future, e)
                : 'через ' + declension(n.regular, e)
              : n.past
              ? declension(n.past, e)
              : declension(n.regular, e) + ' назад'
            : declension(n.regular, e)
        }
      }
      e.exports = function buildDistanceInWordsLocale() {
        var o = {
          lessThanXSeconds: buildLocalizeTokenFn({
            regular: {
              one: 'меньше секунды',
              singularNominative: 'меньше {{count}} секунды',
              singularGenitive: 'меньше {{count}} секунд',
              pluralGenitive: 'меньше {{count}} секунд',
            },
            future: {
              one: 'меньше, чем через секунду',
              singularNominative: 'меньше, чем через {{count}} секунду',
              singularGenitive: 'меньше, чем через {{count}} секунды',
              pluralGenitive: 'меньше, чем через {{count}} секунд',
            },
          }),
          xSeconds: buildLocalizeTokenFn({
            regular: {
              singularNominative: '{{count}} секунда',
              singularGenitive: '{{count}} секунды',
              pluralGenitive: '{{count}} секунд',
            },
            past: {
              singularNominative: '{{count}} секунду назад',
              singularGenitive: '{{count}} секунды назад',
              pluralGenitive: '{{count}} секунд назад',
            },
            future: {
              singularNominative: 'через {{count}} секунду',
              singularGenitive: 'через {{count}} секунды',
              pluralGenitive: 'через {{count}} секунд',
            },
          }),
          halfAMinute: function (e, t) {
            return t.addSuffix
              ? 0 < t.comparison
                ? 'через полминуты'
                : 'полминуты назад'
              : 'полминуты'
          },
          lessThanXMinutes: buildLocalizeTokenFn({
            regular: {
              one: 'меньше минуты',
              singularNominative: 'меньше {{count}} минуты',
              singularGenitive: 'меньше {{count}} минут',
              pluralGenitive: 'меньше {{count}} минут',
            },
            future: {
              one: 'меньше, чем через минуту',
              singularNominative: 'меньше, чем через {{count}} минуту',
              singularGenitive: 'меньше, чем через {{count}} минуты',
              pluralGenitive: 'меньше, чем через {{count}} минут',
            },
          }),
          xMinutes: buildLocalizeTokenFn({
            regular: {
              singularNominative: '{{count}} минута',
              singularGenitive: '{{count}} минуты',
              pluralGenitive: '{{count}} минут',
            },
            past: {
              singularNominative: '{{count}} минуту назад',
              singularGenitive: '{{count}} минуты назад',
              pluralGenitive: '{{count}} минут назад',
            },
            future: {
              singularNominative: 'через {{count}} минуту',
              singularGenitive: 'через {{count}} минуты',
              pluralGenitive: 'через {{count}} минут',
            },
          }),
          aboutXHours: buildLocalizeTokenFn({
            regular: {
              singularNominative: 'около {{count}} часа',
              singularGenitive: 'около {{count}} часов',
              pluralGenitive: 'около {{count}} часов',
            },
            future: {
              singularNominative: 'приблизительно через {{count}} час',
              singularGenitive: 'приблизительно через {{count}} часа',
              pluralGenitive: 'приблизительно через {{count}} часов',
            },
          }),
          xHours: buildLocalizeTokenFn({
            regular: {
              singularNominative: '{{count}} час',
              singularGenitive: '{{count}} часа',
              pluralGenitive: '{{count}} часов',
            },
          }),
          xDays: buildLocalizeTokenFn({
            regular: {
              singularNominative: '{{count}} день',
              singularGenitive: '{{count}} дня',
              pluralGenitive: '{{count}} дней',
            },
          }),
          aboutXMonths: buildLocalizeTokenFn({
            regular: {
              singularNominative: 'около {{count}} месяца',
              singularGenitive: 'около {{count}} месяцев',
              pluralGenitive: 'около {{count}} месяцев',
            },
            future: {
              singularNominative: 'приблизительно через {{count}} месяц',
              singularGenitive: 'приблизительно через {{count}} месяца',
              pluralGenitive: 'приблизительно через {{count}} месяцев',
            },
          }),
          xMonths: buildLocalizeTokenFn({
            regular: {
              singularNominative: '{{count}} месяц',
              singularGenitive: '{{count}} месяца',
              pluralGenitive: '{{count}} месяцев',
            },
          }),
          aboutXYears: buildLocalizeTokenFn({
            regular: {
              singularNominative: 'около {{count}} года',
              singularGenitive: 'около {{count}} лет',
              pluralGenitive: 'около {{count}} лет',
            },
            future: {
              singularNominative: 'приблизительно через {{count}} год',
              singularGenitive: 'приблизительно через {{count}} года',
              pluralGenitive: 'приблизительно через {{count}} лет',
            },
          }),
          xYears: buildLocalizeTokenFn({
            regular: {
              singularNominative: '{{count}} год',
              singularGenitive: '{{count}} года',
              pluralGenitive: '{{count}} лет',
            },
          }),
          overXYears: buildLocalizeTokenFn({
            regular: {
              singularNominative: 'больше {{count}} года',
              singularGenitive: 'больше {{count}} лет',
              pluralGenitive: 'больше {{count}} лет',
            },
            future: {
              singularNominative: 'больше, чем через {{count}} год',
              singularGenitive: 'больше, чем через {{count}} года',
              pluralGenitive: 'больше, чем через {{count}} лет',
            },
          }),
          almostXYears: buildLocalizeTokenFn({
            regular: {
              singularNominative: 'почти {{count}} год',
              singularGenitive: 'почти {{count}} года',
              pluralGenitive: 'почти {{count}} лет',
            },
            future: {
              singularNominative: 'почти через {{count}} год',
              singularGenitive: 'почти через {{count}} года',
              pluralGenitive: 'почти через {{count}} лет',
            },
          }),
        }
        return {
          localize: function localize(e, t, n) {
            return (n = n || {}), o[e](t, n)
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'янв.',
            'фев.',
            'март',
            'апр.',
            'май',
            'июнь',
            'июль',
            'авг.',
            'сент.',
            'окт.',
            'нояб.',
            'дек.',
          ],
          n = [
            'январь',
            'февраль',
            'март',
            'апрель',
            'май',
            'июнь',
            'июль',
            'август',
            'сентябрь',
            'октябрь',
            'ноябрь',
            'декабрь',
          ],
          o = [
            'января',
            'февраля',
            'марта',
            'апреля',
            'мая',
            'июня',
            'июля',
            'августа',
            'сентября',
            'октября',
            'ноября',
            'декабря',
          ],
          i = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
          r = ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
          a = [
            'воскресенье',
            'понедельник',
            'вторник',
            'среда',
            'четверг',
            'пятница',
            'суббота',
          ],
          s = ['ночи', 'утра', 'дня', 'вечера'],
          u = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return i[e.getDay()]
            },
            ddd: function (e) {
              return r[e.getDay()]
            },
            dddd: function (e) {
              return a[e.getDay()]
            },
            A: function (e) {
              var t = e.getHours()
              return 17 <= t ? s[3] : 12 <= t ? s[2] : 4 <= t ? s[1] : s[0]
            },
            Do: function (e, t) {
              return t.D(e) + '-е'
            },
            Wo: function (e, t) {
              return t.W(e) + '-я'
            },
          }
        return (
          (u.a = u.A),
          (u.aa = u.A),
          ['M', 'DDD', 'd', 'Q'].forEach(function (n) {
            u[n + 'o'] = function (e, t) {
              return t[n](e) + '-й'
            }
          }),
          ['D', 'Do', 'DD'].forEach(function (n) {
            u[n + ' MMMM'] = function (e, t) {
              return (u[n] || t[n])(e, t) + ' ' + o[e.getMonth()]
            }
          }),
          { formatters: u, formattingTokensRegExp: c(u) }
        )
      }
    },
    function (e, t) {
      function declension(e, t, n) {
        var o = (function declensionGroup(e, t) {
          return 1 === t ? e.one : 2 <= t && t <= 4 ? e.twoFour : e.other
        })(e, t)
        return (o[n] || o).replace('{{count}}', t)
      }
      function prefixPreposition(e) {
        var t = ''
        return (
          'almost' === e && (t = 'takmer'),
          'about' === e && (t = 'približne'),
          0 < t.length ? t + ' ' : ''
        )
      }
      function suffixPreposition(e) {
        var t = ''
        return (
          'lessThan' === e && (t = 'menej než'),
          'over' === e && (t = 'viac než'),
          0 < t.length ? t + ' ' : ''
        )
      }
      e.exports = function buildDistanceInWordsLocale() {
        var a = {
          xSeconds: {
            one: { regular: 'sekunda', past: 'sekundou', future: 'sekundu' },
            twoFour: {
              regular: '{{count}} sekundy',
              past: '{{count}} sekundami',
              future: '{{count}} sekundy',
            },
            other: {
              regular: '{{count}} sekúnd',
              past: '{{count}} sekundami',
              future: '{{count}} sekúnd',
            },
          },
          halfAMinute: {
            other: {
              regular: 'pol minúty',
              past: 'pol minútou',
              future: 'pol minúty',
            },
          },
          xMinutes: {
            one: { regular: 'minúta', past: 'minútou', future: 'minútu' },
            twoFour: {
              regular: '{{count}} minúty',
              past: '{{count}} minútami',
              future: '{{count}} minúty',
            },
            other: {
              regular: '{{count}} minút',
              past: '{{count}} minútami',
              future: '{{count}} minút',
            },
          },
          xHours: {
            one: { regular: 'hodina', past: 'hodinou', future: 'hodinu' },
            twoFour: {
              regular: '{{count}} hodiny',
              past: '{{count}} hodinami',
              future: '{{count}} hodiny',
            },
            other: {
              regular: '{{count}} hodín',
              past: '{{count}} hodinami',
              future: '{{count}} hodín',
            },
          },
          xDays: {
            one: { regular: 'deň', past: 'dňom', future: 'deň' },
            twoFour: {
              regular: '{{count}} dni',
              past: '{{count}} dňami',
              future: '{{count}} dni',
            },
            other: {
              regular: '{{count}} dní',
              past: '{{count}} dňami',
              future: '{{count}} dní',
            },
          },
          xMonths: {
            one: { regular: 'mesiac', past: 'mesiacom', future: 'mesiac' },
            twoFour: {
              regular: '{{count}} mesiace',
              past: '{{count}} mesiacmi',
              future: '{{count}} mesiace',
            },
            other: {
              regular: '{{count}} mesiacov',
              past: '{{count}} mesiacmi',
              future: '{{count}} mesiacov',
            },
          },
          xYears: {
            one: { regular: 'rok', past: 'rokom', future: 'rok' },
            twoFour: {
              regular: '{{count}} roky',
              past: '{{count}} rokmi',
              future: '{{count}} roky',
            },
            other: {
              regular: '{{count}} rokov',
              past: '{{count}} rokmi',
              future: '{{count}} rokov',
            },
          },
        }
        return {
          localize: function localize(e, t, n) {
            n = n || {}
            var o =
                (function extractPreposition(t) {
                  return ['lessThan', 'about', 'over', 'almost'].filter(
                    function (e) {
                      return !!t.match(new RegExp('^' + e))
                    },
                  )[0]
                })(e) || '',
              i = (function lowercaseFirstLetter(e) {
                return e.charAt(0).toLowerCase() + e.slice(1)
              })(e.substring(o.length)),
              r = a[i]
            return n.addSuffix
              ? 0 < n.comparison
                ? prefixPreposition(o) +
                  'za ' +
                  suffixPreposition(o) +
                  declension(r, t, 'future')
                : prefixPreposition(o) +
                  'pred ' +
                  suffixPreposition(o) +
                  declension(r, t, 'past')
              : prefixPreposition(o) +
                  suffixPreposition(o) +
                  declension(r, t, 'regular')
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'feb',
            'mar',
            'apr',
            'máj',
            'jún',
            'júl',
            'aug',
            'sep',
            'okt',
            'nov',
            'dec',
          ],
          n = [
            'január',
            'február',
            'marec',
            'apríl',
            'máj',
            'jún',
            'júl',
            'august',
            'september',
            'október',
            'november',
            'december',
          ],
          o = ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
          i = ['neď', 'pon', 'uto', 'str', 'štv', 'pia', 'sob'],
          r = [
            'nedeľa',
            'pondelok',
            'utorok',
            'streda',
            'štvrtok',
            'piatok',
            'sobota',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '.'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'manj kot sekunda',
            two: 'manj kot 2 sekundi',
            three: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund',
          },
          xSeconds: {
            one: '1 sekunda',
            two: '2 sekundi',
            three: '{{count}} sekunde',
            other: '{{count}} sekund',
          },
          halfAMinute: 'pol minute',
          lessThanXMinutes: {
            one: 'manj kot minuta',
            two: 'manj kot 2 minuti',
            three: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut',
          },
          xMinutes: {
            one: '1 minuta',
            two: '2 minuti',
            three: '{{count}} minute',
            other: '{{count}} minut',
          },
          aboutXHours: {
            one: 'približno 1 ura',
            two: 'približno 2 uri',
            three: 'približno {{count}} ure',
            other: 'približno {{count}} ur',
          },
          xHours: {
            one: '1 ura',
            two: '2 uri',
            three: '{{count}} ure',
            other: '{{count}} ur',
          },
          xDays: {
            one: '1 dan',
            two: '2 dni',
            three: '{{count}} dni',
            other: '{{count}} dni',
          },
          aboutXMonths: {
            one: 'približno 1 mesec',
            two: 'približno 2 meseca',
            three: 'približno {{count}} mesece',
            other: 'približno {{count}} mesecev',
          },
          xMonths: {
            one: '1 mesec',
            two: '2 meseca',
            three: '{{count}} meseci',
            other: '{{count}} mesecev',
          },
          aboutXYears: {
            one: 'približno 1 leto',
            two: 'približno 2 leti',
            three: 'približno {{count}} leta',
            other: 'približno {{count}} let',
          },
          xYears: {
            one: '1 leto',
            two: '2 leti',
            three: '{{count}} leta',
            other: '{{count}} let',
          },
          overXYears: {
            one: 'več kot 1 leto',
            two: 'več kot 2 leti',
            three: 'več kot {{count}} leta',
            other: 'več kot {{count}} let',
          },
          almostXYears: {
            one: 'skoraj 1 leto',
            two: 'skoraj 2 leti',
            three: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let',
          },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : 2 === t
                  ? i[e].two
                  : 3 === t || 4 === t
                  ? i[e].three.replace('{{count}}', t)
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix
                ? ((o = o.replace(/(minut|sekund|ur)(a)/, '$1o')),
                  'xMonths' === e && (o = o.replace(/(mesec)(i)/, '$1e')),
                  0 < n.comparison ? 'čez ' + o : o + ' nazaj')
                : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'avg',
            'sep',
            'okt',
            'nov',
            'dec',
          ],
          n = [
            'januar',
            'februar',
            'marec',
            'april',
            'maj',
            'junij',
            'julij',
            'avgust',
            'september',
            'oktober',
            'november',
            'december',
          ],
          o = ['ne', 'po', 'to', 'sr', 'če', 'pe', 'so'],
          i = ['ned', 'pon', 'tor', 'sre', 'čet', 'pet', 'sob'],
          r = [
            'nedelja',
            'ponedeljek',
            'torek',
            'sreda',
            'četrtek',
            'petek',
            'sobota',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['a.m.', 'p.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e + '.'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var r = {
            lessThanXSeconds: {
              singular: 'mindre än en sekund',
              plural: 'mindre än {{count}} sekunder',
            },
            xSeconds: { singular: 'en sekund', plural: '{{count}} sekunder' },
            halfAMinute: 'en halv minut',
            lessThanXMinutes: {
              singular: 'mindre än en minut',
              plural: 'mindre än {{count}} minuter',
            },
            xMinutes: { singular: 'en minut', plural: '{{count}} minuter' },
            aboutXHours: {
              singular: 'ungefär en timme',
              plural: 'ungefär {{count}} timmar',
            },
            xHours: { singular: 'en timme', plural: '{{count}} timmar' },
            xDays: { singular: 'en dag', plural: '{{count}} dagar' },
            aboutXMonths: {
              singular: 'ungefär en månad',
              plural: 'ungefär {{count}} månader',
            },
            xMonths: { singular: 'en månad', plural: '{{count}} månader' },
            aboutXYears: {
              singular: 'ungefär ett år',
              plural: 'ungefär {{count}} år',
            },
            xYears: { singular: 'ett år', plural: '{{count}} år' },
            overXYears: {
              singular: 'över ett år',
              plural: 'över {{count}} år',
            },
            almostXYears: {
              singular: 'nästan ett år',
              plural: 'nästan {{count}} år',
            },
          },
          a = [
            'noll',
            'en',
            'två',
            'tre',
            'fyra',
            'fem',
            'sex',
            'sju',
            'åtta',
            'nio',
            'tio',
            'elva',
            'tolv',
          ]
        return {
          localize: function localize(e, t, n) {
            n = n || {}
            var o,
              i = r[e]
            return (
              (o =
                'string' == typeof i
                  ? i
                  : 0 === t || 1 < t
                  ? i.plural.replace('{{count}}', t < 13 ? a[t] : t)
                  : i.singular),
              n.addSuffix ? (0 < n.comparison ? 'om ' + o : o + ' sedan') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var s = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'aug',
            'sep',
            'okt',
            'nov',
            'dec',
          ],
          n = [
            'januari',
            'februari',
            'mars',
            'april',
            'maj',
            'juni',
            'juli',
            'augusti',
            'september',
            'oktober',
            'november',
            'december',
          ],
          o = ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
          i = ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
          r = [
            'söndag',
            'måndag',
            'tisdag',
            'onsdag',
            'torsdag',
            'fredag',
            'lördag',
          ],
          a = ['f.m.', 'e.m.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
          }
        return (
          (e.A = e.aa),
          (e.a = e.aa),
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                var t = e % 100
                if (20 < t || t < 10)
                  switch (t % 10) {
                    case 1:
                    case 2:
                      return e + ':a'
                  }
                return e + ':e'
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: s(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: {
            one: 'น้อยกว่า 1 วินาที',
            other: 'น้อยกว่า {{count}} วินาที',
          },
          xSeconds: { one: '1 วินาที', other: '{{count}} วินาที' },
          halfAMinute: 'ครึ่งนาที',
          lessThanXMinutes: {
            one: 'น้อยกว่า 1 นาที',
            other: 'น้อยกว่า {{count}} นาที',
          },
          xMinutes: { one: '1 นาที', other: '{{count}} นาที' },
          aboutXHours: {
            one: 'ประมาณ 1 ชั่วโมง',
            other: 'ประมาณ {{count}} ชั่วโมง',
          },
          xHours: { one: '1 ชั่วโมง', other: '{{count}} ชั่วโมง' },
          xDays: { one: '1 วัน', other: '{{count}} วัน' },
          aboutXMonths: {
            one: 'ประมาณ 1 เดือน',
            other: 'ประมาณ {{count}} เดือน',
          },
          xMonths: { one: '1 เดือน', other: '{{count}} เดือน' },
          aboutXYears: { one: 'ประมาณ 1 ปี', other: 'ประมาณ {{count}} ปี' },
          xYears: { one: '1 ปี', other: '{{count}} ปี' },
          overXYears: { one: 'มากกว่า 1 ปี', other: 'มากกว่า {{count}} ปี' },
          almostXYears: { one: 'เกือบ 1 ปี', other: 'เกือบ {{count}} ปี' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix
                ? 0 < n.comparison
                  ? 'halfAMinute' === e
                    ? 'ใน' + o
                    : 'ใน ' + o
                  : o + 'ที่ผ่านมา'
                : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'ม.ค.',
            'ก.พ.',
            'มี.ค.',
            'เม.ย.',
            'พ.ค.',
            'มิ.ย.',
            'ก.ค.',
            'ส.ค.',
            'ก.ย.',
            'ต.ค.',
            'พ.ย.',
            'ธ.ค.',
          ],
          n = [
            'มกราคาม',
            'กุมภาพันธ์',
            'มีนาคม',
            'เมษายน',
            'พฤษภาคม',
            'มิถุนายน',
            'กรกฎาคม',
            'สิงหาคม',
            'กันยายน',
            'ตุลาคม',
            'พฤศจิกายน',
            'ธันวาคม',
          ],
          o = ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
          i = ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
          r = [
            'อาทิตย์',
            'จันทร์',
            'อังคาร',
            'พุธ',
            'พฤหัสบดี',
            'ศุกร์',
            'เสาร์',
          ],
          a = ['น.'],
          s = ['น.'],
          u = ['นาฬิกา'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return a[0]
            },
            a: function (e) {
              return s[0]
            },
            aa: function (e) {
              return u[0]
            },
          }
        return { formatters: e, formattingTokensRegExp: c(e) }
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var r = {
            lessThanXSeconds: {
              one: 'bir saniyeden az',
              other: '{{count}} saniyeden az',
            },
            xSeconds: { one: '1 saniye', other: '{{count}} saniye' },
            halfAMinute: 'yarım dakika',
            lessThanXMinutes: {
              one: 'bir dakikadan az',
              other: '{{count}} dakikadan az',
            },
            xMinutes: { one: '1 dakika', other: '{{count}} dakika' },
            aboutXHours: {
              one: 'yaklaşık 1 saat',
              other: 'yaklaşık {{count}} saat',
            },
            xHours: { one: '1 saat', other: '{{count}} saat' },
            xDays: { one: '1 gün', other: '{{count}} gün' },
            aboutXMonths: {
              one: 'yaklaşık 1 ay',
              other: 'yaklaşık {{count}} ay',
            },
            xMonths: { one: '1 ay', other: '{{count}} ay' },
            aboutXYears: {
              one: 'yaklaşık 1 yıl',
              other: 'yaklaşık {{count}} yıl',
            },
            xYears: { one: '1 yıl', other: '{{count}} yıl' },
            overXYears: {
              one: '1 yıldan fazla',
              other: '{{count}} yıldan fazla',
            },
            almostXYears: {
              one: 'neredeyse 1 yıl',
              other: 'neredeyse {{count}} yıl',
            },
          },
          a = ['lessThanXSeconds', 'lessThanXMinutes', 'overXYears']
        return {
          localize: function localize(e, t, n) {
            var o
            if (
              ((n = n || {}),
              (o =
                'string' == typeof r[e]
                  ? r[e]
                  : 1 === t
                  ? r[e].one
                  : r[e].other.replace('{{count}}', t)),
              n.addSuffix)
            ) {
              var i = ''
              return (
                -1 < a.indexOf(e) && (i = ' bir süre'),
                0 < n.comparison ? o + i + ' içinde' : o + i + ' önce'
              )
            }
            return o
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            'Oca',
            'Şub',
            'Mar',
            'Nis',
            'May',
            'Haz',
            'Tem',
            'Ağu',
            'Eyl',
            'Eki',
            'Kas',
            'Ara',
          ],
          n = [
            'Ocak',
            'Şubat',
            'Mart',
            'Nisan',
            'Mayıs',
            'Haziran',
            'Temmuz',
            'Ağustos',
            'Eylül',
            'Ekim',
            'Kasım',
            'Aralık',
          ],
          o = ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
          i = ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
          r = [
            'Pazar',
            'Pazartesi',
            'Salı',
            'Çarşamba',
            'Perşembe',
            'Cuma',
            'Cumartesi',
          ],
          a = ['ÖÖ', 'ÖS'],
          s = ['öö', 'ös'],
          u = ['ö.ö.', 'ö.s.'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                var t = {
                  1: "'inci",
                  2: "'inci",
                  3: "'üncü",
                  4: "'üncü",
                  5: "'inci",
                  6: "'ıncı",
                  7: "'inci",
                  8: "'inci",
                  9: "'uncu",
                  10: "'uncu",
                  20: "'inci",
                  30: "'uncu",
                  50: "'inci",
                  60: "'ıncı",
                  70: "'inci",
                  80: "'inci",
                  90: "'ıncı",
                  100: "'üncü",
                }
                if (0 === e) return "0'ıncı"
                var n = e % 10,
                  o = (e % 100) - n,
                  i = 100 <= e ? 100 : null
                return e + (t[n] || t[o] || t[i])
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: { one: '不到 1 秒', other: '不到 {{count}} 秒' },
          xSeconds: { one: '1 秒', other: '{{count}} 秒' },
          halfAMinute: '半分钟',
          lessThanXMinutes: {
            one: '不到 1 分钟',
            other: '不到 {{count}} 分钟',
          },
          xMinutes: { one: '1 分钟', other: '{{count}} 分钟' },
          xHours: { one: '1 小时', other: '{{count}} 小时' },
          aboutXHours: { one: '大约 1 小时', other: '大约 {{count}} 小时' },
          xDays: { one: '1 天', other: '{{count}} 天' },
          aboutXMonths: { one: '大约 1 个月', other: '大约 {{count}} 个月' },
          xMonths: { one: '1 个月', other: '{{count}} 个月' },
          aboutXYears: { one: '大约 1 年', other: '大约 {{count}} 年' },
          xYears: { one: '1 年', other: '{{count}} 年' },
          overXYears: { one: '超过 1 年', other: '超过 {{count}} 年' },
          almostXYears: { one: '将近 1 年', other: '将近 {{count}} 年' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? o + '内' : o + '前') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var s = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月',
          ],
          n = [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
          ],
          o = ['日', '一', '二', '三', '四', '五', '六'],
          i = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
          r = [
            '星期日',
            '星期一',
            '星期二',
            '星期三',
            '星期四',
            '星期五',
            '星期六',
          ],
          a = ['上午', '下午'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
          }
        return (
          (e.a =
            e.aa =
            e.A =
              function (e) {
                return 1 <= e.getHours() / 12 ? a[1] : a[0]
              }),
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e.toString()
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: s(e) }
        )
      }
    },
    function (e, t) {
      e.exports = function buildDistanceInWordsLocale() {
        var i = {
          lessThanXSeconds: { one: '少於 1 秒', other: '少於 {{count}} 秒' },
          xSeconds: { one: '1 秒', other: '{{count}} 秒' },
          halfAMinute: '半分鐘',
          lessThanXMinutes: {
            one: '少於 1 分鐘',
            other: '少於 {{count}} 分鐘',
          },
          xMinutes: { one: '1 分鐘', other: '{{count}} 分鐘' },
          xHours: { one: '1 小時', other: '{{count}} 小時' },
          aboutXHours: { one: '大約 1 小時', other: '大約 {{count}} 小時' },
          xDays: { one: '1 天', other: '{{count}} 天' },
          aboutXMonths: { one: '大約 1 個月', other: '大約 {{count}} 個月' },
          xMonths: { one: '1 個月', other: '{{count}} 個月' },
          aboutXYears: { one: '大約 1 年', other: '大約 {{count}} 年' },
          xYears: { one: '1 年', other: '{{count}} 年' },
          overXYears: { one: '超過 1 年', other: '超過 {{count}} 年' },
          almostXYears: { one: '將近 1 年', other: '將近 {{count}} 年' },
        }
        return {
          localize: function localize(e, t, n) {
            var o
            return (
              (n = n || {}),
              (o =
                'string' == typeof i[e]
                  ? i[e]
                  : 1 === t
                  ? i[e].one
                  : i[e].other.replace('{{count}}', t)),
              n.addSuffix ? (0 < n.comparison ? o + '內' : o + '前') : o
            )
          },
        }
      }
    },
    function (e, t, n) {
      var c = n(2)
      e.exports = function buildFormatLocale() {
        var t = [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月',
          ],
          n = [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月',
          ],
          o = ['日', '一', '二', '三', '四', '五', '六'],
          i = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
          r = [
            '星期日',
            '星期一',
            '星期二',
            '星期三',
            '星期四',
            '星期五',
            '星期六',
          ],
          a = ['AM', 'PM'],
          s = ['am', 'pm'],
          u = ['上午', '下午'],
          e = {
            MMM: function (e) {
              return t[e.getMonth()]
            },
            MMMM: function (e) {
              return n[e.getMonth()]
            },
            dd: function (e) {
              return o[e.getDay()]
            },
            ddd: function (e) {
              return i[e.getDay()]
            },
            dddd: function (e) {
              return r[e.getDay()]
            },
            A: function (e) {
              return 1 <= e.getHours() / 12 ? a[1] : a[0]
            },
            a: function (e) {
              return 1 <= e.getHours() / 12 ? s[1] : s[0]
            },
            aa: function (e) {
              return 1 <= e.getHours() / 12 ? u[1] : u[0]
            },
          }
        return (
          ['M', 'D', 'DDD', 'd', 'Q', 'W'].forEach(function (n) {
            e[n + 'o'] = function (e, t) {
              return (function ordinal(e) {
                return e.toString()
              })(t[n](e))
            }
          }),
          { formatters: e, formattingTokensRegExp: c(e) }
        )
      }
    },
    function (e, t, n) {
      var a = n(0)
      e.exports = function startOfWeek(e, t) {
        var n = (t && Number(t.weekStartsOn)) || 0,
          o = a(e),
          i = o.getDay(),
          r = (i < n ? 7 : 0) + i - n
        return o.setDate(o.getDate() - r), o.setHours(0, 0, 0, 0), o
      }
    },
    function (e, t, n) {
      var a = n(5)
      e.exports = function differenceInCalendarDays(e, t) {
        var n = a(e),
          o = a(t),
          i = n.getTime() - 6e4 * n.getTimezoneOffset(),
          r = o.getTime() - 6e4 * o.getTimezoneOffset()
        return Math.round((i - r) / 864e5)
      }
    },
    function (e, t, n) {
      var s = n(0),
        u = n(121)
      e.exports = function addMonths(e, t) {
        var n = s(e),
          o = Number(t),
          i = n.getMonth() + o,
          r = new Date(0)
        r.setFullYear(n.getFullYear(), i, 1), r.setHours(0, 0, 0, 0)
        var a = u(r)
        return n.setMonth(i, Math.min(a, n.getDate())), n
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function differenceInMilliseconds(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() - o.getTime()
      }
    },
    function (e, t, n) {
      var o = {
        './_lib/build_formatting_tokens_reg_exp': 2,
        './_lib/build_formatting_tokens_reg_exp/': 2,
        './_lib/build_formatting_tokens_reg_exp/index': 2,
        './_lib/build_formatting_tokens_reg_exp/index.js': 2,
        './_lib/package': 196,
        './_lib/package.json': 196,
        './ar': 85,
        './ar/': 85,
        './ar/build_distance_in_words_locale': 14,
        './ar/build_distance_in_words_locale/': 14,
        './ar/build_distance_in_words_locale/index': 14,
        './ar/build_distance_in_words_locale/index.js': 14,
        './ar/build_format_locale': 15,
        './ar/build_format_locale/': 15,
        './ar/build_format_locale/index': 15,
        './ar/build_format_locale/index.js': 15,
        './ar/index': 85,
        './ar/index.js': 85,
        './ar/package': 197,
        './ar/package.json': 197,
        './bg': 86,
        './bg/': 86,
        './bg/build_distance_in_words_locale': 16,
        './bg/build_distance_in_words_locale/': 16,
        './bg/build_distance_in_words_locale/index': 16,
        './bg/build_distance_in_words_locale/index.js': 16,
        './bg/build_format_locale': 17,
        './bg/build_format_locale/': 17,
        './bg/build_format_locale/index': 17,
        './bg/build_format_locale/index.js': 17,
        './bg/index': 86,
        './bg/index.js': 86,
        './bg/package': 198,
        './bg/package.json': 198,
        './ca': 87,
        './ca/': 87,
        './ca/build_distance_in_words_locale': 18,
        './ca/build_distance_in_words_locale/': 18,
        './ca/build_distance_in_words_locale/index': 18,
        './ca/build_distance_in_words_locale/index.js': 18,
        './ca/build_format_locale': 19,
        './ca/build_format_locale/': 19,
        './ca/build_format_locale/index': 19,
        './ca/build_format_locale/index.js': 19,
        './ca/index': 87,
        './ca/index.js': 87,
        './ca/package': 199,
        './ca/package.json': 199,
        './cs': 88,
        './cs/': 88,
        './cs/build_distance_in_words_locale': 20,
        './cs/build_distance_in_words_locale/': 20,
        './cs/build_distance_in_words_locale/index': 20,
        './cs/build_distance_in_words_locale/index.js': 20,
        './cs/build_format_locale': 21,
        './cs/build_format_locale/': 21,
        './cs/build_format_locale/index': 21,
        './cs/build_format_locale/index.js': 21,
        './cs/index': 88,
        './cs/index.js': 88,
        './cs/package': 200,
        './cs/package.json': 200,
        './da': 89,
        './da/': 89,
        './da/build_distance_in_words_locale': 22,
        './da/build_distance_in_words_locale/': 22,
        './da/build_distance_in_words_locale/index': 22,
        './da/build_distance_in_words_locale/index.js': 22,
        './da/build_format_locale': 23,
        './da/build_format_locale/': 23,
        './da/build_format_locale/index': 23,
        './da/build_format_locale/index.js': 23,
        './da/index': 89,
        './da/index.js': 89,
        './da/package': 201,
        './da/package.json': 201,
        './de': 90,
        './de/': 90,
        './de/build_distance_in_words_locale': 24,
        './de/build_distance_in_words_locale/': 24,
        './de/build_distance_in_words_locale/index': 24,
        './de/build_distance_in_words_locale/index.js': 24,
        './de/build_format_locale': 25,
        './de/build_format_locale/': 25,
        './de/build_format_locale/index': 25,
        './de/build_format_locale/index.js': 25,
        './de/index': 90,
        './de/index.js': 90,
        './de/package': 202,
        './de/package.json': 202,
        './el': 91,
        './el/': 91,
        './el/build_distance_in_words_locale': 26,
        './el/build_distance_in_words_locale/': 26,
        './el/build_distance_in_words_locale/index': 26,
        './el/build_distance_in_words_locale/index.js': 26,
        './el/build_format_locale': 27,
        './el/build_format_locale/': 27,
        './el/build_format_locale/index': 27,
        './el/build_format_locale/index.js': 27,
        './el/index': 91,
        './el/index.js': 91,
        './el/package': 203,
        './el/package.json': 203,
        './en': 6,
        './en/': 6,
        './en/build_distance_in_words_locale': 12,
        './en/build_distance_in_words_locale/': 12,
        './en/build_distance_in_words_locale/index': 12,
        './en/build_distance_in_words_locale/index.js': 12,
        './en/build_format_locale': 13,
        './en/build_format_locale/': 13,
        './en/build_format_locale/index': 13,
        './en/build_format_locale/index.js': 13,
        './en/index': 6,
        './en/index.js': 6,
        './en/package': 204,
        './en/package.json': 204,
        './eo': 92,
        './eo/': 92,
        './eo/build_distance_in_words_locale': 28,
        './eo/build_distance_in_words_locale/': 28,
        './eo/build_distance_in_words_locale/index': 28,
        './eo/build_distance_in_words_locale/index.js': 28,
        './eo/build_format_locale': 29,
        './eo/build_format_locale/': 29,
        './eo/build_format_locale/index': 29,
        './eo/build_format_locale/index.js': 29,
        './eo/index': 92,
        './eo/index.js': 92,
        './eo/package': 205,
        './eo/package.json': 205,
        './es': 93,
        './es/': 93,
        './es/build_distance_in_words_locale': 30,
        './es/build_distance_in_words_locale/': 30,
        './es/build_distance_in_words_locale/index': 30,
        './es/build_distance_in_words_locale/index.js': 30,
        './es/build_format_locale': 31,
        './es/build_format_locale/': 31,
        './es/build_format_locale/index': 31,
        './es/build_format_locale/index.js': 31,
        './es/index': 93,
        './es/index.js': 93,
        './es/package': 206,
        './es/package.json': 206,
        './fi': 94,
        './fi/': 94,
        './fi/build_distance_in_words_locale': 32,
        './fi/build_distance_in_words_locale/': 32,
        './fi/build_distance_in_words_locale/index': 32,
        './fi/build_distance_in_words_locale/index.js': 32,
        './fi/build_format_locale': 33,
        './fi/build_format_locale/': 33,
        './fi/build_format_locale/index': 33,
        './fi/build_format_locale/index.js': 33,
        './fi/index': 94,
        './fi/index.js': 94,
        './fi/package': 207,
        './fi/package.json': 207,
        './fil': 95,
        './fil/': 95,
        './fil/build_distance_in_words_locale': 34,
        './fil/build_distance_in_words_locale/': 34,
        './fil/build_distance_in_words_locale/index': 34,
        './fil/build_distance_in_words_locale/index.js': 34,
        './fil/build_format_locale': 35,
        './fil/build_format_locale/': 35,
        './fil/build_format_locale/index': 35,
        './fil/build_format_locale/index.js': 35,
        './fil/index': 95,
        './fil/index.js': 95,
        './fil/package': 208,
        './fil/package.json': 208,
        './fr': 96,
        './fr/': 96,
        './fr/build_distance_in_words_locale': 36,
        './fr/build_distance_in_words_locale/': 36,
        './fr/build_distance_in_words_locale/index': 36,
        './fr/build_distance_in_words_locale/index.js': 36,
        './fr/build_format_locale': 37,
        './fr/build_format_locale/': 37,
        './fr/build_format_locale/index': 37,
        './fr/build_format_locale/index.js': 37,
        './fr/index': 96,
        './fr/index.js': 96,
        './fr/package': 209,
        './fr/package.json': 209,
        './hr': 97,
        './hr/': 97,
        './hr/build_distance_in_words_locale': 38,
        './hr/build_distance_in_words_locale/': 38,
        './hr/build_distance_in_words_locale/index': 38,
        './hr/build_distance_in_words_locale/index.js': 38,
        './hr/build_format_locale': 39,
        './hr/build_format_locale/': 39,
        './hr/build_format_locale/index': 39,
        './hr/build_format_locale/index.js': 39,
        './hr/index': 97,
        './hr/index.js': 97,
        './hr/package': 210,
        './hr/package.json': 210,
        './hu': 98,
        './hu/': 98,
        './hu/build_distance_in_words_locale': 40,
        './hu/build_distance_in_words_locale/': 40,
        './hu/build_distance_in_words_locale/index': 40,
        './hu/build_distance_in_words_locale/index.js': 40,
        './hu/build_format_locale': 41,
        './hu/build_format_locale/': 41,
        './hu/build_format_locale/index': 41,
        './hu/build_format_locale/index.js': 41,
        './hu/index': 98,
        './hu/index.js': 98,
        './hu/package': 211,
        './hu/package.json': 211,
        './id': 99,
        './id/': 99,
        './id/build_distance_in_words_locale': 42,
        './id/build_distance_in_words_locale/': 42,
        './id/build_distance_in_words_locale/index': 42,
        './id/build_distance_in_words_locale/index.js': 42,
        './id/build_format_locale': 43,
        './id/build_format_locale/': 43,
        './id/build_format_locale/index': 43,
        './id/build_format_locale/index.js': 43,
        './id/index': 99,
        './id/index.js': 99,
        './id/package': 212,
        './id/package.json': 212,
        './is': 100,
        './is/': 100,
        './is/build_distance_in_words_locale': 44,
        './is/build_distance_in_words_locale/': 44,
        './is/build_distance_in_words_locale/index': 44,
        './is/build_distance_in_words_locale/index.js': 44,
        './is/build_format_locale': 45,
        './is/build_format_locale/': 45,
        './is/build_format_locale/index': 45,
        './is/build_format_locale/index.js': 45,
        './is/index': 100,
        './is/index.js': 100,
        './is/package': 213,
        './is/package.json': 213,
        './it': 101,
        './it/': 101,
        './it/build_distance_in_words_locale': 46,
        './it/build_distance_in_words_locale/': 46,
        './it/build_distance_in_words_locale/index': 46,
        './it/build_distance_in_words_locale/index.js': 46,
        './it/build_format_locale': 47,
        './it/build_format_locale/': 47,
        './it/build_format_locale/index': 47,
        './it/build_format_locale/index.js': 47,
        './it/index': 101,
        './it/index.js': 101,
        './it/package': 214,
        './it/package.json': 214,
        './ja': 102,
        './ja/': 102,
        './ja/build_distance_in_words_locale': 48,
        './ja/build_distance_in_words_locale/': 48,
        './ja/build_distance_in_words_locale/index': 48,
        './ja/build_distance_in_words_locale/index.js': 48,
        './ja/build_format_locale': 49,
        './ja/build_format_locale/': 49,
        './ja/build_format_locale/index': 49,
        './ja/build_format_locale/index.js': 49,
        './ja/index': 102,
        './ja/index.js': 102,
        './ja/package': 215,
        './ja/package.json': 215,
        './ko': 103,
        './ko/': 103,
        './ko/build_distance_in_words_locale': 50,
        './ko/build_distance_in_words_locale/': 50,
        './ko/build_distance_in_words_locale/index': 50,
        './ko/build_distance_in_words_locale/index.js': 50,
        './ko/build_format_locale': 51,
        './ko/build_format_locale/': 51,
        './ko/build_format_locale/index': 51,
        './ko/build_format_locale/index.js': 51,
        './ko/index': 103,
        './ko/index.js': 103,
        './ko/package': 216,
        './ko/package.json': 216,
        './mk': 104,
        './mk/': 104,
        './mk/build_distance_in_words_locale': 52,
        './mk/build_distance_in_words_locale/': 52,
        './mk/build_distance_in_words_locale/index': 52,
        './mk/build_distance_in_words_locale/index.js': 52,
        './mk/build_format_locale': 53,
        './mk/build_format_locale/': 53,
        './mk/build_format_locale/index': 53,
        './mk/build_format_locale/index.js': 53,
        './mk/index': 104,
        './mk/index.js': 104,
        './mk/package': 217,
        './mk/package.json': 217,
        './nb': 105,
        './nb/': 105,
        './nb/build_distance_in_words_locale': 54,
        './nb/build_distance_in_words_locale/': 54,
        './nb/build_distance_in_words_locale/index': 54,
        './nb/build_distance_in_words_locale/index.js': 54,
        './nb/build_format_locale': 55,
        './nb/build_format_locale/': 55,
        './nb/build_format_locale/index': 55,
        './nb/build_format_locale/index.js': 55,
        './nb/index': 105,
        './nb/index.js': 105,
        './nb/package': 218,
        './nb/package.json': 218,
        './nl': 106,
        './nl/': 106,
        './nl/build_distance_in_words_locale': 56,
        './nl/build_distance_in_words_locale/': 56,
        './nl/build_distance_in_words_locale/index': 56,
        './nl/build_distance_in_words_locale/index.js': 56,
        './nl/build_format_locale': 57,
        './nl/build_format_locale/': 57,
        './nl/build_format_locale/index': 57,
        './nl/build_format_locale/index.js': 57,
        './nl/index': 106,
        './nl/index.js': 106,
        './nl/package': 219,
        './nl/package.json': 219,
        './package': 220,
        './package.json': 220,
        './pl': 107,
        './pl/': 107,
        './pl/build_distance_in_words_locale': 58,
        './pl/build_distance_in_words_locale/': 58,
        './pl/build_distance_in_words_locale/index': 58,
        './pl/build_distance_in_words_locale/index.js': 58,
        './pl/build_format_locale': 59,
        './pl/build_format_locale/': 59,
        './pl/build_format_locale/index': 59,
        './pl/build_format_locale/index.js': 59,
        './pl/index': 107,
        './pl/index.js': 107,
        './pl/package': 221,
        './pl/package.json': 221,
        './pt': 108,
        './pt/': 108,
        './pt/build_distance_in_words_locale': 60,
        './pt/build_distance_in_words_locale/': 60,
        './pt/build_distance_in_words_locale/index': 60,
        './pt/build_distance_in_words_locale/index.js': 60,
        './pt/build_format_locale': 61,
        './pt/build_format_locale/': 61,
        './pt/build_format_locale/index': 61,
        './pt/build_format_locale/index.js': 61,
        './pt/index': 108,
        './pt/index.js': 108,
        './pt/package': 222,
        './pt/package.json': 222,
        './ro': 109,
        './ro/': 109,
        './ro/build_distance_in_words_locale': 62,
        './ro/build_distance_in_words_locale/': 62,
        './ro/build_distance_in_words_locale/index': 62,
        './ro/build_distance_in_words_locale/index.js': 62,
        './ro/build_format_locale': 63,
        './ro/build_format_locale/': 63,
        './ro/build_format_locale/index': 63,
        './ro/build_format_locale/index.js': 63,
        './ro/index': 109,
        './ro/index.js': 109,
        './ro/package': 223,
        './ro/package.json': 223,
        './ru': 110,
        './ru/': 110,
        './ru/build_distance_in_words_locale': 64,
        './ru/build_distance_in_words_locale/': 64,
        './ru/build_distance_in_words_locale/index': 64,
        './ru/build_distance_in_words_locale/index.js': 64,
        './ru/build_format_locale': 65,
        './ru/build_format_locale/': 65,
        './ru/build_format_locale/index': 65,
        './ru/build_format_locale/index.js': 65,
        './ru/index': 110,
        './ru/index.js': 110,
        './ru/package': 224,
        './ru/package.json': 224,
        './sk': 111,
        './sk/': 111,
        './sk/build_distance_in_words_locale': 66,
        './sk/build_distance_in_words_locale/': 66,
        './sk/build_distance_in_words_locale/index': 66,
        './sk/build_distance_in_words_locale/index.js': 66,
        './sk/build_format_locale': 67,
        './sk/build_format_locale/': 67,
        './sk/build_format_locale/index': 67,
        './sk/build_format_locale/index.js': 67,
        './sk/index': 111,
        './sk/index.js': 111,
        './sk/package': 225,
        './sk/package.json': 225,
        './sl': 112,
        './sl/': 112,
        './sl/build_distance_in_words_locale': 68,
        './sl/build_distance_in_words_locale/': 68,
        './sl/build_distance_in_words_locale/index': 68,
        './sl/build_distance_in_words_locale/index.js': 68,
        './sl/build_format_locale': 69,
        './sl/build_format_locale/': 69,
        './sl/build_format_locale/index': 69,
        './sl/build_format_locale/index.js': 69,
        './sl/index': 112,
        './sl/index.js': 112,
        './sl/package': 226,
        './sl/package.json': 226,
        './sv': 113,
        './sv/': 113,
        './sv/build_distance_in_words_locale': 70,
        './sv/build_distance_in_words_locale/': 70,
        './sv/build_distance_in_words_locale/index': 70,
        './sv/build_distance_in_words_locale/index.js': 70,
        './sv/build_format_locale': 71,
        './sv/build_format_locale/': 71,
        './sv/build_format_locale/index': 71,
        './sv/build_format_locale/index.js': 71,
        './sv/index': 113,
        './sv/index.js': 113,
        './sv/package': 227,
        './sv/package.json': 227,
        './th': 114,
        './th/': 114,
        './th/build_distance_in_words_locale': 72,
        './th/build_distance_in_words_locale/': 72,
        './th/build_distance_in_words_locale/index': 72,
        './th/build_distance_in_words_locale/index.js': 72,
        './th/build_format_locale': 73,
        './th/build_format_locale/': 73,
        './th/build_format_locale/index': 73,
        './th/build_format_locale/index.js': 73,
        './th/index': 114,
        './th/index.js': 114,
        './th/package': 228,
        './th/package.json': 228,
        './tr': 115,
        './tr/': 115,
        './tr/build_distance_in_words_locale': 74,
        './tr/build_distance_in_words_locale/': 74,
        './tr/build_distance_in_words_locale/index': 74,
        './tr/build_distance_in_words_locale/index.js': 74,
        './tr/build_format_locale': 75,
        './tr/build_format_locale/': 75,
        './tr/build_format_locale/index': 75,
        './tr/build_format_locale/index.js': 75,
        './tr/index': 115,
        './tr/index.js': 115,
        './tr/package': 229,
        './tr/package.json': 229,
        './zh_cn': 116,
        './zh_cn/': 116,
        './zh_cn/build_distance_in_words_locale': 76,
        './zh_cn/build_distance_in_words_locale/': 76,
        './zh_cn/build_distance_in_words_locale/index': 76,
        './zh_cn/build_distance_in_words_locale/index.js': 76,
        './zh_cn/build_format_locale': 77,
        './zh_cn/build_format_locale/': 77,
        './zh_cn/build_format_locale/index': 77,
        './zh_cn/build_format_locale/index.js': 77,
        './zh_cn/index': 116,
        './zh_cn/index.js': 116,
        './zh_cn/package': 230,
        './zh_cn/package.json': 230,
        './zh_tw': 117,
        './zh_tw/': 117,
        './zh_tw/build_distance_in_words_locale': 78,
        './zh_tw/build_distance_in_words_locale/': 78,
        './zh_tw/build_distance_in_words_locale/index': 78,
        './zh_tw/build_distance_in_words_locale/index.js': 78,
        './zh_tw/build_format_locale': 79,
        './zh_tw/build_format_locale/': 79,
        './zh_tw/build_format_locale/index': 79,
        './zh_tw/build_format_locale/index.js': 79,
        './zh_tw/index': 117,
        './zh_tw/index.js': 117,
        './zh_tw/package': 231,
        './zh_tw/package.json': 231,
      }
      function webpackContext(e) {
        return n(webpackContextResolve(e))
      }
      function webpackContextResolve(e) {
        var t = o[e]
        if (!(t + 1)) throw new Error("Cannot find module '" + e + "'.")
        return t
      }
      ;(webpackContext.keys = function webpackContextKeys() {
        return Object.keys(o)
      }),
        (webpackContext.resolve = webpackContextResolve),
        ((e.exports = webpackContext).id = 84)
    },
    function (e, t, n) {
      var o = n(14),
        i = n(15)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(16),
        i = n(17)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(18),
        i = n(19)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(20),
        i = n(21)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(22),
        i = n(23)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(24),
        i = n(25)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(26),
        i = n(27)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(28),
        i = n(29)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(30),
        i = n(31)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(32),
        i = n(33)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(34),
        i = n(35)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(36),
        i = n(37)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(38),
        i = n(39)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(40),
        i = n(41)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(42),
        i = n(43)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(44),
        i = n(45)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(46),
        i = n(47)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(48),
        i = n(49)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(50),
        i = n(51)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(52),
        i = n(53)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(54),
        i = n(55)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(56),
        i = n(57)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(58),
        i = n(59)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(60),
        i = n(61)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(62),
        i = n(63)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(64),
        i = n(65)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(66),
        i = n(67)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(68),
        i = n(69)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(70),
        i = n(71)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(72),
        i = n(73)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(74),
        i = n(75)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(76),
        i = n(77)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      var o = n(78),
        i = n(79)
      e.exports = { distanceInWords: o(), format: i() }
    },
    function (e, t, n) {
      'use strict'
      n.d(t, 'b', function () {
        return o
      }),
        n.d(t, 'a', function () {
          return i
        })
      Object.assign
      var o = function uuid() {
          return (
            (0 < arguments.length && void 0 !== arguments[0]
              ? arguments[0]
              : '') +
            ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(
              /[018]/g,
              function (e) {
                return (
                  e ^
                  (crypto.getRandomValues(new Uint8Array(1))[0] &
                    (15 >> (e / 4)))
                ).toString(16)
              },
            )
          )
        },
        i = function detectSupportsPassive() {
          var e = !1
          try {
            var t = Object.defineProperty({}, 'passive', {
              get: function get() {
                e = !0
              },
            })
            window.addEventListener('testPassive', null, t),
              window.removeEventListener('testPassive', null, t)
          } catch (e) {}
          return e
        }
    },
    function (e, t, n) {
      'use strict'
      n.d(t, 'c', function () {
        return i
      }),
        n.d(t, 'e', function () {
          return r
        }),
        n.d(t, 'b', function () {
          return a
        }),
        n.d(t, 'd', function () {
          return s
        }),
        n.d(t, 'a', function () {
          return c
        })
      var o =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function (e) {
                return typeof e
              }
            : function (e) {
                return e &&
                  'function' == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? 'symbol'
                  : typeof e
              },
        i = function isFunction(e) {
          return 'function' == typeof e
        },
        r = function isString(e) {
          return (
            'string' == typeof e ||
            (!!e &&
              'object' === (void 0 === e ? 'undefined' : o(e)) &&
              '[object String]' === Object.prototype.toString.call(e))
          )
        },
        a = function isDate(e) {
          return (
            ('[object Date]' === Object.prototype.toString.call(e) ||
              e instanceof Date) &&
            !isNaN(e.valueOf())
          )
        },
        s = function isObject(e) {
          return (
            ('function' == typeof e ||
              ('object' === (void 0 === e ? 'undefined' : o(e)) && !!e)) &&
            !Array.isArray(e)
          )
        },
        u = /^(?:f(?:alse)?|no?|0+)$/i,
        c = function BooleanParse(e) {
          return !u.test(e) && !!e
        }
    },
    function (e, t) {
      e.exports = function isDate(e) {
        return e instanceof Date
      }
    },
    function (e, t, n) {
      var r = n(0)
      e.exports = function getDaysInMonth(e) {
        var t = r(e),
          n = t.getFullYear(),
          o = t.getMonth(),
          i = new Date(0)
        return i.setFullYear(n, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate()
      }
    },
    function (e, t, n) {
      var o = n(8)
      e.exports = function addWeeks(e, t) {
        var n = Number(t)
        return o(e, 7 * n)
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function compareDesc(e, t) {
        var n = i(e).getTime(),
          o = i(t).getTime()
        return o < n ? -1 : n < o ? 1 : 0
      }
    },
    function (e, t, n) {
      var a = n(0),
        s = n(138),
        u = n(11)
      e.exports = function differenceInMonths(e, t) {
        var n = a(e),
          o = a(t),
          i = u(n, o),
          r = Math.abs(s(n, o))
        return n.setMonth(n.getMonth() - i * r), i * (r - (u(n, o) === -i))
      }
    },
    function (e, t, n) {
      var o = n(83)
      e.exports = function differenceInSeconds(e, t) {
        var n = o(e, t) / 1e3
        return 0 < n ? Math.floor(n) : Math.ceil(n)
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function endOfDay(e) {
        var t = o(e)
        return t.setHours(23, 59, 59, 999), t
      }
    },
    function (e, t, n) {
      var o = n(0),
        i = n(4),
        r = n(10)
      e.exports = function getISOWeek(e) {
        var t = o(e),
          n = i(t).getTime() - r(t).getTime()
        return Math.round(n / 6048e5) + 1
      }
    },
    function (e, t, n) {
      var r = n(80)
      e.exports = function isSameWeek(e, t, n) {
        var o = r(e, n),
          i = r(t, n)
        return o.getTime() === i.getTime()
      }
    },
    function (e, t, n) {
      'use strict'
      var o = (function () {
        function defineProperties(e, t) {
          for (var n = 0; n < t.length; n++) {
            var o = t[n]
            ;(o.enumerable = o.enumerable || !1),
              (o.configurable = !0),
              'value' in o && (o.writable = !0),
              Object.defineProperty(e, o.key, o)
          }
        }
        return function (e, t, n) {
          return (
            t && defineProperties(e.prototype, t),
            n && defineProperties(e, n),
            e
          )
        }
      })()
      var i = (function () {
        function EventEmitter() {
          var e =
            0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : []
          !(function _classCallCheck(e, t) {
            if (!(e instanceof t))
              throw new TypeError('Cannot call a class as a function')
          })(this, EventEmitter),
            (this._listeners = new Map(e)),
            (this._middlewares = new Map())
        }
        return (
          o(EventEmitter, [
            {
              key: 'listenerCount',
              value: function listenerCount(e) {
                return this._listeners.has(e)
                  ? this._listeners.get(e).length
                  : 0
              },
            },
            {
              key: 'removeListeners',
              value: function removeListeners() {
                var t = this,
                  e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : null,
                  n =
                    1 < arguments.length &&
                    void 0 !== arguments[1] &&
                    arguments[1]
                null !== e
                  ? Array.isArray(e)
                    ? name.forEach(function (e) {
                        return t.removeListeners(e, n)
                      })
                    : (this._listeners.delete(e), n && this.removeMiddleware(e))
                  : (this._listeners = new Map())
              },
            },
            {
              key: 'middleware',
              value: function middleware(e, t) {
                var n = this
                Array.isArray(e)
                  ? name.forEach(function (e) {
                      return n.middleware(e, t)
                    })
                  : (Array.isArray(this._middlewares.get(e)) ||
                      this._middlewares.set(e, []),
                    this._middlewares.get(e).push(t))
              },
            },
            {
              key: 'removeMiddleware',
              value: function removeMiddleware() {
                var t = this,
                  e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : null
                null !== e
                  ? Array.isArray(e)
                    ? name.forEach(function (e) {
                        return t.removeMiddleware(e)
                      })
                    : this._middlewares.delete(e)
                  : (this._middlewares = new Map())
              },
            },
            {
              key: 'on',
              value: function on(e, t) {
                var n = this,
                  o =
                    2 < arguments.length &&
                    void 0 !== arguments[2] &&
                    arguments[2]
                if (Array.isArray(e))
                  e.forEach(function (e) {
                    return n.on(e, t)
                  })
                else {
                  var i = (e = e.toString()).split(/,|, | /)
                  1 < i.length
                    ? i.forEach(function (e) {
                        return n.on(e, t)
                      })
                    : (Array.isArray(this._listeners.get(e)) ||
                        this._listeners.set(e, []),
                      this._listeners.get(e).push({ once: o, callback: t }))
                }
              },
            },
            {
              key: 'once',
              value: function once(e, t) {
                this.on(e, t, !0)
              },
            },
            {
              key: 'emit',
              value: function emit(n, o) {
                var i = this,
                  r =
                    2 < arguments.length &&
                    void 0 !== arguments[2] &&
                    arguments[2]
                n = n.toString()
                var a = this._listeners.get(n),
                  s = null,
                  u = 0,
                  c = r
                if (Array.isArray(a))
                  for (
                    a.forEach(function (e, t) {
                      r ||
                        ((s = i._middlewares.get(n)),
                        Array.isArray(s)
                          ? (s.forEach(function (e) {
                              e(
                                o,
                                function () {
                                  var e =
                                    0 < arguments.length &&
                                    void 0 !== arguments[0]
                                      ? arguments[0]
                                      : null
                                  null !== e && (o = e), u++
                                },
                                n,
                              )
                            }),
                            u >= s.length && (c = !0))
                          : (c = !0)),
                        c &&
                          (e.once && (a[t] = null),
                          e.callback({
                            type: n,
                            timeStamp: new Date().getTime(),
                            data: o,
                          }))
                    });
                    -1 !== a.indexOf(null);

                  )
                    a.splice(a.indexOf(null), 1)
              },
            },
          ]),
          EventEmitter
        )
      })()
      t.a = i
    },
    function (e, t, n) {
      var o = n(9)
      e.exports = function addHours(e, t) {
        var n = Number(t)
        return o(e, 36e5 * n)
      }
    },
    function (e, t, n) {
      var o = n(3),
        i = n(132)
      e.exports = function addISOYears(e, t) {
        var n = Number(t)
        return i(e, o(e) + n)
      }
    },
    function (e, t, n) {
      var a = n(0),
        s = n(10),
        u = n(81)
      e.exports = function setISOYear(e, t) {
        var n = a(e),
          o = Number(t),
          i = u(n, s(n)),
          r = new Date(0)
        return (
          r.setFullYear(o, 0, 4),
          r.setHours(0, 0, 0, 0),
          (n = s(r)).setDate(n.getDate() + i),
          n
        )
      }
    },
    function (e, t, n) {
      var o = n(9)
      e.exports = function addMinutes(e, t) {
        var n = Number(t)
        return o(e, 6e4 * n)
      }
    },
    function (e, t, n) {
      var o = n(82)
      e.exports = function addQuarters(e, t) {
        var n = Number(t)
        return o(e, 3 * n)
      }
    },
    function (e, t, n) {
      var o = n(9)
      e.exports = function addSeconds(e, t) {
        var n = Number(t)
        return o(e, 1e3 * n)
      }
    },
    function (e, t, n) {
      var o = n(82)
      e.exports = function addYears(e, t) {
        var n = Number(t)
        return o(e, 12 * n)
      }
    },
    function (e, t, n) {
      var o = n(3)
      e.exports = function differenceInCalendarISOYears(e, t) {
        return o(e) - o(t)
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function differenceInCalendarMonths(e, t) {
        var n = i(e),
          o = i(t)
        return (
          12 * (n.getFullYear() - o.getFullYear()) +
          (n.getMonth() - o.getMonth())
        )
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getQuarter(e) {
        var t = o(e)
        return Math.floor(t.getMonth() / 3) + 1
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function differenceInCalendarYears(e, t) {
        var n = i(e),
          o = i(t)
        return n.getFullYear() - o.getFullYear()
      }
    },
    function (e, t, n) {
      var a = n(0),
        s = n(81),
        u = n(11)
      e.exports = function differenceInDays(e, t) {
        var n = a(e),
          o = a(t),
          i = u(n, o),
          r = Math.abs(s(n, o))
        return n.setDate(n.getDate() - i * r), i * (r - (u(n, o) === -i))
      }
    },
    function (e, t, n) {
      var o = n(131)
      e.exports = function subISOYears(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var v = n(123),
        g = n(0),
        b = n(125),
        _ = n(124),
        M = n(6)
      e.exports = function distanceInWords(e, t, n) {
        var o = n || {},
          i = v(e, t),
          r = o.locale,
          a = M.distanceInWords.localize
        r &&
          r.distanceInWords &&
          r.distanceInWords.localize &&
          (a = r.distanceInWords.localize)
        var s,
          u,
          c = { addSuffix: Boolean(o.addSuffix), comparison: i }
        u = 0 < i ? ((s = g(e)), g(t)) : ((s = g(t)), g(e))
        var d,
          l = b(u, s),
          f = u.getTimezoneOffset() - s.getTimezoneOffset(),
          h = Math.round(l / 60) - f
        if (h < 2)
          return o.includeSeconds
            ? l < 5
              ? a('lessThanXSeconds', 5, c)
              : l < 10
              ? a('lessThanXSeconds', 10, c)
              : l < 20
              ? a('lessThanXSeconds', 20, c)
              : l < 40
              ? a('halfAMinute', null, c)
              : a(l < 60 ? 'lessThanXMinutes' : 'xMinutes', 1, c)
            : 0 === h
            ? a('lessThanXMinutes', 1, c)
            : a('xMinutes', h, c)
        if (h < 45) return a('xMinutes', h, c)
        if (h < 90) return a('aboutXHours', 1, c)
        if (h < 1440) return a('aboutXHours', Math.round(h / 60), c)
        if (h < 2520) return a('xDays', 1, c)
        if (h < 43200) return a('xDays', Math.round(h / 1440), c)
        if (h < 86400) return a('aboutXMonths', (d = Math.round(h / 43200)), c)
        if ((d = _(u, s)) < 12) return a('xMonths', Math.round(h / 43200), c)
        var m = d % 12,
          p = Math.floor(d / 12)
        return m < 3
          ? a('aboutXYears', p, c)
          : m < 9
          ? a('overXYears', p, c)
          : a('almostXYears', p + 1, c)
      }
    },
    function (e, t, n) {
      var a = n(0)
      e.exports = function endOfWeek(e, t) {
        var n = (t && Number(t.weekStartsOn)) || 0,
          o = a(e),
          i = o.getDay(),
          r = 6 + (i < n ? -7 : 0) - (i - n)
        return o.setDate(o.getDate() + r), o.setHours(23, 59, 59, 999), o
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function endOfMonth(e) {
        var t = o(e),
          n = t.getMonth()
        return (
          t.setFullYear(t.getFullYear(), n + 1, 0),
          t.setHours(23, 59, 59, 999),
          t
        )
      }
    },
    function (e, t, n) {
      var o = n(0),
        i = n(147),
        r = n(81)
      e.exports = function getDayOfYear(e) {
        var t = o(e)
        return r(t, i(t)) + 1
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function startOfYear(e) {
        var t = o(e),
          n = new Date(0)
        return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n
      }
    },
    function (e, t, n) {
      var o = n(120)
      e.exports = function isValid(e) {
        if (o(e)) return !isNaN(e)
        throw new TypeError(toString.call(e) + ' is not an instance of Date')
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isLeapYear(e) {
        var t = o(e).getFullYear()
        return t % 400 == 0 || (t % 4 == 0 && t % 100 != 0)
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getISODay(e) {
        var t = o(e).getDay()
        return 0 === t && (t = 7), t
      }
    },
    function (e, t, n) {
      var i = n(152)
      e.exports = function isSameHour(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() === o.getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function startOfHour(e) {
        var t = o(e)
        return t.setMinutes(0, 0, 0), t
      }
    },
    function (e, t, n) {
      var o = n(128)
      e.exports = function isSameISOWeek(e, t) {
        return o(e, t, { weekStartsOn: 1 })
      }
    },
    function (e, t, n) {
      var i = n(10)
      e.exports = function isSameISOYear(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() === o.getTime()
      }
    },
    function (e, t, n) {
      var i = n(156)
      e.exports = function isSameMinute(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() === o.getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function startOfMinute(e) {
        var t = o(e)
        return t.setSeconds(0, 0), t
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function isSameMonth(e, t) {
        var n = i(e),
          o = i(t)
        return (
          n.getFullYear() === o.getFullYear() && n.getMonth() === o.getMonth()
        )
      }
    },
    function (e, t, n) {
      var i = n(159)
      e.exports = function isSameQuarter(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() === o.getTime()
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function startOfQuarter(e) {
        var t = i(e),
          n = t.getMonth(),
          o = n - (n % 3)
        return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t
      }
    },
    function (e, t, n) {
      var i = n(161)
      e.exports = function isSameSecond(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() === o.getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function startOfSecond(e) {
        var t = o(e)
        return t.setMilliseconds(0), t
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function isSameYear(e, t) {
        var n = i(e),
          o = i(t)
        return n.getFullYear() === o.getFullYear()
      }
    },
    function (e, t, n) {
      var a = n(0)
      e.exports = function lastDayOfWeek(e, t) {
        var n = (t && Number(t.weekStartsOn)) || 0,
          o = a(e),
          i = o.getDay(),
          r = 6 + (i < n ? -7 : 0) - (i - n)
        return o.setHours(0, 0, 0, 0), o.setDate(o.getDate() + r), o
      }
    },
    function (e, t, n) {
      var u = n(0),
        c = n(121)
      e.exports = function setMonth(e, t) {
        var n = u(e),
          o = Number(t),
          i = n.getFullYear(),
          r = n.getDate(),
          a = new Date(0)
        a.setFullYear(i, o, 15), a.setHours(0, 0, 0, 0)
        var s = c(a)
        return n.setMonth(o, Math.min(r, s)), n
      }
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          var t = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'],
            n = {
              '٠': 0,
              '١': 1,
              '٢': 2,
              '٣': 3,
              '٤': 4,
              '٥': 5,
              '٦': 6,
              '٧': 7,
              '٨': 8,
              '٩': 9,
            }
          e.setLocales('ar', {
            MMMM: [
              'كانون الثاني يناير',
              'شباط فبراير',
              'آذار مارس',
              'نيسان أبريل',
              'أيار مايو',
              'حزيران يونيو',
              'تموز يوليو',
              'آب أغسطس',
              'أيلول سبتمبر',
              'تشرين الأول أكتوبر',
              'تشرين الثاني نوفمبر',
              'كانون الأول ديسمبر',
            ],
            MMM: [
              'كانون الثاني يناير',
              'شباط فبراير',
              'آذار مارس',
              'نيسان أبريل',
              'أيار مايو',
              'حزيران يونيو',
              'تموز يوليو',
              'آب أغسطس',
              'أيلول سبتمبر',
              'تشرين الأول أكتوبر',
              'تشرين الثاني نوفمبر',
              'كانون الأول ديسمبر',
            ],
            dddd: [
              'الأحد',
              'الإثنين',
              'الثلاثاء',
              'الأربعاء',
              'الخميس',
              'الجمعة',
              'السبت',
            ],
            ddd: ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
            dd: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
            A: ['ص', 'م'],
            formatter: {
              post: function (e) {
                return e.replace(/\d/g, function (e) {
                  return t[0 | e]
                })
              },
            },
            parser: {
              pre: function (e) {
                return e.replace(/[٠١٢٣٤٥٦٧٨٩]/g, function (e) {
                  return '' + n[e]
                })
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('az', {
            MMMM: [
              'yanvar',
              'fevral',
              'mart',
              'aprel',
              'may',
              'iyun',
              'iyul',
              'avqust',
              'sentyabr',
              'oktyabr',
              'noyabr',
              'dekabr',
            ],
            MMM: [
              'yan',
              'fev',
              'mar',
              'apr',
              'may',
              'iyn',
              'iyl',
              'avq',
              'sen',
              'okt',
              'noy',
              'dek',
            ],
            dddd: [
              'Bazar',
              'Bazar ertəsi',
              'Çərşənbə axşamı',
              'Çərşənbə',
              'Cümə axşamı',
              'Cümə',
              'Şənbə',
            ],
            ddd: ['Baz', 'BzE', 'ÇAx', 'Çər', 'CAx', 'Cüm', 'Şən'],
            dd: ['Bz', 'BE', 'ÇA', 'Çə', 'CA', 'Cü', 'Şə'],
            A: ['gecə', 'səhər', 'gündüz', 'axşam'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 4
                  ? this.A[0]
                  : t < 12
                  ? this.A[1]
                  : t < 17
                  ? this.A[2]
                  : this.A[3]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 2 ? e : 11 < e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('bn', {
            MMMM: [
              'জানুয়ারী',
              'ফেবুয়ারী',
              'মার্চ',
              'এপ্রিল',
              'মে',
              'জুন',
              'জুলাই',
              'অগাস্ট',
              'সেপ্টেম্বর',
              'অক্টোবর',
              'নভেম্বর',
              'ডিসেম্বর',
            ],
            MMM: [
              'জানু',
              'ফেব',
              'মার্চ',
              'এপর',
              'মে',
              'জুন',
              'জুল',
              'অগ',
              'সেপ্ট',
              'অক্টো',
              'নভ',
              'ডিসেম্',
            ],
            dddd: [
              'রবিবার',
              'সোমবার',
              'মঙ্গলবার',
              'বুধবার',
              'বৃহস্পত্তিবার',
              'শুক্রবার',
              'শনিবার',
            ],
            ddd: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহস্পত্তি', 'শুক্র', 'শনি'],
            dd: ['রব', 'সম', 'মঙ্গ', 'বু', 'ব্রিহ', 'শু', 'শনি'],
            A: ['রাত', 'সকাল', 'দুপুর', 'বিকাল'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 4
                  ? this.A[0]
                  : t < 10
                  ? this.A[1]
                  : t < 17
                  ? this.A[2]
                  : t < 20
                  ? this.A[3]
                  : this.A[0]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 1
                  ? e < 4 || 11 < e
                    ? e
                    : e + 12
                  : t < 2
                  ? e
                  : t < 3 && 9 < e
                  ? e
                  : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('cs', {
            MMMM: [
              'leden',
              'únor',
              'březen',
              'duben',
              'květen',
              'červen',
              'červenec',
              'srpen',
              'září',
              'říjen',
              'listopad',
              'prosinec',
            ],
            MMM: [
              'led',
              'úno',
              'bře',
              'dub',
              'kvě',
              'čvn',
              'čvc',
              'srp',
              'zář',
              'říj',
              'lis',
              'pro',
            ],
            dddd: [
              'neděle',
              'pondělí',
              'úterý',
              'středa',
              'čtvrtek',
              'pátek',
              'sobota',
            ],
            ddd: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
            dd: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('de', {
            MMMM: [
              'Januar',
              'Februar',
              'März',
              'April',
              'Mai',
              'Juni',
              'Juli',
              'August',
              'September',
              'Oktober',
              'November',
              'Dezember',
            ],
            MMM: [
              'Jan.',
              'Febr.',
              'Mrz.',
              'Apr.',
              'Mai',
              'Jun.',
              'Jul.',
              'Aug.',
              'Sept.',
              'Okt.',
              'Nov.',
              'Dez.',
            ],
            dddd: [
              'Sonntag',
              'Montag',
              'Dienstag',
              'Mittwoch',
              'Donnerstag',
              'Freitag',
              'Samstag',
            ],
            ddd: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
            dd: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
            A: ['Uhr nachmittags', 'Uhr morgens'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('el', {
            MMMM: {
              nominative: [
                'Ιανουάριος',
                'Φεβρουάριος',
                'Μάρτιος',
                'Απρίλιος',
                'Μάιος',
                'Ιούνιος',
                'Ιούλιος',
                'Αύγουστος',
                'Σεπτέμβριος',
                'Οκτώβριος',
                'Νοέμβριος',
                'Δεκέμβριος',
              ],
              genitive: [
                'Ιανουαρίου',
                'Φεβρουαρίου',
                'Μαρτίου',
                'Απριλίου',
                'Μαΐου',
                'Ιουνίου',
                'Ιουλίου',
                'Αυγούστου',
                'Σεπτεμβρίου',
                'Οκτωβρίου',
                'Νοεμβρίου',
                'Δεκεμβρίου',
              ],
            },
            MMM: [
              'Ιαν',
              'Φεβ',
              'Μαρ',
              'Απρ',
              'Μαϊ',
              'Ιουν',
              'Ιουλ',
              'Αυγ',
              'Σεπ',
              'Οκτ',
              'Νοε',
              'Δεκ',
            ],
            dddd: [
              'Κυριακή',
              'Δευτέρα',
              'Τρίτη',
              'Τετάρτη',
              'Πέμπτη',
              'Παρασκευή',
              'Σάββατο',
            ],
            ddd: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
            dd: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σα'],
            A: ['πμ', 'μμ'],
            formatter: {
              MMMM: function (e, t) {
                return this.MMMM[/D.*MMMM/.test(t) ? 'genitive' : 'nominative'][
                  e.getMonth()
                ]
              },
              hh: function (e) {
                return ('0' + (e.getHours() % 12)).slice(-2)
              },
              h: function (e) {
                return e.getHours() % 12
              },
            },
            parser: {
              MMMM: function (e, t) {
                return this.parser.find(
                  this.MMMM[/D.*MMMM/.test(t) ? 'genitive' : 'nominative'],
                  e,
                )
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('es', {
            MMMM: [
              'Enero',
              'Febrero',
              'Marzo',
              'Abril',
              'Mayo',
              'Junio',
              'Julio',
              'Agosto',
              'Septiembre',
              'Octubre',
              'Noviembre',
              'Diciembre',
            ],
            MMM: [
              'Ene.',
              'Feb.',
              'Mar.',
              'Abr.',
              'May.',
              'Jun.',
              'Jul.',
              'Ago.',
              'Sep.',
              'Oct.',
              'Nov.',
              'Dic.',
            ],
            dddd: [
              'Domingo',
              'Lunes',
              'Martes',
              'Miércoles',
              'Jueves',
              'Viernes',
              'Sábado',
            ],
            ddd: ['Dom.', 'Lun.', 'Mar.', 'Mié.', 'Jue.', 'Vie.', 'Sáb.'],
            dd: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
            A: ['de la mañana', 'de la tarde', 'de la noche'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 12 ? this.A[0] : t < 19 ? this.A[1] : this.A[2]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 1 ? e : 11 < e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          var t = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'],
            n = {
              '۰': 0,
              '۱': 1,
              '۲': 2,
              '۳': 3,
              '۴': 4,
              '۵': 5,
              '۶': 6,
              '۷': 7,
              '۸': 8,
              '۹': 9,
            }
          e.setLocales('fa', {
            MMMM: [
              'ژانویه',
              'فوریه',
              'مارس',
              'آوریل',
              'مه',
              'ژوئن',
              'ژوئیه',
              'اوت',
              'سپتامبر',
              'اکتبر',
              'نوامبر',
              'دسامبر',
            ],
            MMM: [
              'ژانویه',
              'فوریه',
              'مارس',
              'آوریل',
              'مه',
              'ژوئن',
              'ژوئیه',
              'اوت',
              'سپتامبر',
              'اکتبر',
              'نوامبر',
              'دسامبر',
            ],
            dddd: [
              'یک‌شنبه',
              'دوشنبه',
              'سه‌شنبه',
              'چهارشنبه',
              'پنج‌شنبه',
              'جمعه',
              'شنبه',
            ],
            ddd: [
              'یک‌شنبه',
              'دوشنبه',
              'سه‌شنبه',
              'چهارشنبه',
              'پنج‌شنبه',
              'جمعه',
              'شنبه',
            ],
            dd: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
            A: ['قبل از ظهر', 'بعد از ظهر'],
            formatter: {
              post: function (e) {
                return e.replace(/\d/g, function (e) {
                  return t[0 | e]
                })
              },
            },
            parser: {
              pre: function (e) {
                return e.replace(/[۰۱۲۳۴۵۶۷۸۹]/g, function (e) {
                  return '' + n[e]
                })
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('fr', {
            MMMM: [
              'janvier',
              'février',
              'mars',
              'avril',
              'mai',
              'juin',
              'juillet',
              'août',
              'septembre',
              'octobre',
              'novembre',
              'décembre',
            ],
            MMM: [
              'janv.',
              'févr.',
              'mars',
              'avr.',
              'mai',
              'juin',
              'juil.',
              'août',
              'sept.',
              'oct.',
              'nov.',
              'déc.',
            ],
            dddd: [
              'dimanche',
              'lundi',
              'mardi',
              'mercredi',
              'jeudi',
              'vendredi',
              'samedi',
            ],
            ddd: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
            dd: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
            A: ['matin', "l'après-midi"],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('hi', {
            MMMM: [
              'जनवरी',
              'फ़रवरी',
              'मार्च',
              'अप्रैल',
              'मई',
              'जून',
              'जुलाई',
              'अगस्त',
              'सितम्बर',
              'अक्टूबर',
              'नवम्बर',
              'दिसम्बर',
            ],
            MMM: [
              'जन.',
              'फ़र.',
              'मार्च',
              'अप्रै.',
              'मई',
              'जून',
              'जुल.',
              'अग.',
              'सित.',
              'अक्टू.',
              'नव.',
              'दिस.',
            ],
            dddd: [
              'रविवार',
              'सोमवार',
              'मंगलवार',
              'बुधवार',
              'गुरूवार',
              'शुक्रवार',
              'शनिवार',
            ],
            ddd: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरू', 'शुक्र', 'शनि'],
            dd: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
            A: ['रात', 'सुबह', 'दोपहर', 'शाम'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 4
                  ? this.A[0]
                  : t < 10
                  ? this.A[1]
                  : t < 17
                  ? this.A[2]
                  : t < 20
                  ? this.A[3]
                  : this.A[0]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 1
                  ? e < 4 || 11 < e
                    ? e
                    : e + 12
                  : t < 2
                  ? e
                  : t < 3 && 9 < e
                  ? e
                  : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('hu', {
            MMMM: [
              'január',
              'február',
              'március',
              'április',
              'május',
              'június',
              'július',
              'augusztus',
              'szeptember',
              'október',
              'november',
              'december',
            ],
            MMM: [
              'jan',
              'feb',
              'márc',
              'ápr',
              'máj',
              'jún',
              'júl',
              'aug',
              'szept',
              'okt',
              'nov',
              'dec',
            ],
            dddd: [
              'vasárnap',
              'hétfő',
              'kedd',
              'szerda',
              'csütörtök',
              'péntek',
              'szombat',
            ],
            ddd: ['vas', 'hét', 'kedd', 'sze', 'csüt', 'pén', 'szo'],
            dd: ['v', 'h', 'k', 'sze', 'cs', 'p', 'szo'],
            A: ['de', 'du'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('id', {
            MMMM: [
              'Januari',
              'Februari',
              'Maret',
              'April',
              'Mei',
              'Juni',
              'Juli',
              'Agustus',
              'September',
              'Oktober',
              'November',
              'Desember',
            ],
            MMM: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'Mei',
              'Jun',
              'Jul',
              'Ags',
              'Sep',
              'Okt',
              'Nov',
              'Des',
            ],
            dddd: [
              'Minggu',
              'Senin',
              'Selasa',
              'Rabu',
              'Kamis',
              'Jumat',
              'Sabtu',
            ],
            ddd: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
            dd: ['Mg', 'Sn', 'Sl', 'Rb', 'Km', 'Jm', 'Sb'],
            A: ['pagi', 'siang', 'sore', 'malam'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 11
                  ? this.A[0]
                  : t < 15
                  ? this.A[1]
                  : t < 19
                  ? this.A[2]
                  : this.A[3]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 1 ? e : t < 2 && 11 <= e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('it', {
            MMMM: [
              'gennaio',
              'febbraio',
              'marzo',
              'aprile',
              'maggio',
              'giugno',
              'luglio',
              'agosto',
              'settembre',
              'ottobre',
              'novembre',
              'dicembre',
            ],
            MMM: [
              'gen',
              'feb',
              'mar',
              'apr',
              'mag',
              'giu',
              'lug',
              'ago',
              'set',
              'ott',
              'nov',
              'dic',
            ],
            dddd: [
              'Domenica',
              'Lunedì',
              'Martedì',
              'Mercoledì',
              'Giovedì',
              'Venerdì',
              'Sabato',
            ],
            ddd: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
            dd: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
            A: ['di mattina', 'di pomerrigio'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('ja', {
            MMMM: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
            MMM: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
            dddd: [
              '日曜日',
              '月曜日',
              '火曜日',
              '水曜日',
              '木曜日',
              '金曜日',
              '土曜日',
            ],
            ddd: ['日', '月', '火', '水', '木', '金', '土'],
            dd: ['日', '月', '火', '水', '木', '金', '土'],
            A: ['午前', '午後'],
            formatter: {
              hh: function (e) {
                return ('0' + (e.getHours() % 12)).slice(-2)
              },
              h: function (e) {
                return e.getHours() % 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('jv', {
            MMMM: [
              'Januari',
              'Februari',
              'Maret',
              'April',
              'Mei',
              'Juni',
              'Juli',
              'Agustus',
              'September',
              'Oktober',
              'Nopember',
              'Desember',
            ],
            MMM: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'Mei',
              'Jun',
              'Jul',
              'Ags',
              'Sep',
              'Okt',
              'Nop',
              'Des',
            ],
            dddd: [
              'Minggu',
              'Senen',
              'Seloso',
              'Rebu',
              'Kemis',
              'Jemuwah',
              'Septu',
            ],
            ddd: ['Min', 'Sen', 'Sel', 'Reb', 'Kem', 'Jem', 'Sep'],
            dd: ['Mg', 'Sn', 'Sl', 'Rb', 'Km', 'Jm', 'Sp'],
            A: ['enjing', 'siyang', 'sonten', 'ndalu'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 11
                  ? this.A[0]
                  : t < 15
                  ? this.A[1]
                  : t < 19
                  ? this.A[2]
                  : this.A[3]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 1 ? e : t < 2 && 11 <= e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('ko', {
            MMMM: [
              '1월',
              '2월',
              '3월',
              '4월',
              '5월',
              '6월',
              '7월',
              '8월',
              '9월',
              '10월',
              '11월',
              '12월',
            ],
            MMM: [
              '1월',
              '2월',
              '3월',
              '4월',
              '5월',
              '6월',
              '7월',
              '8월',
              '9월',
              '10월',
              '11월',
              '12월',
            ],
            dddd: [
              '일요일',
              '월요일',
              '화요일',
              '수요일',
              '목요일',
              '금요일',
              '토요일',
            ],
            ddd: ['일', '월', '화', '수', '목', '금', '토'],
            dd: ['일', '월', '화', '수', '목', '금', '토'],
            A: ['오전', '오후'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          var t = ['၀', '၁', '၂', '၃', '၄', '၅', '၆', '၇', '၈', '၉'],
            n = {
              '၀': 0,
              '၁': 1,
              '၂': 2,
              '၃': 3,
              '၄': 4,
              '၅': 5,
              '၆': 6,
              '၇': 7,
              '၈': 8,
              '၉': 9,
            }
          e.setLocales('my', {
            MMMM: [
              'ဇန်နဝါရီ',
              'ဖေဖော်ဝါရီ',
              'မတ်',
              'ဧပြီ',
              'မေ',
              'ဇွန်',
              'ဇူလိုင်',
              'သြဂုတ်',
              'စက်တင်ဘာ',
              'အောက်တိုဘာ',
              'နိုဝင်ဘာ',
              'ဒီဇင်ဘာ',
            ],
            MMM: [
              'ဇန်',
              'ဖေ',
              'မတ်',
              'ပြီ',
              'မေ',
              'ဇွန်',
              'လိုင်',
              'သြ',
              'စက်',
              'အောက်',
              'နို',
              'ဒီ',
            ],
            dddd: [
              'တနင်္ဂနွေ',
              'တနင်္လာ',
              'အင်္ဂါ',
              'ဗုဒ္ဓဟူး',
              'ကြာသပတေး',
              'သောကြာ',
              'စနေ',
            ],
            ddd: ['နွေ', 'လာ', 'ဂါ', 'ဟူး', 'ကြာ', 'သော', 'နေ'],
            dd: ['နွေ', 'လာ', 'ဂါ', 'ဟူး', 'ကြာ', 'သော', 'နေ'],
            formatter: {
              post: function (e) {
                return e.replace(/\d/g, function (e) {
                  return t[0 | e]
                })
              },
            },
            parser: {
              pre: function (e) {
                return e.replace(/[၀၁၂၃၄၅၆၇၈၉]/g, function (e) {
                  return '' + n[e]
                })
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('nl', {
            MMMM: [
              'januari',
              'februari',
              'maart',
              'april',
              'mei',
              'juni',
              'juli',
              'augustus',
              'september',
              'oktober',
              'november',
              'december',
            ],
            MMM: {
              withdots: [
                'jan.',
                'feb.',
                'mrt.',
                'apr.',
                'mei',
                'jun.',
                'jul.',
                'aug.',
                'sep.',
                'okt.',
                'nov.',
                'dec.',
              ],
              withoutdots: [
                'jan',
                'feb',
                'mrt',
                'apr',
                'mei',
                'jun',
                'jul',
                'aug',
                'sep',
                'okt',
                'nov',
                'dec',
              ],
            },
            dddd: [
              'zondag',
              'maandag',
              'dinsdag',
              'woensdag',
              'donderdag',
              'vrijdag',
              'zaterdag',
            ],
            ddd: ['zo.', 'ma.', 'di.', 'wo.', 'do.', 'vr.', 'za.'],
            dd: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
            formatter: {
              MMM: function (e, t) {
                return this.MMM[/-MMM-/.test(t) ? 'withoutdots' : 'withdots'][
                  e.getMonth()
                ]
              },
            },
            parser: {
              MMM: function (e, t) {
                return this.parser.find(
                  this.MMM[/-MMM-/.test(t) ? 'withoutdots' : 'withdots'],
                  e,
                )
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          var t = ['੦', '੧', '੨', '੩', '੪', '੫', '੬', '੭', '੮', '੯'],
            n = {
              '੦': 0,
              '੧': 1,
              '੨': 2,
              '੩': 3,
              '੪': 4,
              '੫': 5,
              '੬': 6,
              '੭': 7,
              '੮': 8,
              '੯': 9,
            }
          e.setLocales('pa-in', {
            MMMM: [
              'ਜਨਵਰੀ',
              'ਫ਼ਰਵਰੀ',
              'ਮਾਰਚ',
              'ਅਪ੍ਰੈਲ',
              'ਮਈ',
              'ਜੂਨ',
              'ਜੁਲਾਈ',
              'ਅਗਸਤ',
              'ਸਤੰਬਰ',
              'ਅਕਤੂਬਰ',
              'ਨਵੰਬਰ',
              'ਦਸੰਬਰ',
            ],
            MMM: [
              'ਜਨਵਰੀ',
              'ਫ਼ਰਵਰੀ',
              'ਮਾਰਚ',
              'ਅਪ੍ਰੈਲ',
              'ਮਈ',
              'ਜੂਨ',
              'ਜੁਲਾਈ',
              'ਅਗਸਤ',
              'ਸਤੰਬਰ',
              'ਅਕਤੂਬਰ',
              'ਨਵੰਬਰ',
              'ਦਸੰਬਰ',
            ],
            dddd: [
              'ਐਤਵਾਰ',
              'ਸੋਮਵਾਰ',
              'ਮੰਗਲਵਾਰ',
              'ਬੁਧਵਾਰ',
              'ਵੀਰਵਾਰ',
              'ਸ਼ੁੱਕਰਵਾਰ',
              'ਸ਼ਨੀਚਰਵਾਰ',
            ],
            ddd: ['ਐਤ', 'ਸੋਮ', 'ਮੰਗਲ', 'ਬੁਧ', 'ਵੀਰ', 'ਸ਼ੁਕਰ', 'ਸ਼ਨੀ'],
            dd: ['ਐਤ', 'ਸੋਮ', 'ਮੰਗਲ', 'ਬੁਧ', 'ਵੀਰ', 'ਸ਼ੁਕਰ', 'ਸ਼ਨੀ'],
            A: ['ਰਾਤ', 'ਸਵੇਰ', 'ਦੁਪਹਿਰ', 'ਸ਼ਾਮ'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 4
                  ? this.A[0]
                  : t < 10
                  ? this.A[1]
                  : t < 17
                  ? this.A[2]
                  : t < 20
                  ? this.A[3]
                  : this.A[0]
              },
              post: function (e) {
                return e.replace(/\d/g, function (e) {
                  return t[0 | e]
                })
              },
            },
            parser: {
              h: function (e, t) {
                return t < 1
                  ? e < 4 || 11 < e
                    ? e
                    : e + 12
                  : t < 2
                  ? e
                  : t < 3 && 10 <= e
                  ? e
                  : e + 12
              },
              pre: function (e) {
                return e.replace(/[੦੧੨੩੪੫੬੭੮੯]/g, function (e) {
                  return '' + n[e]
                })
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('pl', {
            MMMM: {
              nominative: [
                'styczeń',
                'luty',
                'marzec',
                'kwiecień',
                'maj',
                'czerwiec',
                'lipiec',
                'sierpień',
                'wrzesień',
                'październik',
                'listopad',
                'grudzień',
              ],
              subjective: [
                'stycznia',
                'lutego',
                'marca',
                'kwietnia',
                'maja',
                'czerwca',
                'lipca',
                'sierpnia',
                'września',
                'października',
                'listopada',
                'grudnia',
              ],
            },
            MMM: [
              'sty',
              'lut',
              'mar',
              'kwi',
              'maj',
              'cze',
              'lip',
              'sie',
              'wrz',
              'paź',
              'lis',
              'gru',
            ],
            dddd: [
              'niedziela',
              'poniedziałek',
              'wtorek',
              'środa',
              'czwartek',
              'piątek',
              'sobota',
            ],
            ddd: ['nie', 'pon', 'wt', 'śr', 'czw', 'pt', 'sb'],
            dd: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
            formatter: {
              MMMM: function (e, t) {
                return this.MMMM[
                  /D MMMM/.test(t) ? 'subjective' : 'nominative'
                ][e.getMonth()]
              },
            },
            parser: {
              MMMM: function (e, t) {
                return this.parser.find(
                  this.MMMM[/D MMMM/.test(t) ? 'subjective' : 'nominative'],
                  e,
                )
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('pt', {
            MMMM: [
              'Janeiro',
              'Fevereiro',
              'Março',
              'Abril',
              'Maio',
              'Junho',
              'Julho',
              'Agosto',
              'Setembro',
              'Outubro',
              'Novembro',
              'Dezembro',
            ],
            MMM: [
              'Jan',
              'Fev',
              'Mar',
              'Abr',
              'Mai',
              'Jun',
              'Jul',
              'Ago',
              'Set',
              'Out',
              'Nov',
              'Dez',
            ],
            dddd: [
              'Domingo',
              'Segunda-Feira',
              'Terça-Feira',
              'Quarta-Feira',
              'Quinta-Feira',
              'Sexta-Feira',
              'Sábado',
            ],
            ddd: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            dd: ['Dom', '2ª', '3ª', '4ª', '5ª', '6ª', 'Sáb'],
            A: ['da madrugada', 'da manhã', 'da tarde', 'da noite'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 5
                  ? this.A[0]
                  : t < 12
                  ? this.A[1]
                  : t < 19
                  ? this.A[2]
                  : this.A[3]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 2 ? e : 11 < e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('ro', {
            MMMM: [
              'ianuarie',
              'februarie',
              'martie',
              'aprilie',
              'mai',
              'iunie',
              'iulie',
              'august',
              'septembrie',
              'octombrie',
              'noiembrie',
              'decembrie',
            ],
            MMM: [
              'ian.',
              'febr.',
              'mart.',
              'apr.',
              'mai',
              'iun.',
              'iul.',
              'aug.',
              'sept.',
              'oct.',
              'nov.',
              'dec.',
            ],
            dddd: [
              'duminică',
              'luni',
              'marți',
              'miercuri',
              'joi',
              'vineri',
              'sâmbătă',
            ],
            ddd: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
            dd: ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sâ'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('ru', {
            MMMM: [
              'Января',
              'Февраля',
              'Марта',
              'Апреля',
              'Мая',
              'Июня',
              'Июля',
              'Августа',
              'Сентября',
              'Октября',
              'Ноября',
              'Декабря',
            ],
            MMM: [
              'янв',
              'фев',
              'мар',
              'апр',
              'мая',
              'июня',
              'июля',
              'авг',
              'сен',
              'окт',
              'ноя',
              'дек',
            ],
            dddd: [
              'Воскресенье',
              'Понедельник',
              'Вторник',
              'Среду',
              'Четверг',
              'Пятницу',
              'Субботу',
            ],
            ddd: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            dd: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
            A: ['ночи', 'утра', 'дня', 'вечера'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 4
                  ? this.A[0]
                  : t < 12
                  ? this.A[1]
                  : t < 17
                  ? this.A[2]
                  : this.A[3]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 2 ? e : 11 < e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('sr', {
            MMMM: [
              'januar',
              'februar',
              'mart',
              'april',
              'maj',
              'jun',
              'jul',
              'avgust',
              'septembar',
              'oktobar',
              'novembar',
              'decembar',
            ],
            MMM: [
              'jan.',
              'feb.',
              'mar.',
              'apr.',
              'maj',
              'jun',
              'jul',
              'avg.',
              'sep.',
              'okt.',
              'nov.',
              'dec.',
            ],
            dddd: [
              'nedelja',
              'ponedeljak',
              'utorak',
              'sreda',
              'četvrtak',
              'petak',
              'subota',
            ],
            ddd: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
            dd: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('th', {
            MMMM: [
              'มกราคม',
              'กุมภาพันธ์',
              'มีนาคม',
              'เมษายน',
              'พฤษภาคม',
              'มิถุนายน',
              'กรกฎาคม',
              'สิงหาคม',
              'กันยายน',
              'ตุลาคม',
              'พฤศจิกายน',
              'ธันวาคม',
            ],
            MMM: [
              'ม.ค.',
              'ก.พ.',
              'มี.ค.',
              'เม.ย.',
              'พ.ค.',
              'มิ.ย.',
              'ก.ค.',
              'ส.ค.',
              'ก.ย.',
              'ต.ค.',
              'พ.ย.',
              'ธ.ค.',
            ],
            dddd: [
              'อาทิตย์',
              'จันทร์',
              'อังคาร',
              'พุธ',
              'พฤหัสบดี',
              'ศุกร์',
              'เสาร์',
            ],
            ddd: [
              'อาทิตย์',
              'จันทร์',
              'อังคาร',
              'พุธ',
              'พฤหัส',
              'ศุกร์',
              'เสาร์',
            ],
            dd: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
            A: ['ก่อนเที่ยง', 'หลังเที่ยง'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('tr', {
            MMMM: [
              'Ocak',
              'Şubat',
              'Mart',
              'Nisan',
              'Mayıs',
              'Haziran',
              'Temmuz',
              'Ağustos',
              'Eylül',
              'Ekim',
              'Kasım',
              'Aralık',
            ],
            MMM: [
              'Oca',
              'Şub',
              'Mar',
              'Nis',
              'May',
              'Haz',
              'Tem',
              'Ağu',
              'Eyl',
              'Eki',
              'Kas',
              'Ara',
            ],
            dddd: [
              'Pazar',
              'Pazartesi',
              'Salı',
              'Çarşamba',
              'Perşembe',
              'Cuma',
              'Cumartesi',
            ],
            ddd: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
            dd: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('uk', {
            MMMM: [
              'січня',
              'лютого',
              'березня',
              'квітня',
              'травня',
              'червня',
              'липня',
              'серпня',
              'вересня',
              'жовтня',
              'листопада',
              'грудня',
            ],
            MMM: [
              'січ',
              'лют',
              'бер',
              'квіт',
              'трав',
              'черв',
              'лип',
              'серп',
              'вер',
              'жовт',
              'лист',
              'груд',
            ],
            dddd: {
              nominative: [
                'неділя',
                'понеділок',
                'вівторок',
                'середа',
                'четвер',
                'п’ятниця',
                'субота',
              ],
              accusative: [
                'неділю',
                'понеділок',
                'вівторок',
                'середу',
                'четвер',
                'п’ятницю',
                'суботу',
              ],
              genitive: [
                'неділі',
                'понеділка',
                'вівторка',
                'середи',
                'четверга',
                'п’ятниці',
                'суботи',
              ],
            },
            ddd: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
            dd: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
            A: ['ночі', 'ранку', 'дня', 'вечора'],
            formatter: {
              A: function (e) {
                var t = e.getHours()
                return t < 4
                  ? this.A[0]
                  : t < 12
                  ? this.A[1]
                  : t < 17
                  ? this.A[2]
                  : this.A[3]
              },
              dddd: function (e, t) {
                var n = 'nominative'
                return (
                  /(\[[ВвУу]\]) ?dddd/.test(t)
                    ? (n = 'accusative')
                    : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t) &&
                      (n = 'genitive'),
                  this.dddd[n][e.getDay()]
                )
              },
            },
            parser: {
              h: function (e, t) {
                return t < 2 ? e : 11 < e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('uz', {
            MMMM: [
              'январ',
              'феврал',
              'март',
              'апрел',
              'май',
              'июн',
              'июл',
              'август',
              'сентябр',
              'октябр',
              'ноябр',
              'декабр',
            ],
            MMM: [
              'янв',
              'фев',
              'мар',
              'апр',
              'май',
              'июн',
              'июл',
              'авг',
              'сен',
              'окт',
              'ноя',
              'дек',
            ],
            dddd: [
              'Якшанба',
              'Душанба',
              'Сешанба',
              'Чоршанба',
              'Пайшанба',
              'Жума',
              'Шанба',
            ],
            ddd: ['Якш', 'Душ', 'Сеш', 'Чор', 'Пай', 'Жум', 'Шан'],
            dd: ['Як', 'Ду', 'Се', 'Чо', 'Па', 'Жу', 'Ша'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('vi', {
            MMMM: [
              'tháng 1',
              'tháng 2',
              'tháng 3',
              'tháng 4',
              'tháng 5',
              'tháng 6',
              'tháng 7',
              'tháng 8',
              'tháng 9',
              'tháng 10',
              'tháng 11',
              'tháng 12',
            ],
            MMM: [
              'Th01',
              'Th02',
              'Th03',
              'Th04',
              'Th05',
              'Th06',
              'Th07',
              'Th08',
              'Th09',
              'Th10',
              'Th11',
              'Th12',
            ],
            dddd: [
              'chủ nhật',
              'thứ hai',
              'thứ ba',
              'thứ tư',
              'thứ năm',
              'thứ sáu',
              'thứ bảy',
            ],
            ddd: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
            dd: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
            A: ['sa', 'ch'],
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('zh-cn', {
            MMMM: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月',
            ],
            MMM: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
            dddd: [
              '星期日',
              '星期一',
              '星期二',
              '星期三',
              '星期四',
              '星期五',
              '星期六',
            ],
            ddd: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            dd: ['日', '一', '二', '三', '四', '五', '六'],
            A: ['凌晨', '早上', '上午', '中午', '下午', '晚上'],
            formatter: {
              A: function (e) {
                var t = 100 * e.getHours() + e.getMinutes()
                return t < 600
                  ? this.A[0]
                  : t < 900
                  ? this.A[1]
                  : t < 1130
                  ? this.A[2]
                  : t < 1230
                  ? this.A[3]
                  : t < 1800
                  ? this.A[4]
                  : this.A[5]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 4 ? e : 11 < e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (n, o, i) {
      var r, a, s
      !(function (e) {
        'use strict'
        var t = function (e) {
          e.setLocales('zh-tw', {
            MMMM: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月',
            ],
            MMM: [
              '1月',
              '2月',
              '3月',
              '4月',
              '5月',
              '6月',
              '7月',
              '8月',
              '9月',
              '10月',
              '11月',
              '12月',
            ],
            dddd: [
              '星期日',
              '星期一',
              '星期二',
              '星期三',
              '星期四',
              '星期五',
              '星期六',
            ],
            ddd: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            dd: ['日', '一', '二', '三', '四', '五', '六'],
            A: ['早上', '上午', '中午', '下午', '晚上'],
            formatter: {
              A: function (e) {
                var t = 100 * e.getHours() + e.getMinutes()
                return t < 900
                  ? this.A[0]
                  : t < 1130
                  ? this.A[1]
                  : t < 1230
                  ? this.A[2]
                  : t < 1800
                  ? this.A[3]
                  : this.A[4]
              },
            },
            parser: {
              h: function (e, t) {
                return t < 3 ? e : 11 < e ? e : e + 12
              },
            },
          })
        }
        'object' == typeof n && 'object' == typeof n.exports
          ? t(i(1))
          : ((a = [i(1)]),
            void 0 === (s = 'function' == typeof (r = t) ? r.apply(o, a) : r) ||
              (n.exports = s))
      })()
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t) {
      e.exports = { typings: '../../typings.d.ts' }
    },
    function (e, t, n) {
      'use strict'
      Object.defineProperty(t, '__esModule', { value: !0 })
      var i = n(118),
        r = n(119),
        a = n(7),
        o = (n.n(a), n(1)),
        s = n.n(o),
        u = n(129),
        c = n(332),
        d = n(339),
        l = n(342),
        f = n(343),
        h = n(344),
        m = n(345),
        p = function (e, t) {
          if (Array.isArray(e)) return e
          if (Symbol.iterator in Object(e))
            return (function sliceIterator(e, t) {
              var n = [],
                o = !0,
                i = !1,
                r = void 0
              try {
                for (
                  var a, s = e[Symbol.iterator]();
                  !(o = (a = s.next()).done) &&
                  (n.push(a.value), !t || n.length !== t);
                  o = !0
                );
              } catch (e) {
                ;(i = !0), (r = e)
              } finally {
                try {
                  !o && s.return && s.return()
                } finally {
                  if (i) throw r
                }
              }
              return n
            })(e, t)
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance',
          )
        },
        v =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t]
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o])
            }
            return e
          },
        g = (function () {
          function defineProperties(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n]
              ;(o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                'value' in o && (o.writable = !0),
                Object.defineProperty(e, o.key, o)
            }
          }
          return function (e, t, n) {
            return (
              t && defineProperties(e.prototype, t),
              n && defineProperties(e, n),
              e
            )
          }
        })()
      var b = (function (e) {
        function bulmaCalendar(e) {
          var t =
            1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}
          !(function _classCallCheck(e, t) {
            if (!(e instanceof t))
              throw new TypeError('Cannot call a class as a function')
          })(this, bulmaCalendar)
          var n = (function _possibleConstructorReturn(e, t) {
            if (!e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called",
              )
            return !t || ('object' != typeof t && 'function' != typeof t)
              ? e
              : t
          })(
            this,
            (
              bulmaCalendar.__proto__ || Object.getPrototypeOf(bulmaCalendar)
            ).call(this),
          )
          if (
            ((n.element = r.e(e) ? document.querySelector(e) : e), !n.element)
          )
            throw new Error(
              'An invalid selector or non-DOM node has been provided.',
            )
          ;(n._clickEvents = ['click', 'touch']), (n._supportsPassive = i.a())
          var o = n.element.dataset
            ? Object.keys(n.element.dataset)
                .filter(function (e) {
                  return Object.keys(l.a).includes(e)
                })
                .reduce(function (e, t) {
                  return v(
                    {},
                    e,
                    (function _defineProperty(e, t, n) {
                      return (
                        t in e
                          ? Object.defineProperty(e, t, {
                              value: n,
                              enumerable: !0,
                              configurable: !0,
                              writable: !0,
                            })
                          : (e[t] = n),
                        e
                      )
                    })({}, t, n.element.dataset[t]),
                  )
                }, {})
            : {}
          if (((n.options = v({}, l.a, t, o)), void 0 === n.options.type))
            switch (n.element.getAttribute('type')) {
              case 'date':
                n.options.type = 'date'
                break
              case 'time':
                n.options.type = 'time'
                break
              default:
                n.options.type = 'datetime'
            }
          return (
            (n._id = i.b('datetimePicker')),
            (n.onToggleDateTimePicker = n.onToggleDateTimePicker.bind(n)),
            (n.onCloseDateTimePicker = n.onCloseDateTimePicker.bind(n)),
            (n.onDocumentClickDateTimePicker =
              n.onDocumentClickDateTimePicker.bind(n)),
            (n.onValidateClickDateTimePicker =
              n.onValidateClickDateTimePicker.bind(n)),
            (n.onTodayClickDateTimePicker =
              n.onTodayClickDateTimePicker.bind(n)),
            (n.onClearClickDateTimePicker =
              n.onClearClickDateTimePicker.bind(n)),
            (n.onCancelClickDateTimePicker =
              n.onCancelClickDateTimePicker.bind(n)),
            (n.onSelectDateTimePicker = n.onSelectDateTimePicker.bind(n)),
            n._init(),
            n
          )
        }
        return (
          (function _inherits(e, t) {
            if ('function' != typeof t && null !== t)
              throw new TypeError(
                'Super expression must either be null or a function, not ' +
                  typeof t,
              )
            ;(e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
              t &&
                (Object.setPrototypeOf
                  ? Object.setPrototypeOf(e, t)
                  : (e.__proto__ = t))
          })(bulmaCalendar, u['a']),
          g(
            bulmaCalendar,
            [
              {
                key: 'onSelectDateTimePicker',
                value: function onSelectDateTimePicker(e) {
                  this.refresh(),
                    this.save(),
                    'select' === e.type &&
                      this.options.closeOnSelect &&
                      'inline' !== this.options.displayMode &&
                      this.hide(),
                    this.emit(e.type, this)
                },
              },
              {
                key: 'onDocumentClickDateTimePicker',
                value: function onDocumentClickDateTimePicker(e) {
                  var t = e.target || e.srcElement
                  !this._ui.wrapper.contains(t) &&
                    'inline' !== this.options.displayMode &&
                    this._open &&
                    this.onCloseDateTimePicker(e)
                },
              },
              {
                key: 'onToggleDateTimePicker',
                value: function onToggleDateTimePicker(e) {
                  this._supportsPassive || e.preventDefault(),
                    e.stopPropagation(),
                    this._open ? this.hide() : this.show()
                },
              },
              {
                key: 'onValidateClickDateTimePicker',
                value: function onValidateClickDateTimePicker(e) {
                  this._supportsPassive || e.preventDefault(),
                    e.stopPropagation(),
                    this.save(),
                    this.emit('select', this),
                    'inline' !== this.options.displayMode &&
                      this.onCloseDateTimePicker(e)
                },
              },
              {
                key: 'onTodayClickDateTimePicker',
                value: function onTodayClickDateTimePicker(e) {
                  this._supportsPassive || e.preventDefault(),
                    e.stopPropagation(),
                    this.datePicker.value(new Date()),
                    this.datePicker.refresh(),
                    this.timePicker.value(new Date()),
                    this.timePicker.refresh(),
                    this.save()
                },
              },
              {
                key: 'onClearClickDateTimePicker',
                value: function onClearClickDateTimePicker(e) {
                  this._supportsPassive || e.preventDefault(),
                    e.stopPropagation(),
                    this.clear(),
                    this.emit('clear', this)
                },
              },
              {
                key: 'onCancelClickDateTimePicker',
                value: function onCancelClickDateTimePicker(e) {
                  this._supportsPassive || e.preventDefault(),
                    e.stopPropagation(),
                    this._snapshots.length &&
                      ((this.datePicker = this._snapshots[0].datePicker),
                      (this.timePicker = this._snapshots[0].timePicker)),
                    this.save(),
                    'inline' !== this.options.displayMode &&
                      this.onCloseDateTimePicker(e)
                },
              },
              {
                key: 'onCloseDateTimePicker',
                value: function onCloseDateTimePicker(e) {
                  this._supportsPassive || e.preventDefault(),
                    e.stopPropagation(),
                    this.hide()
                },
              },
              {
                key: 'isRange',
                value: function isRange() {
                  return this.options.isRange
                },
              },
              {
                key: 'isOpen',
                value: function isOpen() {
                  return this._open
                },
              },
              {
                key: 'value',
                value: function value() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : null
                  if (!e) {
                    var t = ''
                    switch (this.options.type) {
                      case 'date':
                        t = this.datePicker.value()
                        break
                      case 'time':
                        t = this.timePicker.value()
                        break
                      case 'datetime':
                        var n = this.datePicker.start
                            ? a.getTime(
                                a.addMinutes(
                                  a.addHours(
                                    this.datePicker.start,
                                    a.getHours(this.timePicker.start),
                                  ),
                                  a.getMinutes(this.timePicker.start),
                                ),
                              )
                            : void 0,
                          o = this.datePicker.end
                            ? a.getTime(this.datePicker.end)
                            : void 0
                        o &&
                          this.options.isRange &&
                          (o = a.getTime(
                            a.addMinutes(
                              a.addHours(
                                this.datePicker.end,
                                a.getHours(this.timePicker.end),
                              ),
                              a.getMinutes(this.timePicker.end),
                            ),
                          )),
                          (t = n
                            ? a.format(new Date(n), this.format, {
                                locale: this.locale,
                              })
                            : ''),
                          o &&
                            (t +=
                              ' - ' +
                              (o
                                ? a.format(new Date(o), this.format, {
                                    locale: this.locale,
                                  })
                                : ''))
                    }
                    return t
                  }
                  this.datePicker.value(e), this.timePicker.value(e)
                },
              },
              {
                key: 'refresh',
                value: function refresh() {
                  ;(this._ui.header.start.day.innerHTML = this.datePicker.start
                    ? a.format(this.datePicker.start, 'DD', {
                        locale: this.locale,
                      })
                    : '--'),
                    (this._ui.header.start.month.innerHTML = this.datePicker
                      .start
                      ? a.format(this.datePicker.start, 'MMMM YYYY', {
                          locale: this.locale,
                        })
                      : ''),
                    this.datePicker.start
                      ? (this._ui.header.start.weekday.classList.remove(
                          'is-hidden',
                        ),
                        (this._ui.header.start.weekday.innerHTML = this
                          .datePicker.start
                          ? a.format(this.datePicker.start, 'dddd', {
                              locale: this.locale,
                            })
                          : ''))
                      : this._ui.header.start.weekday.classList.add(
                          'is-hidden',
                        ),
                    this._ui.header.start.hour &&
                      (this._ui.header.start.hour.innerHTML = this.timePicker
                        .start
                        ? a.format(this.timePicker.start, 'HH:mm', {
                            locale: this.locale,
                          })
                        : '--:--'),
                    this._ui.header.end &&
                      ((this._ui.header.end.day.innerHTML =
                        this.options.isRange && this.datePicker.end
                          ? a.format(this.datePicker.end, 'DD', {
                              locale: this.locale,
                            })
                          : '--'),
                      (this._ui.header.end.month.innerHTML =
                        this.options.isRange && this.datePicker.end
                          ? a.format(this.datePicker.end, 'MMMM YYYY', {
                              locale: this.locale,
                            })
                          : ''),
                      this.datePicker.end
                        ? (this._ui.header.end.weekday.classList.remove(
                            'is-hidden',
                          ),
                          (this._ui.header.end.weekday.innerHTML = this
                            .datePicker.end
                            ? a.format(this.datePicker.end, 'dddd', {
                                locale: this.locale,
                              })
                            : ''))
                        : this._ui.header.end.weekday.classList.add(
                            'is-hidden',
                          ),
                      this._ui.header.end &&
                        this._ui.header.end.hour &&
                        (this._ui.header.end.hour.innerHTML = this.timePicker
                          .end
                          ? a.format(this.timePicker.end, 'HH:mm', {
                              locale: this.locale,
                            })
                          : '--:--')),
                    this.emit('refresh', this)
                },
              },
              {
                key: 'clear',
                value: function clear() {
                  this.datePicker.clear(),
                    this.timePicker.clear(),
                    this.refresh(),
                    (this.element.value = ''),
                    (this._ui.dummy.dummy_1.value = ''),
                    this._ui.dummy.dummy_2 &&
                      (this._ui.dummy.dummy_2.value = ''),
                    this.emit('clear', this)
                },
              },
              {
                key: 'show',
                value: function show() {
                  ;(this._snapshots = []),
                    this.snapshot(),
                    this.element.value &&
                      (this.datePicker.value(this.element.value),
                      this.timePicker.value(this.element.value)),
                    this.datePicker.show(),
                    this.timePicker.hide(),
                    this._ui.modal && this._ui.modal.classList.add('is-active'),
                    this._ui.wrapper.classList.add('is-active'),
                    (this._open = !0),
                    this.emit('show', this)
                },
              },
              {
                key: 'hide',
                value: function hide() {
                  ;(this._open = !1),
                    (this._focus = !1),
                    this._ui.modal &&
                      this._ui.modal.classList.remove('is-active'),
                    this._ui.wrapper.classList.remove('is-active'),
                    this.emit('hide', this)
                },
              },
              {
                key: 'save',
                value: function save() {
                  var e = this.value(),
                    t = e.split(' - '),
                    n = p(t, 2),
                    o = n[0],
                    i = n[1]
                  ;(this.element.value = e),
                    (this._ui.dummy.dummy_1.value = o || ''),
                    this._ui.dummy.dummy_2 &&
                      (this._ui.dummy.dummy_2.value = i || '')
                },
              },
              { key: 'snapshot', value: function snapshot() {} },
              {
                key: 'destroy',
                value: function destroy() {
                  this._ui.wrapper.remove()
                },
              },
              {
                key: '_init',
                value: function _init() {
                  ;(this._open = !1),
                    (this._snapshots = []),
                    (this._type =
                      -1 <
                      ['date', 'time', 'datetime'].indexOf(
                        this.options.type.toLowerCase(),
                      )
                        ? this.options.type.toLowerCase()
                        : 'date'),
                    this.element.setAttribute('type', 'text'),
                    (this.datePicker = new c.a(
                      v({}, this.options, { lang: this.lang }),
                    )),
                    (this.timePicker = new d.a(
                      v({}, this.options, { lang: this.lang }),
                    )),
                    this.element.value &&
                      (this.datePicker.value(this.element.value),
                      this.timePicker.value(this.element.value)),
                    (this.lang = this.options.lang),
                    (this.format =
                      'date' === this._type
                        ? this.options.dateFormat
                        : 'time' === this._type
                        ? this.options.timeFormat
                        : this.options.dateFormat +
                          ' ' +
                          this.options.timeFormat),
                    'default' === this.options.displayMode &&
                      window.matchMedia('screen and (max-width: 768px)')
                        .matches &&
                      (this.options.displayMode = 'dialog'),
                    window.matchMedia('screen and (max-width: 768px)')
                      .matches &&
                      ('default' === this.options.displayMode &&
                        (this.options.displayMode = 'dialog'),
                      (this.options.displayDual = !1)),
                    this._build(),
                    this._bindEvents(),
                    this.save(),
                    r.c(this.options.onReady) &&
                      this.on('ready', this.options.onReady),
                    this.emit('ready', this)
                },
              },
              {
                key: '_build',
                value: function _build() {
                  var e = document.createRange().createContextualFragment(
                      Object(h.a)(
                        v({}, this.options, {
                          type: this._type,
                          datePicker: 'time' !== this.options.type,
                          timePicker: 'date' !== this.options.type,
                        }),
                      ),
                    ),
                    t = document
                      .createRange()
                      .createContextualFragment(Object(m.a)(this.options)),
                    n = document
                      .createRange()
                      .createContextualFragment(
                        Object(f.a)(v({}, this.options, { id: this.id })),
                      )
                  switch (
                    ((this._ui = {
                      modal: n.querySelector('.modal'),
                      wrapper: n.querySelector('.datetimepicker'),
                      container: n.querySelector('.datetimepicker-container'),
                      dummy: {
                        container: n.querySelector('.datetimepicker-dummy'),
                        wrapper: n.querySelector(
                          '.datetimepicker-dummy-wrapper',
                        ),
                        dummy_1: n.querySelector(
                          '.datetimepicker-dummy .datetimepicker-dummy-input:nth-child(1)',
                        ),
                        dummy_2: n.querySelector(
                          '.datetimepicker-dummy .datetimepicker-dummy-input:nth-child(2)',
                        ),
                        clear: n.querySelector(
                          '.datetimepicker-dummy .datetimepicker-clear-button',
                        ),
                      },
                      calendar: n.querySelector('.datetimepicker'),
                      overlay:
                        'dialog' === this.options.displayMode
                          ? {
                              background: n.querySelector('.modal-background'),
                              close: n.querySelector('.modal-close'),
                            }
                          : void 0,
                      header: {
                        container: e.querySelector('.datetimepicker-header'),
                        start: {
                          container: e.querySelector(
                            '.datetimepicker-selection-start',
                          ),
                          day: e.querySelector(
                            '.datetimepicker-selection-start .datetimepicker-selection-day',
                          ),
                          month: e.querySelector(
                            '.datetimepicker-selection-start .datetimepicker-selection-month',
                          ),
                          weekday: e.querySelector(
                            '.datetimepicker-selection-start .datetimepicker-selection-weekday',
                          ),
                          hour: e.querySelector(
                            '.datetimepicker-selection-start .datetimepicker-selection-hour',
                          ),
                          empty: e.querySelector(
                            '.datetimepicker-selection-start .empty',
                          ),
                        },
                        end: this.options.isRange
                          ? {
                              container: e.querySelector(
                                '.datetimepicker-selection-end',
                              ),
                              day: e.querySelector(
                                '.datetimepicker-selection-end .datetimepicker-selection-day',
                              ),
                              month: e.querySelector(
                                '.datetimepicker-selection-end .datetimepicker-selection-month',
                              ),
                              weekday: e.querySelector(
                                '.datetimepicker-selection-end .datetimepicker-selection-weekday',
                              ),
                              hour: e.querySelector(
                                '.datetimepicker-selection-end .datetimepicker-selection-hour',
                              ),
                              empty: e.querySelector(
                                '.datetimepicker-selection-start .empty',
                              ),
                            }
                          : void 0,
                      },
                      footer: {
                        container: t.querySelector('.datetimepicker-footer'),
                        validate: t.querySelector(
                          '.datetimepicker-footer-validate',
                        ),
                        today: t.querySelector('.datetimepicker-footer-today'),
                        clear: t.querySelector('.datetimepicker-footer-clear'),
                        cancel: t.querySelector(
                          '.datetimepicker-footer-cancel',
                        ),
                      },
                    }),
                    r.a(this.options.showHeader) ||
                      this._ui.header.container.classList.add('is-hidden'),
                    r.a(this.options.showFooter) ||
                      this._ui.footer.container.classList.add('is-hidden'),
                    r.a(this.options.showTodayButton) ||
                      this._ui.footer.today.classList.add('is-hidden'),
                    r.a(this.options.showClearButton) ||
                      this._ui.footer.clear.classList.add('is-hidden'),
                    this.options.closeOnSelect &&
                      this._ui.footer.validate &&
                      this._ui.footer.validate.classList.add('is-hidden'),
                    this._ui.container.appendChild(e),
                    this._type)
                  ) {
                    case 'date':
                      this._ui.container.appendChild(this.datePicker.render())
                      break
                    case 'time':
                      this._ui.container.appendChild(this.timePicker.render()),
                        this._ui.footer.validate &&
                          this._ui.footer.validate.classList.remove(
                            'is-hidden',
                          ),
                        this._ui.footer.today &&
                          this._ui.footer.today.classList.add('is-hidden')
                      break
                    case 'datetime':
                      ;(this.options.closeOnSelect = !1),
                        this._ui.footer.validate &&
                          this._ui.footer.validate.classList.remove(
                            'is-hidden',
                          ),
                        this._ui.container.appendChild(
                          this.datePicker.render(),
                        ),
                        this._ui.container.appendChild(this.timePicker.render())
                  }
                  this._ui.wrapper.appendChild(t),
                    this._ui.wrapper.classList.add('is-' + this.options.color),
                    this._ui.dummy.container.classList.add(
                      'is-' + this.options.color,
                    ),
                    this.element.parentNode.insertBefore(
                      n,
                      this.element.nextSibling,
                    ),
                    this._ui.dummy.wrapper.appendChild(this.element),
                    this.element.classList.add('is-hidden'),
                    'inline' === this.options.displayMode
                      ? this._ui.wrapper.classList.add('is-active')
                      : (this._ui.dummy.container.classList.remove('is-hidden'),
                        (this._ui.wrapper.style.position = 'absolute'),
                        this._ui.wrapper.classList.add(
                          'is-datetimepicker-default',
                        )),
                    this.refresh()
                },
              },
              {
                key: '_bindEvents',
                value: function _bindEvents() {
                  var t = this
                  this._clickEvents.forEach(function (e) {
                    document.body.addEventListener(
                      e,
                      t.onDocumentClickDateTimePicker,
                    )
                  }),
                    this.datePicker.on('select', this.onSelectDateTimePicker),
                    this.datePicker.on(
                      'select:start',
                      this.onSelectDateTimePicker,
                    ),
                    this.datePicker.on(
                      'select:end',
                      this.onSelectDateTimePicker,
                    ),
                    this.timePicker.on('select', this.onSelectDateTimePicker),
                    this.timePicker.on(
                      'select:start',
                      this.onSelectDateTimePicker,
                    ),
                    this.timePicker.on(
                      'select:end',
                      this.onSelectDateTimePicker,
                    ),
                    !0 === this.options.toggleOnInputClick &&
                      this._clickEvents.forEach(function (e) {
                        t._ui.dummy.wrapper.addEventListener(
                          e,
                          t.onToggleDateTimePicker,
                        ),
                          t.element.addEventListener(
                            e,
                            t.onToggleDateTimePicker,
                          )
                      }),
                    'dialog' === this.options.displayMode &&
                      this._ui.overlay &&
                      (this._ui.overlay.close &&
                        this._clickEvents.forEach(function (e) {
                          t.this._ui.overlay.close.addEventListener(
                            e,
                            t.onCloseDateTimePicker,
                          )
                        }),
                      this.options.closeOnOverlayClick &&
                        this._ui.overlay.background &&
                        this._clickEvents.forEach(function (e) {
                          t._ui.overlay.background.addEventListener(
                            e,
                            t.onCloseDateTimePicker,
                          )
                        })),
                    this._ui.footer.validate &&
                      this._clickEvents.forEach(function (e) {
                        t._ui.footer.validate.addEventListener(
                          e,
                          t.onValidateClickDateTimePicker,
                        )
                      }),
                    this._ui.footer.today &&
                      this._clickEvents.forEach(function (e) {
                        t._ui.footer.today.addEventListener(
                          e,
                          t.onTodayClickDateTimePicker,
                        )
                      }),
                    this._ui.footer.clear &&
                      this._clickEvents.forEach(function (e) {
                        t._ui.footer.clear.addEventListener(
                          e,
                          t.onClearClickDateTimePicker,
                        )
                      }),
                    this._clickEvents.forEach(function (e) {
                      t._ui.dummy.clear.addEventListener(
                        e,
                        t.onClearClickDateTimePicker,
                      )
                    }),
                    this._ui.footer.cancel &&
                      this._clickEvents.forEach(function (e) {
                        t._ui.footer.cancel.addEventListener(
                          e,
                          t.onCancelClickDateTimePicker,
                        )
                      })
                },
              },
              {
                key: 'id',
                get: function get() {
                  return this._id
                },
              },
              {
                key: 'lang',
                set: function set() {
                  var t =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : 'en'
                  try {
                    this._locale = n(84)('./' + t)
                  } catch (e) {
                    ;(t = 'en'), (this._locale = n(84)('./' + t))
                  } finally {
                    return (
                      (this._lang = t),
                      (this.datePicker.lang = t),
                      (this.timePicker.lang = t),
                      this
                    )
                  }
                },
                get: function get() {
                  return this._lang
                },
              },
              {
                key: 'locale',
                get: function get() {
                  return this._locale
                },
              },
              {
                key: 'format',
                set: function set(e) {
                  return (this._format = e), this
                },
                get: function get() {
                  return this._format
                },
              },
              {
                key: 'date',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : null
                  return (this.datePicker.date = e), this
                },
                get: function get() {
                  return this.datePicker.date
                },
              },
              {
                key: 'startDate',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (
                    (this.datePicker.start = s.a.parse(e, this.dateFormat)),
                    this
                  )
                },
                get: function get() {
                  return this.datePicker.start
                },
              },
              {
                key: 'endDate',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (
                    (this.datePicker.end = s.a.parse(e, this.dateFormat)), this
                  )
                },
                get: function get() {
                  return this.datePicker.end
                },
              },
              {
                key: 'minDate',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (
                    (this.datePicker.minDate = s.a.parse(e, this.dateFormat)),
                    this
                  )
                },
                get: function get() {
                  return this.datePicker.minDate
                },
              },
              {
                key: 'maxDate',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (
                    (this.datePicker.maxDate = s.a.parse(e, this.dateFormat)),
                    this
                  )
                },
                get: function get() {
                  return this.datePicker.maxDate
                },
              },
              {
                key: 'dateFormat',
                set: function set(e) {
                  return (this.datePicker.dateFormat = e), this
                },
                get: function get() {
                  return this.datePicker.dateFormat
                },
              },
              {
                key: 'time',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : null
                  return (this.timePicker.time = e), this
                },
                get: function get() {
                  return this.timePicker.time
                },
              },
              {
                key: 'startTime',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (this.timePicker.start = e), this
                },
                get: function get() {
                  return this.timePicker.start
                },
              },
              {
                key: 'endTime',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (this.timePicker.end = e), this
                },
                get: function get() {
                  return this.timePicker.end
                },
              },
              {
                key: 'minTime',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (this.timePicker.minTime = e), this
                },
                get: function get() {
                  return this.timePicker.minTime
                },
              },
              {
                key: 'maxTime',
                set: function set() {
                  var e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                  return (this.timePicker.maxTime = e), this
                },
                get: function get() {
                  return this.timePicker.maxTime
                },
              },
              {
                key: 'timeFormat',
                set: function set(e) {
                  return (this.timePicker.dateFormat = e), this
                },
                get: function get() {
                  return this.timePicker.timeFormat
                },
              },
            ],
            [
              {
                key: 'attach',
                value: function attach() {
                  var n = this,
                    e =
                      0 < arguments.length && void 0 !== arguments[0]
                        ? arguments[0]
                        : 'input[type="date"]',
                    o =
                      1 < arguments.length && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    i = new Array(),
                    t = r.e(e)
                      ? document.querySelectorAll(e)
                      : Array.isArray(e)
                      ? e
                      : [e]
                  return (
                    [].forEach.call(t, function (e) {
                      if (void 0 === e[n.constructor.name]) {
                        var t = new bulmaCalendar(e, o)
                        ;(e.bulmaCalendar = t), i.push(t)
                      } else i.push(e[n.constructor.name])
                    }),
                    i
                  )
                },
              },
            ],
          ),
          bulmaCalendar
        )
      })()
      t.default = b
    },
    function (e, t, n) {
      var u = n(0)
      e.exports = function areRangesOverlapping(e, t, n, o) {
        var i = u(e).getTime(),
          r = u(t).getTime(),
          a = u(n).getTime(),
          s = u(o).getTime()
        if (r < i || s < a)
          throw new Error(
            'The start of the range cannot be after the end of the range',
          )
        return i < s && a < r
      }
    },
    function (e, t, n) {
      var s = n(0)
      e.exports = function closestIndexTo(e, t) {
        if (!(t instanceof Array))
          throw new TypeError(toString.call(t) + ' is not an instance of Array')
        var i,
          r,
          a = s(e).getTime()
        return (
          t.forEach(function (e, t) {
            var n = s(e),
              o = Math.abs(a - n.getTime())
            ;(void 0 === i || o < r) && ((i = t), (r = o))
          }),
          i
        )
      }
    },
    function (e, t, n) {
      var a = n(0)
      e.exports = function closestTo(e, t) {
        if (!(t instanceof Array))
          throw new TypeError(toString.call(t) + ' is not an instance of Array')
        var o,
          i,
          r = a(e).getTime()
        return (
          t.forEach(function (e) {
            var t = a(e),
              n = Math.abs(r - t.getTime())
            ;(void 0 === o || n < i) && ((o = t), (i = n))
          }),
          o
        )
      }
    },
    function (e, t, n) {
      var a = n(4)
      e.exports = function differenceInCalendarISOWeeks(e, t) {
        var n = a(e),
          o = a(t),
          i = n.getTime() - 6e4 * n.getTimezoneOffset(),
          r = o.getTime() - 6e4 * o.getTimezoneOffset()
        return Math.round((i - r) / 6048e5)
      }
    },
    function (e, t, n) {
      var i = n(139),
        r = n(0)
      e.exports = function differenceInCalendarQuarters(e, t) {
        var n = r(e),
          o = r(t)
        return 4 * (n.getFullYear() - o.getFullYear()) + (i(n) - i(o))
      }
    },
    function (e, t, n) {
      var s = n(80)
      e.exports = function differenceInCalendarWeeks(e, t, n) {
        var o = s(e, n),
          i = s(t, n),
          r = o.getTime() - 6e4 * o.getTimezoneOffset(),
          a = i.getTime() - 6e4 * i.getTimezoneOffset()
        return Math.round((r - a) / 6048e5)
      }
    },
    function (e, t, n) {
      var o = n(83)
      e.exports = function differenceInHours(e, t) {
        var n = o(e, t) / 36e5
        return 0 < n ? Math.floor(n) : Math.ceil(n)
      }
    },
    function (e, t, n) {
      var a = n(0),
        s = n(137),
        u = n(11),
        c = n(142)
      e.exports = function differenceInISOYears(e, t) {
        var n = a(e),
          o = a(t),
          i = u(n, o),
          r = Math.abs(s(n, o))
        return (n = c(n, i * r)), i * (r - (u(n, o) === -i))
      }
    },
    function (e, t, n) {
      var o = n(83)
      e.exports = function differenceInMinutes(e, t) {
        var n = o(e, t) / 6e4
        return 0 < n ? Math.floor(n) : Math.ceil(n)
      }
    },
    function (e, t, n) {
      var o = n(124)
      e.exports = function differenceInQuarters(e, t) {
        var n = o(e, t) / 3
        return 0 < n ? Math.floor(n) : Math.ceil(n)
      }
    },
    function (e, t, n) {
      var o = n(141)
      e.exports = function differenceInWeeks(e, t) {
        var n = o(e, t) / 7
        return 0 < n ? Math.floor(n) : Math.ceil(n)
      }
    },
    function (e, t, n) {
      var a = n(0),
        s = n(140),
        u = n(11)
      e.exports = function differenceInYears(e, t) {
        var n = a(e),
          o = a(t),
          i = u(n, o),
          r = Math.abs(s(n, o))
        return (
          n.setFullYear(n.getFullYear() - i * r), i * (r - (u(n, o) === -i))
        )
      }
    },
    function (e, t, n) {
      var p = n(123),
        v = n(0),
        g = n(125),
        b = n(6)
      e.exports = function distanceInWordsStrict(e, t, n) {
        var o = n || {},
          i = p(e, t),
          r = o.locale,
          a = b.distanceInWords.localize
        r &&
          r.distanceInWords &&
          r.distanceInWords.localize &&
          (a = r.distanceInWords.localize)
        var s,
          u,
          c,
          d = { addSuffix: Boolean(o.addSuffix), comparison: i }
        u = 0 < i ? ((s = v(e)), v(t)) : ((s = v(t)), v(e))
        var l = Math[o.partialMethod ? String(o.partialMethod) : 'floor'],
          f = g(u, s),
          h = u.getTimezoneOffset() - s.getTimezoneOffset(),
          m = l(f / 60) - h
        if (
          's' ===
          (c = o.unit
            ? String(o.unit)
            : m < 1
            ? 's'
            : m < 60
            ? 'm'
            : m < 1440
            ? 'h'
            : m < 43200
            ? 'd'
            : m < 525600
            ? 'M'
            : 'Y')
        )
          return a('xSeconds', f, d)
        if ('m' === c) return a('xMinutes', m, d)
        if ('h' === c) return a('xHours', l(m / 60), d)
        if ('d' === c) return a('xDays', l(m / 1440), d)
        if ('M' === c) return a('xMonths', l(m / 43200), d)
        if ('Y' === c) return a('xYears', l(m / 525600), d)
        throw new Error('Unknown unit: ' + c)
      }
    },
    function (e, t, n) {
      var o = n(143)
      e.exports = function distanceInWordsToNow(e, t) {
        return o(Date.now(), e, t)
      }
    },
    function (e, t, n) {
      var u = n(0)
      e.exports = function eachDay(e, t, n) {
        var o = u(e),
          i = void 0 !== n ? n : 1,
          r = u(t).getTime()
        if (o.getTime() > r)
          throw new Error('The first date cannot be after the second date')
        var a = [],
          s = o
        for (s.setHours(0, 0, 0, 0); s.getTime() <= r; )
          a.push(u(s)), s.setDate(s.getDate() + i)
        return a
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function endOfHour(e) {
        var t = o(e)
        return t.setMinutes(59, 59, 999), t
      }
    },
    function (e, t, n) {
      var o = n(144)
      e.exports = function endOfISOWeek(e) {
        return o(e, { weekStartsOn: 1 })
      }
    },
    function (e, t, n) {
      var i = n(3),
        r = n(4)
      e.exports = function endOfISOYear(e) {
        var t = i(e),
          n = new Date(0)
        n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0)
        var o = r(n)
        return o.setMilliseconds(o.getMilliseconds() - 1), o
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function endOfMinute(e) {
        var t = o(e)
        return t.setSeconds(59, 999), t
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function endOfQuarter(e) {
        var t = i(e),
          n = t.getMonth(),
          o = n - (n % 3) + 3
        return t.setMonth(o, 0), t.setHours(23, 59, 59, 999), t
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function endOfSecond(e) {
        var t = o(e)
        return t.setMilliseconds(999), t
      }
    },
    function (e, t, n) {
      var o = n(126)
      e.exports = function endOfToday() {
        return o(new Date())
      }
    },
    function (e, t) {
      e.exports = function endOfTomorrow() {
        var e = new Date(),
          t = e.getFullYear(),
          n = e.getMonth(),
          o = e.getDate(),
          i = new Date(0)
        return i.setFullYear(t, n, o + 1), i.setHours(23, 59, 59, 999), i
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function endOfYear(e) {
        var t = o(e),
          n = t.getFullYear()
        return t.setFullYear(n + 1, 0, 0), t.setHours(23, 59, 59, 999), t
      }
    },
    function (e, t) {
      e.exports = function endOfYesterday() {
        var e = new Date(),
          t = e.getFullYear(),
          n = e.getMonth(),
          o = e.getDate(),
          i = new Date(0)
        return i.setFullYear(t, n, o - 1), i.setHours(23, 59, 59, 999), i
      }
    },
    function (e, t, n) {
      var o = n(146),
        i = n(127),
        r = n(3),
        u = n(0),
        c = n(148),
        d = n(6)
      var l = {
        M: function (e) {
          return e.getMonth() + 1
        },
        MM: function (e) {
          return addLeadingZeros(e.getMonth() + 1, 2)
        },
        Q: function (e) {
          return Math.ceil((e.getMonth() + 1) / 3)
        },
        D: function (e) {
          return e.getDate()
        },
        DD: function (e) {
          return addLeadingZeros(e.getDate(), 2)
        },
        DDD: function (e) {
          return o(e)
        },
        DDDD: function (e) {
          return addLeadingZeros(o(e), 3)
        },
        d: function (e) {
          return e.getDay()
        },
        E: function (e) {
          return e.getDay() || 7
        },
        W: function (e) {
          return i(e)
        },
        WW: function (e) {
          return addLeadingZeros(i(e), 2)
        },
        YY: function (e) {
          return addLeadingZeros(e.getFullYear(), 4).substr(2)
        },
        YYYY: function (e) {
          return addLeadingZeros(e.getFullYear(), 4)
        },
        GG: function (e) {
          return String(r(e)).substr(2)
        },
        GGGG: function (e) {
          return r(e)
        },
        H: function (e) {
          return e.getHours()
        },
        HH: function (e) {
          return addLeadingZeros(e.getHours(), 2)
        },
        h: function (e) {
          var t = e.getHours()
          return 0 === t ? 12 : 12 < t ? t % 12 : t
        },
        hh: function (e) {
          return addLeadingZeros(l.h(e), 2)
        },
        m: function (e) {
          return e.getMinutes()
        },
        mm: function (e) {
          return addLeadingZeros(e.getMinutes(), 2)
        },
        s: function (e) {
          return e.getSeconds()
        },
        ss: function (e) {
          return addLeadingZeros(e.getSeconds(), 2)
        },
        S: function (e) {
          return Math.floor(e.getMilliseconds() / 100)
        },
        SS: function (e) {
          return addLeadingZeros(Math.floor(e.getMilliseconds() / 10), 2)
        },
        SSS: function (e) {
          return addLeadingZeros(e.getMilliseconds(), 3)
        },
        Z: function (e) {
          return formatTimezone(e.getTimezoneOffset(), ':')
        },
        ZZ: function (e) {
          return formatTimezone(e.getTimezoneOffset())
        },
        X: function (e) {
          return Math.floor(e.getTime() / 1e3)
        },
        x: function (e) {
          return e.getTime()
        },
      }
      function formatTimezone(e, t) {
        t = t || ''
        var n = 0 < e ? '-' : '+',
          o = Math.abs(e),
          i = o % 60
        return (
          n + addLeadingZeros(Math.floor(o / 60), 2) + t + addLeadingZeros(i, 2)
        )
      }
      function addLeadingZeros(e, t) {
        for (var n = Math.abs(e).toString(); n.length < t; ) n = '0' + n
        return n
      }
      e.exports = function format(e, t, n) {
        var o = t ? String(t) : 'YYYY-MM-DDTHH:mm:ss.SSSZ',
          i = (n || {}).locale,
          r = d.format.formatters,
          a = d.format.formattingTokensRegExp
        i &&
          i.format &&
          i.format.formatters &&
          ((r = i.format.formatters),
          i.format.formattingTokensRegExp &&
            (a = i.format.formattingTokensRegExp))
        var s = u(e)
        return c(s)
          ? (function buildFormatFn(e, t, n) {
              var o,
                i,
                r,
                a = e.match(n),
                s = a.length
              for (o = 0; o < s; o++)
                (i = t[a[o]] || l[a[o]]),
                  (a[o] =
                    i ||
                    ((r = a[o]).match(/\[[\s\S]/)
                      ? r.replace(/^\[|]$/g, '')
                      : r.replace(/\\/g, '')))
              return function (e) {
                for (var t = '', n = 0; n < s; n++)
                  a[n] instanceof Function ? (t += a[n](e, l)) : (t += a[n])
                return t
              }
            })(
              o,
              r,
              a,
            )(s)
          : 'Invalid Date'
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getDate(e) {
        return o(e).getDate()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getDay(e) {
        return o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(149)
      e.exports = function getDaysInYear(e) {
        return o(e) ? 366 : 365
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getHours(e) {
        return o(e).getHours()
      }
    },
    function (e, t, n) {
      var o = n(10),
        i = n(122)
      e.exports = function getISOWeeksInYear(e) {
        var t = o(e),
          n = o(i(t, 60)).valueOf() - t.valueOf()
        return Math.round(n / 6048e5)
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getMilliseconds(e) {
        return o(e).getMilliseconds()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getMinutes(e) {
        return o(e).getMinutes()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getMonth(e) {
        return o(e).getMonth()
      }
    },
    function (e, t, n) {
      var c = n(0)
      e.exports = function getOverlappingDaysInRanges(e, t, n, o) {
        var i = c(e).getTime(),
          r = c(t).getTime(),
          a = c(n).getTime(),
          s = c(o).getTime()
        if (r < i || s < a)
          throw new Error(
            'The start of the range cannot be after the end of the range',
          )
        if (!(i < s && a < r)) return 0
        var u = (r < s ? r : s) - (a < i ? i : a)
        return Math.ceil(u / 864e5)
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getSeconds(e) {
        return o(e).getSeconds()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getTime(e) {
        return o(e).getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function getYear(e) {
        return o(e).getFullYear()
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function isAfter(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() > o.getTime()
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function isBefore(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() < o.getTime()
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function isEqual(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() === o.getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isFirstDayOfMonth(e) {
        return 1 === o(e).getDate()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isFriday(e) {
        return 5 === o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isFuture(e) {
        return o(e).getTime() > new Date().getTime()
      }
    },
    function (e, t, n) {
      var o = n(0),
        i = n(126),
        r = n(145)
      e.exports = function isLastDayOfMonth(e) {
        var t = o(e)
        return i(t).getTime() === r(t).getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isMonday(e) {
        return 1 === o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isPast(e) {
        return o(e).getTime() < new Date().getTime()
      }
    },
    function (e, t, n) {
      var i = n(5)
      e.exports = function isSameDay(e, t) {
        var n = i(e),
          o = i(t)
        return n.getTime() === o.getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isSaturday(e) {
        return 6 === o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isSunday(e) {
        return 0 === o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(151)
      e.exports = function isThisHour(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(153)
      e.exports = function isThisISOWeek(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(154)
      e.exports = function isThisISOYear(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(155)
      e.exports = function isThisMinute(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(157)
      e.exports = function isThisMonth(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(158)
      e.exports = function isThisQuarter(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(160)
      e.exports = function isThisSecond(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(128)
      e.exports = function isThisWeek(e, t) {
        return o(new Date(), e, t)
      }
    },
    function (e, t, n) {
      var o = n(162)
      e.exports = function isThisYear(e) {
        return o(new Date(), e)
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isThursday(e) {
        return 4 === o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(5)
      e.exports = function isToday(e) {
        return o(e).getTime() === o(new Date()).getTime()
      }
    },
    function (e, t, n) {
      var o = n(5)
      e.exports = function isTomorrow(e) {
        var t = new Date()
        return t.setDate(t.getDate() + 1), o(e).getTime() === o(t).getTime()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isTuesday(e) {
        return 2 === o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isWednesday(e) {
        return 3 === o(e).getDay()
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function isWeekend(e) {
        var t = o(e).getDay()
        return 0 === t || 6 === t
      }
    },
    function (e, t, n) {
      var a = n(0)
      e.exports = function isWithinRange(e, t, n) {
        var o = a(e).getTime(),
          i = a(t).getTime(),
          r = a(n).getTime()
        if (r < i)
          throw new Error(
            'The start of the range cannot be after the end of the range',
          )
        return i <= o && o <= r
      }
    },
    function (e, t, n) {
      var o = n(5)
      e.exports = function isYesterday(e) {
        var t = new Date()
        return t.setDate(t.getDate() - 1), o(e).getTime() === o(t).getTime()
      }
    },
    function (e, t, n) {
      var o = n(163)
      e.exports = function lastDayOfISOWeek(e) {
        return o(e, { weekStartsOn: 1 })
      }
    },
    function (e, t, n) {
      var i = n(3),
        r = n(4)
      e.exports = function lastDayOfISOYear(e) {
        var t = i(e),
          n = new Date(0)
        n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0)
        var o = r(n)
        return o.setDate(o.getDate() - 1), o
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function lastDayOfMonth(e) {
        var t = o(e),
          n = t.getMonth()
        return (
          t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(0, 0, 0, 0), t
        )
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function lastDayOfQuarter(e) {
        var t = i(e),
          n = t.getMonth(),
          o = n - (n % 3) + 3
        return t.setMonth(o, 0), t.setHours(0, 0, 0, 0), t
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function lastDayOfYear(e) {
        var t = o(e),
          n = t.getFullYear()
        return t.setFullYear(n + 1, 0, 0), t.setHours(0, 0, 0, 0), t
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function max() {
        var e = Array.prototype.slice.call(arguments).map(function (e) {
            return o(e)
          }),
          t = Math.max.apply(null, e)
        return new Date(t)
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function min() {
        var e = Array.prototype.slice.call(arguments).map(function (e) {
            return o(e)
          }),
          t = Math.min.apply(null, e)
        return new Date(t)
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function setDate(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setDate(o), n
      }
    },
    function (e, t, n) {
      var s = n(0),
        u = n(8)
      e.exports = function setDay(e, t, n) {
        var o = (n && Number(n.weekStartsOn)) || 0,
          i = s(e),
          r = Number(t),
          a = i.getDay()
        return u(i, (((r % 7) + 7) % 7 < o ? 7 : 0) + r - a)
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function setDayOfYear(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setMonth(0), n.setDate(o), n
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function setHours(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setHours(o), n
      }
    },
    function (e, t, n) {
      var r = n(0),
        a = n(8),
        s = n(150)
      e.exports = function setISODay(e, t) {
        var n = r(e),
          o = Number(t),
          i = s(n)
        return a(n, o - i)
      }
    },
    function (e, t, n) {
      var r = n(0),
        a = n(127)
      e.exports = function setISOWeek(e, t) {
        var n = r(e),
          o = Number(t),
          i = a(n) - o
        return n.setDate(n.getDate() - 7 * i), n
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function setMilliseconds(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setMilliseconds(o), n
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function setMinutes(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setMinutes(o), n
      }
    },
    function (e, t, n) {
      var i = n(0),
        r = n(164)
      e.exports = function setQuarter(e, t) {
        var n = i(e),
          o = Number(t) - (Math.floor(n.getMonth() / 3) + 1)
        return r(n, n.getMonth() + 3 * o)
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function setSeconds(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setSeconds(o), n
      }
    },
    function (e, t, n) {
      var i = n(0)
      e.exports = function setYear(e, t) {
        var n = i(e),
          o = Number(t)
        return n.setFullYear(o), n
      }
    },
    function (e, t, n) {
      var o = n(0)
      e.exports = function startOfMonth(e) {
        var t = o(e)
        return t.setDate(1), t.setHours(0, 0, 0, 0), t
      }
    },
    function (e, t, n) {
      var o = n(5)
      e.exports = function startOfToday() {
        return o(new Date())
      }
    },
    function (e, t) {
      e.exports = function startOfTomorrow() {
        var e = new Date(),
          t = e.getFullYear(),
          n = e.getMonth(),
          o = e.getDate(),
          i = new Date(0)
        return i.setFullYear(t, n, o + 1), i.setHours(0, 0, 0, 0), i
      }
    },
    function (e, t) {
      e.exports = function startOfYesterday() {
        var e = new Date(),
          t = e.getFullYear(),
          n = e.getMonth(),
          o = e.getDate(),
          i = new Date(0)
        return i.setFullYear(t, n, o - 1), i.setHours(0, 0, 0, 0), i
      }
    },
    function (e, t, n) {
      var o = n(8)
      e.exports = function subDays(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(130)
      e.exports = function subHours(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(9)
      e.exports = function subMilliseconds(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(133)
      e.exports = function subMinutes(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(82)
      e.exports = function subMonths(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(134)
      e.exports = function subQuarters(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(135)
      e.exports = function subSeconds(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(122)
      e.exports = function subWeeks(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = n(136)
      e.exports = function subYears(e, t) {
        var n = Number(t)
        return o(e, -n)
      }
    },
    function (e, t, n) {
      var o = {
        './ar': 165,
        './ar.js': 165,
        './az': 166,
        './az.js': 166,
        './bn': 167,
        './bn.js': 167,
        './cs': 168,
        './cs.js': 168,
        './de': 169,
        './de.js': 169,
        './el': 170,
        './el.js': 170,
        './es': 171,
        './es.js': 171,
        './fa': 172,
        './fa.js': 172,
        './fr': 173,
        './fr.js': 173,
        './hi': 174,
        './hi.js': 174,
        './hu': 175,
        './hu.js': 175,
        './id': 176,
        './id.js': 176,
        './it': 177,
        './it.js': 177,
        './ja': 178,
        './ja.js': 178,
        './jv': 179,
        './jv.js': 179,
        './ko': 180,
        './ko.js': 180,
        './my': 181,
        './my.js': 181,
        './nl': 182,
        './nl.js': 182,
        './pa-in': 183,
        './pa-in.js': 183,
        './pl': 184,
        './pl.js': 184,
        './pt': 185,
        './pt.js': 185,
        './ro': 186,
        './ro.js': 186,
        './ru': 187,
        './ru.js': 187,
        './sr': 188,
        './sr.js': 188,
        './th': 189,
        './th.js': 189,
        './tr': 190,
        './tr.js': 190,
        './uk': 191,
        './uk.js': 191,
        './uz': 192,
        './uz.js': 192,
        './vi': 193,
        './vi.js': 193,
        './zh-cn': 194,
        './zh-cn.js': 194,
        './zh-tw': 195,
        './zh-tw.js': 195,
      }
      function webpackContext(e) {
        return n(webpackContextResolve(e))
      }
      function webpackContextResolve(e) {
        var t = o[e]
        if (!(t + 1)) throw new Error("Cannot find module '" + e + "'.")
        return t
      }
      ;(webpackContext.keys = function webpackContextKeys() {
        return Object.keys(o)
      }),
        (webpackContext.resolve = webpackContextResolve),
        ((e.exports = webpackContext).id = 331)
    },
    function (e, t, n) {
      'use strict'
      var o = n(118),
        c = n(119),
        d = n(7),
        i = (n.n(d), n(129)),
        r = n(333),
        a = n(334),
        s = n(335),
        u = n(336),
        l = n(337),
        f = n(338),
        h =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t]
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o])
            }
            return e
          },
        m = (function () {
          function defineProperties(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n]
              ;(o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                'value' in o && (o.writable = !0),
                Object.defineProperty(e, o.key, o)
            }
          }
          return function (e, t, n) {
            return (
              t && defineProperties(e.prototype, t),
              n && defineProperties(e, n),
              e
            )
          }
        })()
      var p = (function (e) {
        function datePicker() {
          var e =
            0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}
          !(function _classCallCheck(e, t) {
            if (!(e instanceof t))
              throw new TypeError('Cannot call a class as a function')
          })(this, datePicker)
          var t = (function _possibleConstructorReturn(e, t) {
            if (!e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called",
              )
            return !t || ('object' != typeof t && 'function' != typeof t)
              ? e
              : t
          })(
            this,
            (datePicker.__proto__ || Object.getPrototypeOf(datePicker)).call(
              this,
            ),
          )
          return (
            (t.options = h({}, f.a, e)),
            (t._clickEvents = ['click', 'touch']),
            (t._supportsPassive = o.a()),
            (t._id = o.b('datePicker')),
            (t.node = null),
            (t.onPreviousDatePicker = t.onPreviousDatePicker.bind(t)),
            (t.onNextDatePicker = t.onNextDatePicker.bind(t)),
            (t.onSelectMonthDatePicker = t.onSelectMonthDatePicker.bind(t)),
            (t.onMonthClickDatePicker = t.onMonthClickDatePicker.bind(t)),
            (t.onSelectYearDatePicker = t.onSelectYearDatePicker.bind(t)),
            (t.onYearClickDatePicker = t.onYearClickDatePicker.bind(t)),
            (t.onDateClickDatePicker = t.onDateClickDatePicker.bind(t)),
            t._init(),
            t
          )
        }
        return (
          (function _inherits(e, t) {
            if ('function' != typeof t && null !== t)
              throw new TypeError(
                'Super expression must either be null or a function, not ' +
                  typeof t,
              )
            ;(e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
              t &&
                (Object.setPrototypeOf
                  ? Object.setPrototypeOf(e, t)
                  : (e.__proto__ = t))
          })(datePicker, i['a']),
          m(datePicker, [
            {
              key: 'onPreviousDatePicker',
              value: function onPreviousDatePicker(e) {
                this._supportsPassive || e.preventDefault(), e.stopPropagation()
                var t = d.lastDayOfMonth(
                    d.subMonths(
                      new Date(
                        d.getYear(this._visibleDate),
                        d.getMonth(this._visibleDate),
                      ),
                      1,
                    ),
                  ),
                  n = Math.min(
                    d.getDaysInMonth(t),
                    d.getDate(this._visibleDate),
                  )
                ;(this._visibleDate = this.min
                  ? d.max(d.setDate(t, n), this.min)
                  : d.setDate(t, n)),
                  this.refresh()
              },
            },
            {
              key: 'onNextDatePicker',
              value: function onNextDatePicker(e) {
                this._supportsPassive || e.preventDefault(), e.stopPropagation()
                var t = d.addMonths(this._visibleDate, 1),
                  n = Math.min(
                    d.getDaysInMonth(t),
                    d.getDate(this._visibleDate),
                  )
                ;(this._visibleDate = this.max
                  ? d.min(d.setDate(t, n), this.max)
                  : d.setDate(t, n)),
                  this.refresh()
              },
            },
            {
              key: 'onSelectMonthDatePicker',
              value: function onSelectMonthDatePicker(e) {
                e.stopPropagation(),
                  this.options.enableMonthSwitch &&
                    (this._ui.body.dates.classList.remove('is-active'),
                    this._ui.body.years.classList.remove('is-active'),
                    this._ui.body.months.classList.add('is-active'),
                    this._ui.navigation.previous.setAttribute(
                      'disabled',
                      'disabled',
                    ),
                    this._ui.navigation.next.setAttribute(
                      'disabled',
                      'disabled',
                    ))
              },
            },
            {
              key: 'onSelectYearDatePicker',
              value: function onSelectYearDatePicker(e) {
                if ((e.stopPropagation(), this.options.enableYearSwitch)) {
                  this._ui.body.dates.classList.remove('is-active'),
                    this._ui.body.months.classList.remove('is-active'),
                    this._ui.body.years.classList.add('is-active'),
                    this._ui.navigation.previous.setAttribute(
                      'disabled',
                      'disabled',
                    ),
                    this._ui.navigation.next.setAttribute(
                      'disabled',
                      'disabled',
                    )
                  var t = this._ui.body.years.querySelector(
                    '.calendar-year.is-active',
                  )
                  t &&
                    (this._ui.body.years.scrollTop =
                      t.offsetTop -
                      this._ui.body.years.offsetTop -
                      this._ui.body.years.clientHeight / 2)
                }
              },
            },
            {
              key: 'onMonthClickDatePicker',
              value: function onMonthClickDatePicker(e) {
                this._supportsPassive || e.preventDefault(), e.stopPropagation()
                var t = d.setMonth(
                  this._visibleDate,
                  parseInt(e.currentTarget.dataset.month) - 1,
                )
                ;(this._visibleDate = this.min ? d.max(t, this.min) : t),
                  (this._visibleDate = this.max
                    ? d.min(this._visibleDate, this.max)
                    : this._visibleDate),
                  this.refresh()
              },
            },
            {
              key: 'onYearClickDatePicker',
              value: function onYearClickDatePicker(e) {
                this._supportsPassive || e.preventDefault(), e.stopPropagation()
                var t = d.setYear(
                  this._visibleDate,
                  parseInt(e.currentTarget.dataset.year),
                )
                ;(this._visibleDate = this.min ? d.max(t, this.min) : t),
                  (this._visibleDate = this.max
                    ? d.min(this._visibleDate, this.max)
                    : this._visibleDate),
                  this.refresh()
              },
            },
            {
              key: 'onDateClickDatePicker',
              value: function onDateClickDatePicker(e) {
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  e.currentTarget.classList.contains('is-disabled') ||
                    (this._select(e.currentTarget.dataset.date), this.refresh())
              },
            },
            {
              key: 'isRange',
              value: function isRange() {
                return this.options.isRange
              },
            },
            {
              key: 'enableDate',
              value: function enableDate() {
                var t =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0,
                  e = this.disabledDates.findIndex(function (e) {
                    return d.isEqual(e, t)
                  })
                ;-1 < e && unset(this.disabledDates[e])
              },
            },
            {
              key: 'disableDate',
              value: function disableDate() {
                var t =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : void 0
                ;-1 <
                  this.disabledDates.findIndex(function (e) {
                    return d.isEqual(e, t)
                  }) && this.disabledDates.push(t)
              },
            },
            {
              key: 'enableWeekDay',
              value: function enableWeekDay(t) {
                var e = this.disabledWeekDays.findIndex(function (e) {
                  return d.isEqual(e, t)
                })
                ;-1 < e && unset(this.disabledWeekDays[e])
              },
            },
            {
              key: 'disableWeekDay',
              value: function disableWeekDay(e) {
                ;-1 <
                  this.disabledWeekDays.findIndex(function (e) {
                    return d.isEqual(e, date)
                  }) && this.disabledWeekDays.push(e)
              },
            },
            {
              key: 'show',
              value: function show() {
                this._open ||
                  (this._ui.body.dates.classList.add('is-active'),
                  this._ui.body.months.classList.remove('is-active'),
                  this._ui.body.years.classList.remove('is-active'),
                  this._ui.navigation.previous.removeAttribute('disabled'),
                  this._ui.navigation.next.removeAttribute('disabled'),
                  this._ui.container.classList.add('is-active'),
                  (this._open = !0),
                  (this._focus = !0),
                  this.emit('show', this))
              },
            },
            {
              key: 'hide',
              value: function hide() {
                this._open &&
                  ((this._open = !1),
                  (this._focus = !1),
                  this._ui.container.classList.remove('is-active'),
                  this.emit('hide', this))
              },
            },
            {
              key: 'toggle',
              value: function toggle() {
                this._open ? this.hide() : this.show()
              },
            },
            {
              key: 'value',
              value: function value() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : null
                if (!e) {
                  var t =
                    this.start && this._isValidDate(this.start)
                      ? d.format(this.start, this.format, {
                          locale: this.locale,
                        })
                      : ''
                  return (
                    this.options.isRange &&
                      this.end &&
                      this._isValidDate(this.end) &&
                      (t +=
                        ' - ' +
                        d.format(this.end, this.format, {
                          locale: this.locale,
                        })),
                    t
                  )
                }
                if (this.options.isRange) {
                  if (c.e(e)) {
                    var n = e.split(' - ')
                    n.length &&
                      (this.start = d.format(new Date(n[0]), this.format, {
                        locale: this.locale,
                      })),
                      2 === n.length &&
                        (this.end = d.format(new Date(n[1]), this.format, {
                          locale: this.locale,
                        }))
                  }
                  ;(c.d(e) || c.b(e)) && this._select(e)
                } else this._select(e)
              },
            },
            {
              key: 'refresh',
              value: function refresh() {
                var n = this
                this._ui.body.dates.innerHTML = ''
                var e = new Array(12)
                  .fill(d.startOfWeek(this._visibleDate))
                  .map(function (e, t) {
                    return d.format(d.addMonths(e, t), 'MM', {
                      locale: n.locale,
                    })
                  })
                ;(this._ui.body.months.innerHTML = ''),
                  this._ui.body.months.appendChild(
                    document
                      .createRange()
                      .createContextualFragment(Object(u.a)({ months: e })),
                  ),
                  (
                    this._ui.body.months.querySelectorAll(
                      '.datepicker-month',
                    ) || []
                  ).forEach(function (t) {
                    n._clickEvents.forEach(function (e) {
                      t.addEventListener(e, n.onMonthClickDatePicker)
                    }),
                      t.classList.remove('is-active'),
                      t.dataset.month ===
                        d.format(n._visibleDate, 'MM', { locale: n.locale }) &&
                        t.classList.add('is-active')
                  })
                var t = new Array(100)
                  .fill(d.subYears(this._visibleDate, 50))
                  .map(function (e, t) {
                    return d.format(d.addYears(e, t), 'YYYY', {
                      locale: n.locale,
                    })
                  })
                ;(this._ui.body.years.innerHTML = ''),
                  this._ui.body.years.appendChild(
                    document.createRange().createContextualFragment(
                      Object(l.a)({
                        visibleDate: this._visibleDate,
                        years: t,
                      }),
                    ),
                  ),
                  (
                    this._ui.body.years.querySelectorAll('.datepicker-year') ||
                    []
                  ).forEach(function (t) {
                    n._clickEvents.forEach(function (e) {
                      t.addEventListener(e, n.onYearClickDatePicker)
                    }),
                      t.classList.remove('is-active'),
                      t.dataset.year ===
                        d.format(n._visibleDate, 'YYYY', {
                          locale: n.locale,
                        }) && t.classList.add('is-active')
                  })
                var o = new Array(7)
                  .fill(d.startOfWeek(this._visibleDate))
                  .map(function (e, t) {
                    return d.format(
                      d.addDays(e, t + n.options.weekStart),
                      'ddd',
                      { locale: n.locale },
                    )
                  })
                return (
                  this._ui.body.dates.appendChild(
                    document
                      .createRange()
                      .createContextualFragment(Object(s.a)({ weekdays: o })),
                  ),
                  this.min &&
                  0 === d.differenceInMonths(this._visibleDate, this.min)
                    ? this._togglePreviousButton(!1)
                    : this._togglePreviousButton(),
                  this.max &&
                  0 === d.differenceInMonths(this._visibleDate, this.max)
                    ? this._toggleNextButton(!1)
                    : this._toggleNextButton(),
                  (this._ui.navigation.month.innerHTML = d.format(
                    this._visibleDate,
                    'MMMM',
                    { locale: this.locale },
                  )),
                  (this._ui.navigation.year.innerHTML = d.format(
                    this._visibleDate,
                    'YYYY',
                    { locale: this.locale },
                  )),
                  this._renderDays(),
                  this._ui.body.dates.classList.add('is-active'),
                  this._ui.body.months.classList.remove('is-active'),
                  this._ui.body.years.classList.remove('is-active'),
                  this._ui.navigation.previous.removeAttribute('disabled'),
                  this._ui.navigation.next.removeAttribute('disabled'),
                  this
                )
              },
            },
            {
              key: 'clear',
              value: function clear() {
                var e = new Date()
                ;(this._date = { start: void 0, end: void 0 }),
                  (this._visibleDate = this._isValidDate(e, this.min, this.max)
                    ? e
                    : this.min),
                  this.refresh()
              },
            },
            {
              key: 'snapshot',
              value: function snapshot() {
                this._snapshots.push(h({}, this._date))
              },
            },
            {
              key: 'render',
              value: function render() {
                return this.refresh(), this.node
              },
            },
            {
              key: '_init',
              value: function _init() {
                var e = new Date()
                ;(this._open = !1),
                  (this._snapshots = []),
                  (this.lang = this.options.lang),
                  (this.format = this.options.dateFormat || 'MM/DD/YYYY'),
                  (this.disabledDates = Array.isArray(
                    this.options.disabledDates,
                  )
                    ? this.options.disabledDates
                    : [])
                for (var t = 0; t < this.disabledDates.length; t++)
                  this.disabledDates[t] = d.format(
                    this.disabledDates[t],
                    this.format,
                    { locale: this.locale },
                  )
                ;(this.disabledWeekDays = c.e(this.options.disabledWeekDays)
                  ? this.options.disabledWeekDays.split(',')
                  : Array.isArray(this.options.disabledWeekDays)
                  ? this.options.disabledWeekDays
                  : []),
                  (this.min = this.options.minDate),
                  (this.max = this.options.maxDate),
                  (this._date = {
                    start: this.options.startDate,
                    end: this.options.isRange ? this.options.endDate : void 0,
                  }),
                  (this._visibleDate = this._isValidDate(this.start)
                    ? this.start
                    : this._isValidDate(e, this.min, this.max)
                    ? e
                    : this.min),
                  this._build(),
                  this._bindEvents(),
                  this.emit('ready', this)
              },
            },
            {
              key: '_build',
              value: function _build() {
                ;(this.node = document.createRange().createContextualFragment(
                  Object(r.a)({
                    locale: this.locale,
                    visibleDate: this._visibleDate,
                    icons: this.options.icons,
                  }),
                )),
                  (this._ui = {
                    container: this.node.firstChild,
                    navigation: {
                      container: this.node.querySelector('.datepicker-nav'),
                      previous: this.node.querySelector(
                        '.datepicker-nav-previous',
                      ),
                      next: this.node.querySelector('.datepicker-nav-next'),
                      month: this.node.querySelector('.datepicker-nav-month'),
                      year: this.node.querySelector('.datepicker-nav-year'),
                    },
                    body: {
                      dates: this.node.querySelector('.datepicker-dates'),
                      days: this.node.querySelector('.datepicker-days'),
                      weekdays: this.node.querySelector('.datepicker-weekdays'),
                      months: this.node.querySelector('.datepicker-months'),
                      years: this.node.querySelector('.datepicker-years'),
                    },
                  })
              },
            },
            {
              key: '_bindEvents',
              value: function _bindEvents() {
                var n = this
                document.addEventListener('keydown', function (e) {
                  if (n._focus)
                    switch (e.keyCode || e.which) {
                      case 37:
                        n.onPreviousDatePicker(e)
                        break
                      case 39:
                        n.onNextDatePicker(e)
                    }
                }),
                  this._ui.navigation.previous &&
                    this._clickEvents.forEach(function (e) {
                      n._ui.navigation.previous.addEventListener(
                        e,
                        n.onPreviousDatePicker,
                      )
                    }),
                  this._ui.navigation.next &&
                    this._clickEvents.forEach(function (e) {
                      n._ui.navigation.next.addEventListener(
                        e,
                        n.onNextDatePicker,
                      )
                    }),
                  this._ui.navigation.month &&
                    this._clickEvents.forEach(function (e) {
                      n._ui.navigation.month.addEventListener(
                        e,
                        n.onSelectMonthDatePicker,
                      )
                    }),
                  this._ui.navigation.year &&
                    this._clickEvents.forEach(function (e) {
                      n._ui.navigation.year.addEventListener(
                        e,
                        n.onSelectYearDatePicker,
                      )
                    }),
                  (
                    this._ui.body.months.querySelectorAll('.calendar-month') ||
                    []
                  ).forEach(function (t) {
                    n._clickEvents.forEach(function (e) {
                      t.addEventListener(e, n.onMonthClickDatePicker)
                    })
                  }),
                  (
                    this._ui.body.years.querySelectorAll('.calendar-year') || []
                  ).forEach(function (t) {
                    n._clickEvents.forEach(function (e) {
                      t.addEventListener(e, n.onYearClickDatePicker)
                    })
                  })
              },
            },
            {
              key: '_bindDaysEvents',
              value: function _bindDaysEvents() {
                var o = this
                ;[].forEach.call(this._ui.days, function (n) {
                  o._clickEvents.forEach(function (e) {
                    var t = o._isValidDate(
                      new Date(n.dataset.date),
                      o.min,
                      o.max,
                    )
                      ? o.onDateClickDatePicker
                      : null
                    n.addEventListener(e, t)
                  }),
                    n.addEventListener('hover', function (e) {
                      e.preventDEfault()
                    })
                })
              },
            },
            {
              key: '_renderDays',
              value: function _renderDays() {
                var u = this,
                  e = d.startOfWeek(d.startOfMonth(this._visibleDate)),
                  t = d.endOfWeek(d.endOfMonth(this._visibleDate)),
                  n = new Array(d.differenceInDays(t, e) + 1)
                    .fill(e)
                    .map(function (e, t) {
                      var n = d.startOfDay(
                          d.addDays(e, t + u.options.weekStart),
                        ),
                        o = d.isSameMonth(u._visibleDate, n),
                        i =
                          u.options.isRange &&
                          d.isWithinRange(
                            n,
                            d.startOfDay(u.start),
                            d.endOfDay(u.end),
                          ),
                        r =
                          !!u.max &&
                          d.isAfter(d.startOfDay(n), d.endOfDay(u.max))
                      if (
                        ((r =
                          !r && u.min
                            ? d.isBefore(d.startOfDay(n), d.startOfDay(u.min))
                            : r),
                        u.disabledDates)
                      )
                        for (var a = 0; a < u.disabledDates.length; a++) {
                          var s = u.disabledDates[a]
                          c.c(s) && (s = s(u)),
                            d.getTime(n) == d.getTime(s) && (r = !0)
                        }
                      return (
                        u.disabledWeekDays &&
                          u.disabledWeekDays.forEach(function (e) {
                            c.c(e) && (e = e(u)), d.getDay(n) == e && (r = !0)
                          }),
                        {
                          date: n,
                          isRange: u.options.isRange,
                          isToday: d.isToday(n),
                          isStartDate: d.isEqual(d.startOfDay(u.start), n),
                          isEndDate: d.isEqual(d.startOfDay(u.end), n),
                          isDisabled: r,
                          isThisMonth: o,
                          isInRange: i,
                        }
                      )
                    })
                this._ui.body.dates.appendChild(
                  document
                    .createRange()
                    .createContextualFragment(Object(a.a)(n)),
                ),
                  (this._ui.days =
                    this._ui.body.dates.querySelectorAll('.datepicker-date')),
                  this._bindDaysEvents()
              },
            },
            {
              key: '_select',
              value: function _select() {
                var i = this,
                  e =
                    0 < arguments.length && void 0 !== arguments[0]
                      ? arguments[0]
                      : void 0
                this.snapshot(),
                  (e = c.b(e) ? e : new Date(e)),
                  this.options.isRange &&
                  (!this._isValidDate(this.start) ||
                    (this._isValidDate(this.start) &&
                      this._isValidDate(this.end)))
                    ? ((this.start = e),
                      (this.end = void 0),
                      this.emit('select:start', this))
                    : this.options.isRange && !this._isValidDate(this.end)
                    ? d.isBefore(e, this.start)
                      ? ((this.end = this.start),
                        (this.start = e),
                        this.emit('select', this))
                      : d.isAfter(e, this.start)
                      ? ((this.end = e), this.emit('select', this))
                      : this.options.allowSameDayRange
                      ? ((this.end = e), this.emit('select', this))
                      : ((this.start = e),
                        (this.end = void 0),
                        this.emit('select:start', this))
                    : ((this.start = e),
                      (this.end = void 0),
                      this.emit('select', this)),
                  (this._visibleDate = this._isValidDate(this.start)
                    ? this.start
                    : this._visibleDate),
                  this.options.isRange &&
                    this._isValidDate(this.start) &&
                    this._isValidDate(this.end) &&
                    new Array(d.differenceInDays(this.end, this.start) + 1)
                      .fill(this.start)
                      .map(function (e, t) {
                        var n = d.addDays(e, t),
                          o = i._ui.body.dates.querySelector(
                            '.datepicker-date[data-date="' +
                              n.toString() +
                              '"]',
                          )
                        o &&
                          (d.isEqual(i.start, n) &&
                            o.classList.add('datepicker-range-start'),
                          d.isEqual(i.end, n) &&
                            o.classList.add('datepicker-range-end'),
                          o.classList.add('datepicker-range'))
                      })
              },
            },
            {
              key: '_isValidDate',
              value: function _isValidDate(e, t, n) {
                try {
                  return (
                    !!e &&
                    !!d.isValid(e) &&
                    ((!t && !n) ||
                      (t && n
                        ? d.isWithinRange(e, t, n)
                        : n
                        ? d.isBefore(e, n) || d.isEqual(e, n)
                        : d.isAfter(e, t) || d.isEqual(e, t)))
                  )
                } catch (e) {
                  return !1
                }
              },
            },
            {
              key: '_togglePreviousButton',
              value: function _togglePreviousButton() {
                !(0 < arguments.length && void 0 !== arguments[0]) ||
                arguments[0]
                  ? this._ui.navigation.previous.removeAttribute('disabled')
                  : this._ui.navigation.previous.setAttribute(
                      'disabled',
                      'disabled',
                    )
              },
            },
            {
              key: '_toggleNextButton',
              value: function _toggleNextButton() {
                !(0 < arguments.length && void 0 !== arguments[0]) ||
                arguments[0]
                  ? this._ui.navigation.next.removeAttribute('disabled')
                  : this._ui.navigation.next.setAttribute(
                      'disabled',
                      'disabled',
                    )
              },
            },
            {
              key: 'id',
              get: function get() {
                return this._id
              },
            },
            {
              key: 'date',
              set: function set(e) {
                return c.d(e) && e.start && e.end && (this._date = e), this
              },
              get: function get() {
                return this._date || { start: void 0, end: void 0 }
              },
            },
            {
              key: 'lang',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : 'en'
                return (this._lang = e), (this._locale = n(84)('./' + e)), this
              },
              get: function get() {
                return this._lang
              },
            },
            {
              key: 'locale',
              get: function get() {
                return this._locale
              },
            },
            {
              key: 'start',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : void 0
                return (
                  e
                    ? (c.b(e) &&
                        (this._date.start = this._isValidDate(
                          e,
                          this.min,
                          this.max,
                        )
                          ? d.startOfDay(e)
                          : this._date.start),
                      c.e(e) &&
                        (this._date.start = this._isValidDate(
                          d.parse(e),
                          this.min,
                          this.max,
                        )
                          ? d.startOfDay(d.parse(e))
                          : this._date.start))
                    : (this._date.start = void 0),
                  this
                )
              },
              get: function get() {
                return this._date.start
              },
            },
            {
              key: 'end',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : void 0
                return (
                  e
                    ? (c.b(e) &&
                        (this._date.end = this._isValidDate(
                          e,
                          this.min,
                          this.max,
                        )
                          ? d.startOfDay(e)
                          : this._date.end),
                      c.e(e) &&
                        (this._date.end = this._isValidDate(
                          d.parse(e),
                          this.min,
                          this.max,
                        )
                          ? d.startOfDay(d.parse(e))
                          : this._date.end))
                    : (this._date.end = void 0),
                  this
                )
              },
              get: function get() {
                return this._date.end
              },
            },
            {
              key: 'min',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : void 0
                return (
                  e &&
                    (c.b(e) &&
                      (this._min = this._isValidDate(e)
                        ? d.startOfDay(e)
                        : this._min),
                    c.e(e) &&
                      (this._min = this._isValidDate(d.parse(e))
                        ? d.startOfDay(e)
                        : this._min)),
                  this
                )
              },
              get: function get() {
                return this._min
              },
            },
            {
              key: 'max',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : null
                return (
                  e &&
                    (c.b(e) &&
                      (this._max = this._isValidDate(e)
                        ? d.startOfDay(e)
                        : this._max),
                    c.e(e) &&
                      (this._max = this._isValidDate(d.parse(e))
                        ? d.startOfDay(e)
                        : this._max)),
                  this
                )
              },
              get: function get() {
                return this._max
              },
            },
            {
              key: 'format',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : 'MM/DD/YYYY'
                return (this._format = e), this
              },
              get: function get() {
                return this._format
              },
            },
          ]),
          datePicker
        )
      })()
      t.a = p
    },
    function (e, t, n) {
      'use strict'
      t.a = function (e) {
        return (
          '<div class="datepicker">\n    <div class="datepicker-nav">\n        <button type="button" class="datepicker-nav-previous button is-small is-text">' +
          e.icons.previous +
          '</button>\n        <div class="datepicker-nav-month-year">\n          <div class="datepicker-nav-month"></div>\n          &nbsp;\n          <div class="datepicker-nav-year"></div>\n        </div>\n        <button type="button" class="datepicker-nav-next button is-small is-text">' +
          e.icons.next +
          '</button>\n      </div>\n      <div class="datepicker-body">\n        <div class="datepicker-dates is-active"></div>\n        <div class="datepicker-months"></div>\n        <div class="datepicker-years"></div>\n      </div>\n    </div>'
        )
      }
    },
    function (e, t, n) {
      'use strict'
      t.a = function (e) {
        return (
          '<div class="datepicker-days">' +
          e
            .map(function (e) {
              return (
                '<div data-date="' +
                e.date.toString() +
                '" class="datepicker-date' +
                (e.isThisMonth ? ' is-current-month' : '') +
                (e.isDisabled ? ' is-disabled' : '') +
                (e.isRange && e.isInRange ? ' datepicker-range' : '') +
                (e.isStartDate ? ' datepicker-range-start' : '') +
                (e.isEndDate ? ' datepicker-range-end' : '') +
                '">\n      <button class="date-item' +
                (e.isToday ? ' is-today' : '') +
                (e.isStartDate ? ' is-active' : '') +
                '" type="button">' +
                e.date.getDate() +
                '</button>\n  </div>'
              )
            })
            .join('') +
          '</div>'
        )
      }
    },
    function (e, t, n) {
      'use strict'
      t.a = function (e) {
        return (
          '<div class="datepicker-weekdays">\n\t\t' +
          e.weekdays
            .map(function (e) {
              return '<div class="datepicker-date">' + e + '</div>'
            })
            .join('') +
          '\n\t</div>'
        )
      }
    },
    function (e, t, n) {
      'use strict'
      var o = n(7)
      n.n(o)
      t.a = function (n) {
        return (
          '' +
          n.months
            .map(function (e, t) {
              return (
                '<div class="datepicker-month" data-month="' +
                Object(o.format)(Object(o.addMonths)(e, t), 'MM', {
                  locale: n.locale,
                }) +
                '">' +
                Object(o.format)(Object(o.addMonths)(e, t), 'MMM', {
                  locale: n.locale,
                }) +
                '</div>'
              )
            })
            .join('')
        )
      }
    },
    function (e, t, n) {
      'use strict'
      var o = n(7)
      n.n(o)
      t.a = function (t) {
        return (
          '' +
          t.years
            .map(function (e) {
              return (
                '<div class="datepicker-year' +
                (e === Object(o.getMonth)(t.visibleDate) ? ' is-active' : '') +
                '" data-year="' +
                e +
                '"><span class="item">' +
                e +
                '</span></div>'
              )
            })
            .join('')
        )
      }
    },
    function (e, t, n) {
      'use strict'
      var o = {
        color: 'primary',
        isRange: !1,
        allowSameDayRange: !0,
        lang: 'en',
        startDate: void 0,
        endDate: void 0,
        minDate: null,
        maxDate: null,
        disabledDates: [],
        disabledWeekDays: void 0,
        weekStart: 0,
        dateFormat: 'MM/DD/YYYY',
        enableMonthSwitch: !0,
        enableYearSwitch: !0,
      }
      t.a = o
    },
    function (e, t, n) {
      'use strict'
      var o = n(118),
        i = n(119),
        r = n(7),
        a = (n.n(r), n(129)),
        s = n(340),
        u = n(341),
        c =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t]
              for (var o in n)
                Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o])
            }
            return e
          },
        d = (function () {
          function defineProperties(e, t) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n]
              ;(o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                'value' in o && (o.writable = !0),
                Object.defineProperty(e, o.key, o)
            }
          }
          return function (e, t, n) {
            return (
              t && defineProperties(e.prototype, t),
              n && defineProperties(e, n),
              e
            )
          }
        })()
      var l = (function (e) {
        function timePicker() {
          var e =
            0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}
          !(function _classCallCheck(e, t) {
            if (!(e instanceof t))
              throw new TypeError('Cannot call a class as a function')
          })(this, timePicker)
          var t = (function _possibleConstructorReturn(e, t) {
            if (!e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called",
              )
            return !t || ('object' != typeof t && 'function' != typeof t)
              ? e
              : t
          })(
            this,
            (timePicker.__proto__ || Object.getPrototypeOf(timePicker)).call(
              this,
            ),
          )
          return (
            (t.options = c({}, u.a, e)),
            (t._clickEvents = ['click', 'touch']),
            (t._supportsPassive = o.a()),
            (t._id = o.b('timePicker')),
            (t.node = null),
            (t.onPreviousHourStartTimePicker =
              t.onPreviousHourStartTimePicker.bind(t)),
            (t.onNextHourStartTimePicker = t.onNextHourStartTimePicker.bind(t)),
            (t.onPreviousMinuteStartTimePicker =
              t.onPreviousMinuteStartTimePicker.bind(t)),
            (t.onNextMinuteStartTimePicker =
              t.onNextMinuteStartTimePicker.bind(t)),
            (t.onPreviousHourEndTimePicker =
              t.onPreviousHourEndTimePicker.bind(t)),
            (t.onNextHourEndTimePicker = t.onNextHourEndTimePicker.bind(t)),
            (t.onPreviousMinuteEndTimePicker =
              t.onPreviousMinuteEndTimePicker.bind(t)),
            (t.onNextMinuteEndTimePicker = t.onNextMinuteEndTimePicker.bind(t)),
            t._init(),
            t
          )
        }
        return (
          (function _inherits(e, t) {
            if ('function' != typeof t && null !== t)
              throw new TypeError(
                'Super expression must either be null or a function, not ' +
                  typeof t,
              )
            ;(e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0,
              },
            })),
              t &&
                (Object.setPrototypeOf
                  ? Object.setPrototypeOf(e, t)
                  : (e.__proto__ = t))
          })(timePicker, a['a']),
          d(timePicker, [
            {
              key: '_init',
              value: function _init() {
                ;(this._open = !1),
                  (this._snapshots = []),
                  (this.lang = this.options.lang),
                  (this.format = this.options.format || 'HH:mm'),
                  (this.min = this.options.min),
                  (this.max = this.options.max),
                  (this._time = {
                    start: r.startOfToday(),
                    end: r.endOfToday(),
                  }),
                  (this.start = this.options.start || r.startOfToday()),
                  (this.end = this.options.isRange
                    ? this.options.end
                    : r.endOfToday()),
                  this._build(),
                  this._bindEvents(),
                  this.emit('ready', this)
              },
            },
            {
              key: '_build',
              value: function _build() {
                ;(this.node = document.createRange().createContextualFragment(
                  Object(s.a)({
                    locale: this.locale,
                    isRange: this.options.isRange,
                    icons: this.options.icons,
                  }),
                )),
                  (this._ui = {
                    container: this.node.firstChild,
                    start: {
                      container: this.node.querySelector('.timepicker-start'),
                      hours: {
                        container: this.node.querySelector(
                          '.timepicker-start .timepicker-hours',
                        ),
                        input: this.node.querySelector(
                          '.timepicker-start .timepicker-hours input',
                        ),
                        number: this.node.querySelector(
                          '.timepicker-start .timepicker-hours .timepicker-input-number',
                        ),
                        previous: this.node.querySelector(
                          '.timepicker-start .timepicker-hours .timepicker-previous',
                        ),
                        next: this.node.querySelector(
                          '.timepicker-start .timepicker-hours .timepicker-next',
                        ),
                      },
                      minutes: {
                        container: this.node.querySelector(
                          '.timepicker-start .timepicker-minutes',
                        ),
                        input: this.node.querySelector(
                          '.timepicker-start .timepicker-minutes input',
                        ),
                        number: this.node.querySelector(
                          '.timepicker-start .timepicker-minutes .timepicker-input-number',
                        ),
                        previous: this.node.querySelector(
                          '.timepicker-start .timepicker-minutes .timepicker-previous',
                        ),
                        next: this.node.querySelector(
                          '.timepicker-start .timepicker-minutes .timepicker-next',
                        ),
                      },
                    },
                    end: {
                      container: this.node.querySelector('.timepicker-end'),
                      hours: {
                        container: this.node.querySelector(
                          '.timepicker-end .timepicker-hours',
                        ),
                        input: this.node.querySelector(
                          '.timepicker-end .timepicker-hours input',
                        ),
                        number: this.node.querySelector(
                          '.timepicker-end .timepicker-hours .timepicker-input-number',
                        ),
                        previous: this.node.querySelector(
                          '.timepicker-end .timepicker-hours .timepicker-previous',
                        ),
                        next: this.node.querySelector(
                          '.timepicker-end .timepicker-hours .timepicker-next',
                        ),
                      },
                      minutes: {
                        container: this.node.querySelector(
                          '.timepicker-end .timepicker-minutes',
                        ),
                        input: this.node.querySelector(
                          '.timepicker-end .timepicker-minutes input',
                        ),
                        number: this.node.querySelector(
                          '.timepicker-end .timepicker-minutes .timepicker-input-number',
                        ),
                        previous: this.node.querySelector(
                          '.timepicker-end .timepicker-minutes .timepicker-previous',
                        ),
                        next: this.node.querySelector(
                          '.timepicker-end .timepicker-minutes .timepicker-next',
                        ),
                      },
                    },
                  })
              },
            },
            {
              key: '_bindEvents',
              value: function _bindEvents() {
                var t = this
                this._clickEvents.forEach(function (e) {
                  t._ui.start.hours.previous.addEventListener(
                    e,
                    t.onPreviousHourStartTimePicker,
                  ),
                    t._ui.start.hours.next.addEventListener(
                      e,
                      t.onNextHourStartTimePicker,
                    ),
                    t._ui.start.minutes.previous.addEventListener(
                      e,
                      t.onPreviousMinuteStartTimePicker,
                    ),
                    t._ui.start.minutes.next.addEventListener(
                      e,
                      t.onNextMinuteStartTimePicker,
                    ),
                    t.options.isRange &&
                      (t._ui.end.hours.previous.addEventListener(
                        e,
                        t.onPreviousHourEndTimePicker,
                      ),
                      t._ui.end.hours.next.addEventListener(
                        e,
                        t.onNextHourEndTimePicker,
                      ),
                      t._ui.end.minutes.previous.addEventListener(
                        e,
                        t.onPreviousMinuteEndTimePicker,
                      ),
                      t._ui.end.minutes.next.addEventListener(
                        e,
                        t.onNextMinuteEndTimePicker,
                      ))
                })
              },
            },
            {
              key: '_select',
              value: function _select() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : void 0
                this.snapshot(),
                  (e = i.b(e) ? e : new Date(e)),
                  this.options.isRange &&
                  (!this._isValidTime(this.start) ||
                    (this._isValidTime(this.start) &&
                      this._isValidTime(this.end)))
                    ? ((this.start = e),
                      (this.end = r.endOfToday()),
                      this.emit('select:start', this))
                    : this.options.isRange && !this._isValidTime(this.end)
                    ? r.isBefore(e, this.start)
                      ? ((this.end = this.start),
                        (this.start = r.endOfToday()),
                        this.emit('select', this))
                      : r.isAfter(e, this.start)
                      ? ((this.end = e), this.emit('select', this))
                      : ((this.start = e),
                        (this.end = r.endOfToday()),
                        this.emit('select:start', this))
                    : ((this.start = e),
                      (this.end = r.endOfToday()),
                      this.emit('select', this))
              },
            },
            {
              key: '_isValidTime',
              value: function _isValidTime(e, t, n) {
                try {
                  return (
                    !!e &&
                    !!r.isValid(e) &&
                    ((!t && !n) ||
                      (t && n
                        ? r.isWithinRange(e, t, n)
                        : n
                        ? r.isBefore(e, n) || r.isEqual(e, n)
                        : r.isAfter(e, t) || r.isEqual(e, t)))
                  )
                } catch (e) {
                  return !1
                }
              },
            },
            {
              key: 'onPreviousHourStartTimePicker',
              value: function onPreviousHourStartTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.start = r.subHours(this.start, 1)),
                  setTimeout(function () {
                    t._ui.start.hours.number.classList.add('is-decrement-hide'),
                      setTimeout(function () {
                        ;(t._ui.start.hours.number.innerText = r.format(
                          t.start,
                          'HH',
                        )),
                          (t._ui.start.hours.input.value = r.format(
                            t.start,
                            'HH',
                          )),
                          t._ui.start.hours.number.classList.add(
                            'is-decrement-visible',
                          )
                      }, 100),
                      setTimeout(function () {
                        t._ui.start.hours.number.classList.remove(
                          'is-decrement-hide',
                        ),
                          t._ui.start.hours.number.classList.remove(
                            'is-decrement-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'onNextHourStartTimePicker',
              value: function onNextHourStartTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.start = r.addHours(this.start, 1)),
                  setTimeout(function () {
                    t._ui.start.hours.number.classList.add('is-increment-hide'),
                      setTimeout(function () {
                        ;(t._ui.start.hours.number.innerText = r.format(
                          t.start,
                          'HH',
                        )),
                          (t._ui.start.hours.input.value = r.format(
                            t.start,
                            'HH',
                          )),
                          t._ui.start.hours.number.classList.add(
                            'is-increment-visible',
                          )
                      }, 100),
                      setTimeout(function () {
                        t._ui.start.hours.number.classList.remove(
                          'is-increment-hide',
                        ),
                          t._ui.start.hours.number.classList.remove(
                            'is-increment-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'onPreviousMinuteStartTimePicker',
              value: function onPreviousMinuteStartTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.start = r.subMinutes(
                    this.start,
                    this.options.minuteSteps,
                  )),
                  setTimeout(function () {
                    t._ui.start.minutes.number.classList.add(
                      'is-decrement-hide',
                    ),
                      setTimeout(function () {
                        ;(t._ui.start.minutes.number.innerText = r.format(
                          t.start,
                          'mm',
                        )),
                          (t._ui.start.minutes.input.value = r.format(
                            t.start,
                            'mm',
                          )),
                          t._ui.start.minutes.number.classList.add(
                            'is-decrement-visible',
                          ),
                          r.format(t.start, 'HH') !==
                            t._ui.start.hours.input.value &&
                            ((t._ui.start.hours.number.innerText = r.format(
                              t.start,
                              'HH',
                            )),
                            (t._ui.start.hours.input.value = r.format(
                              t.start,
                              'HH',
                            )),
                            t._ui.start.hours.number.classList.add(
                              'is-decrement-visible',
                            ))
                      }, 100),
                      setTimeout(function () {
                        t._ui.start.minutes.number.classList.remove(
                          'is-decrement-hide',
                        ),
                          t._ui.start.minutes.number.classList.remove(
                            'is-decrement-visible',
                          ),
                          t._ui.start.hours.number.classList.remove(
                            'is-decrement-hide',
                          ),
                          t._ui.start.hours.number.classList.remove(
                            'is-decrement-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'onNextMinuteStartTimePicker',
              value: function onNextMinuteStartTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.start = r.addMinutes(
                    this.start,
                    this.options.minuteSteps,
                  )),
                  setTimeout(function () {
                    t._ui.start.minutes.number.classList.add(
                      'is-increment-hide',
                    ),
                      setTimeout(function () {
                        ;(t._ui.start.minutes.number.innerText = r.format(
                          t.start,
                          'mm',
                        )),
                          (t._ui.start.minutes.input.value = r.format(
                            t.start,
                            'mm',
                          )),
                          t._ui.start.minutes.number.classList.add(
                            'is-increment-visible',
                          ),
                          r.format(t.start, 'HH') !==
                            t._ui.start.hours.input.value &&
                            ((t._ui.start.hours.number.innerText = r.format(
                              t.start,
                              'HH',
                            )),
                            (t._ui.start.hours.input.value = r.format(
                              t.start,
                              'HH',
                            )),
                            t._ui.start.hours.number.classList.add(
                              'is-increment-visible',
                            ))
                      }, 100),
                      setTimeout(function () {
                        t._ui.start.minutes.number.classList.remove(
                          'is-increment-hide',
                        ),
                          t._ui.start.minutes.number.classList.remove(
                            'is-increment-visible',
                          ),
                          t._ui.start.hours.number.classList.remove(
                            'is-increment-hide',
                          ),
                          t._ui.start.hours.number.classList.remove(
                            'is-increment-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'onPreviousHourEndTimePicker',
              value: function onPreviousHourEndTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.end = r.subHours(this.end, 1)),
                  setTimeout(function () {
                    t._ui.end.hours.number.classList.add('is-decrement-hide'),
                      setTimeout(function () {
                        ;(t._ui.end.hours.number.innerText = r.format(
                          t.end,
                          'HH',
                        )),
                          (t._ui.end.hours.input.value = r.format(t.end, 'HH')),
                          t._ui.end.hours.number.classList.add(
                            'is-decrement-visible',
                          )
                      }, 100),
                      setTimeout(function () {
                        t._ui.end.hours.number.classList.remove(
                          'is-decrement-hide',
                        ),
                          t._ui.end.hours.number.classList.remove(
                            'is-decrement-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'onNextHourEndTimePicker',
              value: function onNextHourEndTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.end = r.addHours(this.end, 1)),
                  setTimeout(function () {
                    t._ui.end.hours.number.classList.add('is-increment-hide'),
                      setTimeout(function () {
                        ;(t._ui.end.hours.number.innerText = r.format(
                          t.end,
                          'HH',
                        )),
                          (t._ui.end.hours.input.value = r.format(t.end, 'HH')),
                          t._ui.end.hours.number.classList.add(
                            'is-increment-visible',
                          )
                      }, 100),
                      setTimeout(function () {
                        t._ui.end.hours.number.classList.remove(
                          'is-increment-hide',
                        ),
                          t._ui.end.hours.number.classList.remove(
                            'is-increment-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'onPreviousMinuteEndTimePicker',
              value: function onPreviousMinuteEndTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.end = r.subMinutes(this.end, this.options.minuteSteps)),
                  setTimeout(function () {
                    t._ui.end.minutes.number.classList.add('is-decrement-hide'),
                      setTimeout(function () {
                        ;(t._ui.end.minutes.number.innerText = r.format(
                          t.end,
                          'mm',
                        )),
                          (t._ui.end.minutes.input.value = r.format(
                            t.end,
                            'mm',
                          )),
                          t._ui.end.minutes.number.classList.add(
                            'is-decrement-visible',
                          ),
                          r.format(t.end, 'HH') !==
                            t._ui.end.hours.input.value &&
                            ((t._ui.end.hours.number.innerText = r.format(
                              t.end,
                              'HH',
                            )),
                            (t._ui.end.hours.input.value = r.format(
                              t.end,
                              'HH',
                            )),
                            t._ui.end.hours.number.classList.add(
                              'is-decrement-visible',
                            ))
                      }, 100),
                      setTimeout(function () {
                        t._ui.end.minutes.number.classList.remove(
                          'is-decrement-hide',
                        ),
                          t._ui.end.minutes.number.classList.remove(
                            'is-decrement-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'onNextMinuteEndTimePicker',
              value: function onNextMinuteEndTimePicker(e) {
                var t = this
                this._supportsPassive || e.preventDefault(),
                  e.stopPropagation(),
                  (this.end = r.addMinutes(this.end, this.options.minuteSteps)),
                  setTimeout(function () {
                    t._ui.end.minutes.number.classList.add('is-increment-hide'),
                      setTimeout(function () {
                        ;(t._ui.end.minutes.number.innerText = r.format(
                          t.end,
                          'mm',
                        )),
                          (t._ui.end.minutes.input.value = r.format(
                            t.end,
                            'mm',
                          )),
                          t._ui.end.minutes.number.classList.add(
                            'is-increment-visible',
                          ),
                          r.format(t.end, 'HH') !==
                            t._ui.end.hours.input.value &&
                            ((t._ui.end.hours.number.innerText = r.format(
                              t.end,
                              'HH',
                            )),
                            (t._ui.end.hours.input.value = r.format(
                              t.end,
                              'HH',
                            )),
                            t._ui.end.hours.number.classList.add(
                              'is-increment-visible',
                            ))
                      }, 100),
                      setTimeout(function () {
                        t._ui.end.minutes.number.classList.remove(
                          'is-increment-hide',
                        ),
                          t._ui.end.minutes.number.classList.remove(
                            'is-increment-visible',
                          )
                      }, 1100)
                  }, 100)
              },
            },
            {
              key: 'isRange',
              value: function isRange() {
                return this.options.isRange
              },
            },
            {
              key: 'show',
              value: function show() {
                this._open ||
                  (this._ui.container.classList.add('is-active'),
                  (this._open = !0),
                  (this._focus = !0),
                  this.emit('show', this))
              },
            },
            {
              key: 'hide',
              value: function hide() {
                ;(this._open = !1),
                  (this._focus = !1),
                  this._ui.container.classList.remove('is-active'),
                  this.emit('hide', this)
              },
            },
            {
              key: 'toggle',
              value: function toggle() {
                this._open ? this.hide() : this.show()
              },
            },
            {
              key: 'value',
              value: function value() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : null
                if (!e) {
                  var t =
                    this.start && this._isValidTime(this.start)
                      ? r.format(this.start, this.format, {
                          locale: this.locale,
                        })
                      : ''
                  return (
                    this.options.isRange &&
                      this.end &&
                      this._isValidTime(this.end) &&
                      (t +=
                        ' - ' +
                        r.format(this.end, this.format, {
                          locale: this.locale,
                        })),
                    t
                  )
                }
                if (this.options.isRange) {
                  if (i.e(e)) {
                    var n = e.split(' - ')
                    n.length &&
                      (this.start = r.format(new Date(n[0]), this.format, {
                        locale: this.locale,
                      })),
                      2 === n.length &&
                        (this.end = r.format(new Date(n[1]), this.format, {
                          locale: this.locale,
                        }))
                  }
                  ;(i.d(e) || i.b(e)) && this._select(e)
                } else this._select(e)
              },
            },
            {
              key: 'refresh',
              value: function refresh() {
                return (
                  (this._ui.start.hours.input.value = r.format(
                    this.start,
                    'HH',
                  )),
                  (this._ui.start.hours.number.innerText = r.format(
                    this.start,
                    'HH',
                  )),
                  (this._ui.start.minutes.input.value = r.format(
                    this.start,
                    'mm',
                  )),
                  (this._ui.start.minutes.number.innerText = r.format(
                    this.start,
                    'mm',
                  )),
                  this.options.isRange &&
                    ((this._ui.end.hours.input.value = r.format(
                      this.end,
                      'HH',
                    )),
                    (this._ui.end.hours.number.innerText = r.format(
                      this.end,
                      'HH',
                    )),
                    (this._ui.end.minutes.input.value = r.format(
                      this.end,
                      'mm',
                    )),
                    (this._ui.end.minutes.number.innerText = r.format(
                      this.end,
                      'mm',
                    ))),
                  this
                )
              },
            },
            {
              key: 'clear',
              value: function clear() {
                ;(this.time = { start: r.startOfToday(), end: r.endOfToday() }),
                  this.refresh()
              },
            },
            {
              key: 'snapshot',
              value: function snapshot() {
                this._snapshots.push(c({}, this._time))
              },
            },
            {
              key: 'render',
              value: function render() {
                return this.refresh(), this.node
              },
            },
            {
              key: 'id',
              get: function get() {
                return this._id
              },
            },
            {
              key: 'time',
              set: function set(e) {
                return i.d(e) && e.start && e.end && (this._time = e), this
              },
              get: function get() {
                return this._time || { start: void 0, end: void 0 }
              },
            },
            {
              key: 'lang',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : 'en'
                return (this._lang = e), (this._locale = n(84)('./' + e)), this
              },
              get: function get() {
                return this._lang
              },
            },
            {
              key: 'locale',
              get: function get() {
                return this._locale
              },
            },
            {
              key: 'start',
              set: function set(e) {
                return (
                  (this._time.start = e
                    ? this._isValidTime(e, this.min, this.max)
                      ? e
                      : this._time.start
                    : r.startOfToday()),
                  this
                )
              },
              get: function get() {
                return this._time.start
              },
            },
            {
              key: 'end',
              set: function set(e) {
                return (
                  (this._time.end = e
                    ? this._isValidTime(e, this.min, this.max)
                      ? e
                      : this._time.end
                    : r.endOfToday()),
                  this
                )
              },
              get: function get() {
                return this._time.end
              },
            },
            {
              key: 'min',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : void 0
                return (
                  (this._min = e
                    ? this._isValidTime(e)
                      ? e
                      : this._min
                    : void 0),
                  this
                )
              },
              get: function get() {
                return this._min
              },
            },
            {
              key: 'max',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : null
                return (
                  (this._max = e
                    ? this._isValidTime(e)
                      ? e
                      : this._max
                    : void 0),
                  this
                )
              },
              get: function get() {
                return this._max
              },
            },
            {
              key: 'format',
              set: function set() {
                var e =
                  0 < arguments.length && void 0 !== arguments[0]
                    ? arguments[0]
                    : 'HH:mm'
                return (this._format = e), this
              },
              get: function get() {
                return this._format
              },
            },
          ]),
          timePicker
        )
      })()
      t.a = l
    },
    function (e, t, n) {
      'use strict'
      t.a = function (e) {
        return (
          '<div class="timepicker">\n    <div class="timepicker-start">\n      <div class="timepicker-hours">\n        <span class="timepicker-next">+</span>\n        <div class="timepicker-input">\n          <input type="number">\n          <div class="timepicker-input-number"></div>\n        </div>\n        <span class="timepicker-previous">-</span>\n      </div>\n      <div class="timepicker-time-divider">:</div>\n      <div class="timepicker-minutes">\n        <span class="timepicker-next">+</span>\n        <div class="timepicker-input">\n          <input type="number">\n          <div class="timepicker-input-number"></div>\n        </div>\n        <span class="timepicker-previous">-</span>\n      </div>\n    </div>\n    ' +
          (e.isRange
            ? '<div class="timepicker-end">\n      <div class="timepicker-hours">\n        <span class="timepicker-next">+</span>\n        <div class="timepicker-input">\n          <input type="number">\n          <div class="timepicker-input-number"></div>\n        </div>\n        <span class="timepicker-previous">-</span>\n      </div>\n      <div class="timepicker-time-divider">:</div>\n      <div class="timepicker-minutes">\n        <span class="timepicker-next">+</span>\n        <div class="timepicker-input">\n          <input type="number">\n          <div class="timepicker-input-number"></div>\n        </div>\n        <span class="timepicker-previous">-</span>\n      </div>\n    </div>'
            : '') +
          '\n  </div>'
        )
      }
    },
    function (e, t, n) {
      'use strict'
      var o = {
        timeFormat: 'HH:mm',
        color: 'primary',
        isRange: !1,
        lang: 'en',
        startTime: void 0,
        endTime: void 0,
        minTime: null,
        maxTime: null,
        minuteSteps: 5,
      }
      t.a = o
    },
    function (e, t, n) {
      'use strict'
      var o = {
        type: void 0,
        color: 'primary',
        isRange: !1,
        allowSameDayRange: !0,
        lang: navigator.language.substring(0, 2) || 'en',
        dateFormat: 'MM/DD/YYYY',
        timeFormat: 'HH:mm',
        displayMode: 'default',
        position: 'auto',
        showHeader: !0,
        headerPosition: 'top',
        showFooter: !0,
        showButtons: !0,
        showTodayButton: !0,
        showClearButton: !0,
        cancelLabel: 'Cancel',
        clearLabel: 'Clear',
        todayLabel: 'Today',
        nowLabel: 'Now',
        validateLabel: 'Validate',
        enableMonthSwitch: !0,
        enableYearSwitch: !0,
        startDate: void 0,
        endDate: void 0,
        minDate: null,
        maxDate: null,
        disabledDates: [],
        disabledWeekDays: void 0,
        weekStart: 0,
        startTime: void 0,
        endTime: void 0,
        minuteSteps: 5,
        labelFrom: '',
        labelTo: '',
        closeOnOverlayClick: !0,
        closeOnSelect: !0,
        toggleOnInputClick: !0,
        onReady: null,
        icons: {
          previous:
            '<svg viewBox="0 0 50 80" xml:space="preserve">\n      <polyline fill="none" stroke-width=".5em" stroke-linecap="round" stroke-linejoin="round" points="45.63,75.8 0.375,38.087 45.63,0.375 "/>\n    </svg>',
          next: '<svg viewBox="0 0 50 80" xml:space="preserve">\n      <polyline fill="none" stroke-width=".5em" stroke-linecap="round" stroke-linejoin="round" points="0.375,0.375 45.63,38.087 0.375,75.8 "/>\n    </svg>',
          time: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve">\n      <g>\n        <path fill="currentcolor" d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"/>\n\t      <path fill="currentcolor" d="M30,6c-0.552,0-1,0.447-1,1v23H14c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1V7C31,6.447,30.552,6,30,6z"/>\n      </g>\n    </svg>',
          date: '<svg version="1.1" x="0px" y="0px" viewBox="0 0 60 60" xml:space="preserve">\n      <g>\n        <path d="M57,4h-7V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3H19V1c0-0.553-0.447-1-1-1h-7c-0.553,0-1,0.447-1,1v3H3C2.447,4,2,4.447,2,5v11v43c0,0.553,0.447,1,1,1h54c0.553,0,1-0.447,1-1V16V5C58,4.447,57.553,4,57,4z M43,2h5v3v3h-5V5V2z M12,2h5v3v3h-5V5V2z M4,6h6v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h22v3c0,0.553,0.447,1,1,1h7c0.553,0,1-0.447,1-1V6h6v9H4V6zM4,58V17h52v41H4z"/>\n        <path d="M38,23h-7h-2h-7h-2h-9v9v2v7v2v9h9h2h7h2h7h2h9v-9v-2v-7v-2v-9h-9H38z M31,25h7v7h-7V25z M38,41h-7v-7h7V41z M22,34h7v7h-7V34z M22,25h7v7h-7V25z M13,25h7v7h-7V25z M13,34h7v7h-7V34z M20,50h-7v-7h7V50z M29,50h-7v-7h7V50z M38,50h-7v-7h7V50z M47,50h-7v-7h7V50z M47,41h-7v-7h7V41z M47,25v7h-7v-7H47z"/>\n      </g>\n    </svg>',
        },
      }
      t.a = o
    },
    function (e, t, n) {
      'use strict'
      t.a = function (e) {
        return (
          "<div id='" +
          e.id +
          '\'>\n    <div class="datetimepicker-dummy is-hidden">\n      <div class="datetimepicker-dummy-wrapper">\n        <input placeholder="' +
          e.labelFrom +
          '" readonly="readonly" class="datetimepicker-dummy-input' +
          (e.isRange ? ' is-datetimepicker-range' : '') +
          '" type="text">\n        ' +
          (e.isRange
            ? '<input placeholder="' +
              e.labelTo +
              '" readonly="readonly" class="datetimepicker-dummy-input" type="text">'
            : '') +
          '\n      </div>\n      <button class="datetimepicker-clear-button">＋</button>\n    </div>\n    <div class="datetimepicker-wrapper' +
          ('dialog' === e.displayMode ? ' modal' : '') +
          '">\n        <div class="modal-background' +
          ('dialog' === e.displayMode ? '' : ' is-hidden') +
          '"></div>\n        <div class="datetimepicker">\n          <div class="datetimepicker-container' +
          ('top' === e.headerPosition ? '' : ' has-header-bottom') +
          '"></div>\n        </div>\n    </div>\n  </div>'
        )
      }
    },
    function (e, t, n) {
      'use strict'
      t.a = function (e) {
        return (
          '<div class="datetimepicker-header' +
          ('time' === e.type ? ' is-hidden' : '') +
          ('date' === e.type ? ' is-date-only' : '') +
          '">\n\t\t<div class="datetimepicker-selection-details">\n\t\t\t<div class="datetimepicker-selection-from' +
          ('' === e.labelFrom ? ' is-hidden' : '') +
          '">' +
          e.labelFrom +
          '</div>\n\t\t\t<div class="datetimepicker-selection-start' +
          (e.isRange ? '' : ' is-centered') +
          '">\n\t\t\t\t<div class="datetimepicker-selection-wrapper">\n\t\t\t\t\t<div class="datetimepicker-selection-day"></div>\n\t\t\t\t\t<div class="datetimepicker-selection-date">\n\t\t\t\t\t\t<div class="datetimepicker-selection-month"></div>\n\t\t\t\t\t\t<div class="datetimepicker-selection-weekday"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t' +
          ('date' !== e.type
            ? '<div class="datetimepicker-selection-time">\n\t\t\t\t\t<div class="datetimepicker-selection-time-icon">\n\t\t\t\t\t\t<figure class="image is-16x16">\n\t\t\t\t\t\t\t' +
              (e.icons ? e.icons.time : '') +
              '\n\t\t\t\t\t\t</figure>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="datetimepicker-selection-hour"></div>\n\t\t\t\t</div>'
            : '') +
          '\n\t\t\t</div>\n\t\t</div>\n\t\t' +
          (e.isRange
            ? '\n\t\t<div class="datetimepicker-selection-details">\n\t\t\t<div class="datetimepicker-selection-to' +
              ('' === e.labelTo ? ' is-hidden' : '') +
              '">' +
              e.labelTo +
              '</div>\n\t\t\t<div class="datetimepicker-selection-end">\n\t\t\t\t<div class="datetimepicker-selection-wrapper">\n\t\t\t\t\t<div class="datetimepicker-selection-day"></div>\n\t\t\t\t\t<div class="datetimepicker-selection-date">\n\t\t\t\t\t\t<div class="datetimepicker-selection-month"></div>\n\t\t\t\t\t\t<div class="datetimepicker-selection-weekday"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t' +
              ('date' !== e.type
                ? '<div class="datetimepicker-selection-time">\n\t\t\t\t\t<div class="datetimepicker-selection-time-icon">\n\t\t\t\t\t\t<figure class="image is-16x16">\n\t\t\t\t\t\t\t' +
                  (e.icons ? e.icons.time : '') +
                  '\n\t\t\t\t\t\t</figure>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="datetimepicker-selection-hour"></div>\n\t\t\t\t</div>'
                : '') +
              '\n\t\t\t</div>\n\t\t</div>'
            : '') +
          '\n\t</div>'
        )
      }
    },
    function (e, t, n) {
      'use strict'
      t.a = function (e) {
        return (
          '<div class="datetimepicker-footer">\n\t\t<button type="button" class="datetimepicker-footer-validate has-text-success button is-small is-text ' +
          ('inline' === e.displayMode ? 'is-hidden' : '') +
          '">' +
          (e.icons.validate ? e.icons.validate : '') +
          e.validateLabel +
          ' </button>\n\t\t<button type="button" class="datetimepicker-footer-today has-text-warning button is-small is-text">' +
          (e.icons.today ? e.icons.today : '') +
          e.todayLabel +
          '</button>\n\t\t<button type="button" class="datetimepicker-footer-clear has-text-danger button is-small is-text">' +
          (e.icons.clear ? e.icons.clear : '') +
          e.clearLabel +
          '</button>\n\t\t<button type="button" class="datetimepicker-footer-cancel button is-small is-text ' +
          ('inline' === e.displayMode ? 'is-hidden' : '') +
          '">' +
          (e.icons.cancel ? e.icons.cancel : '') +
          e.cancelLabel +
          '</button>\n\t</div>'
        )
      }
    },
  ]).default
})
